// This file is auto-generated. Do not edit manually.
export type NoteModuleKeys = 'title' | 'fetchSuccess' | 'fetchError' | 'failedToFetch' | 'welcome' | 'toc' | 'children' | 'failedToFetchChildren' | 'noChildren' | 'pathRequired' | 'createNew' | 'edit' | 'delete' | 'create' | 'fetched' | 'unsavedChanges' | 'saved' | 'deleted' | 'name' | 'content' | 'description' | 'tag' | 'type' | 'path' | 'label' | 'visibility' | 'confirmDelete' | 'pagesOf' | 'failedToDelete' | 'newCollection' | 'createCollection' | 'collectionCreated' | 'failedToCreateCollection' | 'collections' | 'noCollections' | 'emptyCollection' | 'manageCollection' | 'addRootItem' | 'searchNoteByTitleOrPath' | 'searchNotesPlaceholder' | 'searching' | 'typeToSearchNotes' | 'untitled' | 'failedToAddNote' | 'confirmRemoveFromCollection' | 'failedToDeleteItem' | 'noItemsYet' | 'selectCollectionToManage' | 'failedToReorder' | 'dragCollectionItem' | 'failedToLoadCollections' | 'failedToLoadCollection' | 'noTocAvailable' | 'addTagPlaceholder' | 'permissionUsers' | 'addUserPlaceholder' | 'disableShare' | 'enableShare' | 'noteCollections' | 'collectionsDescription' | 'backToNotes' | 'collectionUpdated' | 'failedToSaveCollection' | 'confirmDeleteCollection' | 'collectionDeleted' | 'failedToDeleteCollection' | 'noCollectionsYet' | 'noCollectionsDescription' | 'openInNotes' | 'editCollection' | 'addCurrentNoteToCollection' | 'noSavedContentFound' | 'contentSaved' | 'targetLabel' | 'pinnedNotes' | 'unsavedChangesLabel' | 'showAll' | 'showChangedOnly' | 'noPinnedChangesToSave' | 'failedToSavePinnedNotes' | 'savedPinned' | 'savedPinnedPartial' | 'saveWithCount' | 'failedToSaveContent' | 'notesLabel' | 'pinnedDescription' | 'refresh' | 'pinFiltered' | 'unpinFiltered' | 'reset' | 'unsavedBadge' | 'noNotesMatchedFilter' | 'togglePin' | 'shareLinkLabel' | 'editorToolbarMeta' | 'editorToolbarAccess' | 'editorToolbarDrafts' | 'editorToolbarHistory' | 'editorToolbarInsertImage' | 'editorToolbarSaveDraft' | 'editorFooterBackToTop' | 'editorFooterWordCount' | 'editorFooterPreview' | 'editorFooterPublish' | 'editorMetaDialogTitle' | 'editorAccessDialogTitle' | 'editorDraftsDialogTitle' | 'editorHistoryDialogTitle' | 'editorPreviewDialogTitle' | 'editorDraftsHelp' | 'editorNoDrafts' | 'editorSaveCurrentDraft' | 'editorLoadIntoEditor' | 'editorVersionLabel' | 'editorSelectVersion' | 'editorNoVersions' | 'editorSaveDraftSuccess' | 'editorLoadDraftSuccess' | 'editorDeleteDraftSuccess' | 'editorMetaApply' | 'searchTitle' | 'searchResultsCount' | 'searchNoResults' | 'searchTryDifferent' | 'searchEmptyHint';
export type ContactModuleKeys = 'title' | 'addressBook' | 'subtitleShort' | 'subtitleLong' | 'contact' | 'contactSingular' | 'contactPlural' | 'contactProfileHeading' | 'contactNamePlaceholder' | 'contactIDRequired' | 'contactsLoadFailed' | 'contactDeleted' | 'contactCreated' | 'contactUpdated' | 'confirmDeleteContact' | 'loadingContacts' | 'noContactsYet' | 'noContactsMatchFilters' | 'selectContactToPreview' | 'welcomeToContactsHome' | 'newContact' | 'createContact' | 'editContact' | 'deleteContact' | 'searchPlaceholder' | 'clearSearch' | 'expandList' | 'collapseList' | 'view' | 'listView' | 'cardView' | 'filters' | 'sort' | 'groupBy' | 'groupByName' | 'groupByBirthdayMonth' | 'noBirthday' | 'sortFieldAria' | 'sortPlaceholder' | 'toggleSortOrder' | 'birthday' | 'identityNumber' | 'nationality' | 'cityOfResidence' | 'careerField' | 'degree' | 'personalAndProfessionalInformation' | 'personalAndProfessionalInformationDescription' | 'educationBackground' | 'educationBackgroundDescription' | 'noEducationBackground' | 'institution' | 'fieldOfStudy' | 'educationStartDate' | 'educationEndDate' | 'educationDescriptionPlaceholder' | 'upcomingBirthdaysAria' | 'anyTime' | 'days' | 'daysAway' | 'today' | 'tomorrow' | 'favourite' | 'reset' | 'resetFilters' | 'clearAll' | 'clear' | 'markedFavourite' | 'matchingSearch' | 'withUpcomingBirthdays' | 'addedToFavourites' | 'removedFromFavourites' | 'addToFavourites' | 'removeFromFavourites' | 'pinnedFavourite' | 'totalContactsLabel' | 'favouritesLabel' | 'upcomingBirthdaysLabel' | 'recentlyUpdatedLabel' | 'noUpcomingBirthdays' | 'noFavouritesYet' | 'contactsListAria' | 'favouritesHeader' | 'noContactsTitle' | 'noContactsDescription' | 'noContactsAction' | 'loadFailed' | 'yearsOld' | 'addressesDescription' | 'addressPlaceholder' | 'phonesDescription' | 'emailsDescription' | 'imsDescription' | 'urlsDescription' | 'relationshipsDescription' | 'noteHint' | 'call' | 'compose' | 'open' | 'copy' | 'copiedToClipboard' | 'copyFailed' | 'deleteFailed' | 'createContactHeading' | 'editContactHeading' | 'newContactTitle' | 'editingContactTitle' | 'contactFormSubtitle' | 'statusDraft' | 'statusUpdating' | 'description' | 'notes' | 'addressLine1Placeholder' | 'addressLine2Placeholder' | 'district' | 'city' | 'country' | 'postalCode' | 'addressNotePlaceholder' | 'phonePlaceholder' | 'phoneNotePlaceholder' | 'emailPlaceholder' | 'emailNotePlaceholder' | 'imPlaceholder' | 'imNotePlaceholder' | 'urlPlaceholder' | 'urlNotePlaceholder' | 'relationshipPlaceholder' | 'relationshipNotePlaceholder' | 'storySectionTitle' | 'storySectionSubtitle' | 'userManagement' | 'commaSeparatedHint' | 'linkedContact' | 'noLinkedContact' | 'linkContact' | 'searchUsersPlaceholder' | 'selectUserToPreview' | 'noUsersFound' | 'userProfile' | 'userName' | 'accountSecurity' | 'totpSecretPlaceholder' | 'deleteUser' | 'manageTab' | 'createTab' | 'codes' | 'codesDescription' | 'inviteCode' | 'createCode' | 'createBatch' | 'batchCount' | 'status' | 'codeUsed' | 'codeUnused' | 'copyLink' | 'noCodes' | 'codeRequired' | 'codeCreated' | 'codesCreated' | 'codeDeleted' | 'failedToLoadCodes' | 'failedToCreateCode' | 'failedToDeleteCode' | 'inviteLinkCopied' | 'copyInviteLinkFailed' | 'deleteCodeConfirm' | 'createUser' | 'createUserHelp' | 'nameEmailPasswordRequired' | 'profileUpdated' | 'failedToUpdateProfile' | 'failedToUpdatePassword' | 'failedToUpdateTotp' | 'failedToCreateUser' | 'failedToDeleteUser' | 'userCreated' | 'userDeleted' | 'deleteUserConfirm' | 'refresh' | 'addresses' | 'altName' | 'contactDescription' | 'emails' | 'familyName' | 'firstName' | 'instantMessengers' | 'lastName' | 'nickName' | 'noAddresses' | 'noEmails' | 'noInstantMessengers' | 'noPhones' | 'noRelationships' | 'noUrls' | 'phones' | 'relationships' | 'urls' | 'contactInvitations' | 'superAdminTool' | 'contactInvitationsDescription' | 'createContactInvitation' | 'invitationTokenShownOnce' | 'invitationStartsAt' | 'invitationExpiresAt' | 'createInvitation' | 'invitationHistory' | 'invitationHistoryDescription' | 'noContactInvitations' | 'invitationWindow' | 'actions' | 'createdAt' | 'until' | 'revokeInvitation' | 'invitationActive' | 'invitationScheduled' | 'invitationUsed' | 'invitationRevoked' | 'invitationExpired' | 'contactInvitationLinkCopied' | 'contactInvitationCreated' | 'contactInvitationRevoked' | 'failedToLoadContactInvitations' | 'failedToCreateContactInvitation' | 'failedToRevokeContactInvitation' | 'invalidInvitationWindow' | 'secureContactUpdate' | 'updateContactInformation' | 'publicContactInvitationDescription' | 'contactInvitationUnavailableTitle' | 'contactInvitationUnavailable' | 'failedToSubmitContactInvitation' | 'contactInformationSubmitted' | 'contactInvitationConsumed' | 'submitContactInformation' | 'noInformationProvided' | 'add' | 'remove' | 'type' | 'province' | 'contactLabels' | 'contactLabelsDescription' | 'contactLabelsCount' | 'createContactLabel' | 'createLabel' | 'label' | 'labelName' | 'labelColor' | 'labelCount' | 'displayName' | 'contactLabelNamePlaceholder' | 'contactLabelDescriptionPlaceholder' | 'contactLabelNameRequired' | 'contactLabelCreated' | 'contactLabelUpdated' | 'contactLabelDeleted' | 'failedToLoadContactLabels' | 'failedToCreateContactLabel' | 'failedToUpdateContactLabel' | 'failedToDeleteContactLabel' | 'deleteContactLabelConfirm' | 'assignContactLabelsDescription' | 'noContactLabels' | 'allLabels' | 'untaggedContacts' | 'withContactLabels' | 'groupByLabel' | 'information' | 'anyInformation' | 'informationFilterActive' | 'hasContactMethod' | 'missingContactMethod' | 'hasPhone' | 'hasEmail' | 'hasAddress' | 'hasInstantMessage' | 'hasWebsite' | 'hasBirthday' | 'hasIdentityNumber' | 'hasNationality' | 'hasCityOfResidence' | 'hasCareerField' | 'hasDegree' | 'hasEducationBackground';
export type ActivityModuleKeys = 'clickToAddTitle' | 'clickToAddDescription' | 'activityTiming' | 'subtasks' | 'subtasksProgress' | 'addSubtask' | 'subtaskTiming' | 'addSubtaskPlaceholder' | 'addTime' | 'clearTime' | 'openSubtaskMenu' | 'paste' | 'deleteSubtask' | 'subtaskFilterAll' | 'subtaskFilterOpen' | 'subtaskFilterCompleted' | 'subtaskFilterTimed' | 'subtaskSortDefault' | 'subtaskSortName' | 'subtaskSortTiming' | 'subtaskSortStatus' | 'noSubtasksMatchingFilter' | 'noTime' | 'specificTimingStartRequired' | 'startTimeRequired' | 'startRequiredBeforeEnd' | 'duePrefix' | 'scheduledPrefix' | 'recurring' | 'everyFrequency' | 'frequencyDaily' | 'frequencyWeekly' | 'frequencyMonthly' | 'frequencyYearly' | 'frequencyWeekday' | 'frequencyWeekend' | 'frequencyCustom' | 'failedSaveActivityTiming' | 'failedSaveSubtaskTiming' | 'activityPreview' | 'activityEdit' | 'activityName' | 'activityDescription' | 'activityStatus' | 'noTagsAvailable' | 'tagsSummary' | 'activeTagsSummary' | 'manageActivityTags' | 'areYouSureDeleteTag' | 'allActivities' | 'allActivitiesDescription' | 'todo' | 'ready' | 'inProgress' | 'review' | 'done' | 'blocked' | 'cancelled' | 'activityDDL' | 'due' | 'startTypingToCreate' | 'editThisActivity' | 'deleteThisActivity' | 'deleteActivityConfirm' | 'reporting' | 'refreshReports' | 'noReports' | 'failedLoadReports' | 'loadMoreActivities' | 'display' | 'layout' | 'sort' | 'filter' | 'applyFilters' | 'startTime' | 'endTime' | 'projects' | 'project' | 'addProject' | 'editProject' | 'deleteProject' | 'projectName' | 'projectDescription' | 'projectColor' | 'noProjectsAvailable' | 'confirmDeleteProject' | 'createActivity' | 'inbox' | 'today' | 'upcoming' | 'filtersAndLabels' | 'myProjects' | 'taskboard' | 'defaultProject' | 'projectUntitled' | 'openTaskMenu' | 'selectLabels' | 'date' | 'tomorrow' | 'laterThisWeek' | 'thisWeekend' | 'nextWeek' | 'noActivitiesInView' | 'overdue' | 'reschedule' | 'allDay' | 'specificTiming' | 'timingNumber' | 'addTiming' | 'removeTiming' | 'every' | 'until' | 'manageActivityTagsDescription' | 'addTag' | 'editTag' | 'view' | 'sortAndFilter' | 'sortBy' | 'order' | 'updated' | 'ascending' | 'descending' | 'from' | 'clear' | 'resetView' | 'counter' | 'counterNone' | 'daysUntil' | 'daysSince' | 'counterAnchorRequired' | 'chooseDateBeforeCounter' | 'boardSections' | 'boardSectionsMinimum' | 'boardSection' | 'addSection' | 'newSection' | 'defaultSection' | 'completedSection' | 'moveSectionLeft' | 'moveSectionRight' | 'deleteSection' | 'deleteSectionConfirm' | 'deleteSectionConfirmFallback' | 'chooseCounterActivity' | 'counterWidgetDescription' | 'configureCounterWidget' | 'counterAppearance' | 'counterPlain' | 'counterPlainDescription' | 'counterAccent' | 'counterAccentDescription' | 'loadingCounterActivities' | 'failedLoadCounterActivities' | 'noCounterActivities' | 'sectionDescription' | 'editSection' | 'sectionName' | 'dragSection' | 'sectionColor' | 'subtaskCompletedToggle' | 'subtaskHideCompleted' | 'subtaskBatchToggle' | 'subtaskBatchTitle' | 'subtaskBatchTemplateLabel' | 'subtaskBatchTemplatePlaceholder' | 'subtaskBatchTemplateHint' | 'subtaskBatchParse' | 'subtaskBatchVariablesLabel' | 'subtaskBatchVariableLabel' | 'subtaskBatchVariableHint' | 'subtaskBatchVariableValuesPlaceholder' | 'subtaskBatchPreviewLabel' | 'subtaskBatchPreviewCount' | 'subtaskBatchAddCount' | 'subtaskBatchConfirmCount' | 'subtaskBatchNoVariables' | 'subtaskBatchMissingValues' | 'subtaskBatchTooManyCombinations' | 'subtaskBatchEditTemplate' | 'subtaskBatchAdded' | 'createTagNamed' | 'tagNameExists' | 'markIncomplete' | 'sectionActions' | 'projectActions' | 'filtersActive' | 'newProject' | 'boardEmpty' | 'discardChangesConfirm' | 'discard';
export type FileModuleKeys = 'failedToUploadFiles' | 'penguinAlt' | 'untagged' | 'pathRequired' | 'uploadedLivePhoto' | 'noValidLivePhotoPairs' | 'livePhotoUpload' | 'livePhotoDescription' | 'livePhotoPathPlaceholder' | 'uploadAllCount' | 'dropOrChooseFiles' | 'filesSelectedPairs' | 'stillLabel' | 'motionLabel' | 'done' | 'upload' | 'fileDragDropTitle' | 'fileDragDropSubtitle' | 'chooseFiles' | 'fileNamePlaceholder' | 'descriptionOptional' | 'uploadFilesCount' | 'uploadedFilesCount' | 'failedFilesCount' | 'selectedFilesCount' | 'removeSelectedFile' | 'uploadPanelDescription' | 'deleteTagConfirmWithName' | 'fileLibrary' | 'manageTagsDescription' | 'manageTagsHelper' | 'newTag' | 'noTagsYet' | 'noTagsYetDescription' | 'noTagDescription' | 'editTagAria' | 'deleteTagAria' | 'createTag' | 'editTag' | 'files' | 'fileWelcome' | 'fileDescription' | 'fileList' | 'fileListDescription' | 'fileTag' | 'fileTagDescription' | 'clipboardReadFilesCount' | 'clipboardNoSupportedFiles' | 'readFromPasteboard' | 'fileBatchUpload' | 'searchFiles' | 'fileTypeUnknown' | 'tagNamePlaceholder' | 'clipboardReadFile' | 'clipboardNoSupportedFile' | 'editFile' | 'pasteFromClipboard' | 'newContentSelected' | 'deleteFileConfirm' | 'deleteFile' | 'updateFile' | 'areYouSureDeleteTag' | 'fileTagsLoadFailed' | 'incorrectFormData' | 'reviewAndUpload' | 'pathPlaceholder' | 'globalSettings' | 'fileUploadFailed' | 'fileUploadSuccess' | 'manageTags' | 'missingFilePathOrName' | 'missingUploadInfo' | 'pleaseSelectCorrectFileType' | 'pleaseSelectFileFirst' | 'resourceDeletedYouShouldSubmitCurrentChanges' | 'uploading';
export type MomentModuleKeys = 'create' | 'edit' | 'delete' | 'detail' | 'content' | 'saved' | 'loadFailed' | 'saveFailed' | 'countLoadFailed' | 'listLoadFailed' | 'usersLoadFailed' | 'placeholder' | 'idRequired' | 'confirmDelete' | 'deleted' | 'editThis' | 'visibility' | 'permissionUsers' | 'permissionUsersDescription' | 'addUserPlaceholder' | 'insertImage' | 'imagePickerTitle' | 'imagePickerDescription' | 'uploadImage' | 'selectImage' | 'noImagesFound' | 'createMoment' | 'momentDetail' | 'momentIDRequired' | 'failedToDelete';
export type CookingModuleKeys = 'cooking' | 'cuisineType' | 'invalidCuisineType' | 'recipeList' | 'all' | 'submit' | 'query' | 'missingRecipeID' | 'recipeDifficulty' | 'recipeTime' | 'recipeServings' | 'recipeDeliciousness' | 'recipeRatings' | 'steps' | 'tips' | 'ingredients' | 'ingredient' | 'ingredientName' | 'ingredientDescription' | 'ingredientPricing' | 'ingredientTips' | 'ingredientAmount' | 'ingredientUnit' | 'tools' | 'tool' | 'toolName' | 'toolDescription' | 'toolPricing' | 'toolTips' | 'toolAmount' | 'toolUnit' | 'toolQualifierNone' | 'toolQualifierPreheated' | 'toolQualifierChilled' | 'toolQualifierGreased' | 'toolQualifierLined' | 'toolQualifierCovered' | 'editRecipe' | 'createRecipe' | 'deleteRecipe' | 'confirmDeleteRecipe' | 'recipeDetail' | 'recipeName' | 'recipeDescription' | 'recipeSteps' | 'recipeTips' | 'estimatedTime' | 'selectRecipeToPreview' | 'recipeNotFound' | 'recipeSaved' | 'recipeDeleted' | 'saveRecipe' | 'saveIngredients' | 'saveTools' | 'editIngredients' | 'editTools' | 'editIngredientsAssociated' | 'editToolsAssociated' | 'deleteThisRecipe' | 'editThisRecipe' | 'ingredientsManagement' | 'toolsManagement' | 'addIngredient' | 'addTool' | 'deleteThisIngredient' | 'deleteThisTool' | 'confirmDeleteIngredient' | 'confirmDeleteTool' | 'ingredientSaved' | 'toolSaved' | 'ingredientDeleted' | 'toolDeleted' | 'amount' | 'unit' | 'action' | 'minutes' | 'noRecipeIDProvided' | 'manageIngredients' | 'manageTools' | 'manageCuisineTypes' | 'cookingWelcome' | 'cookingDescription' | 'rateRecipe' | 'rateIngredient' | 'rateTool' | 'yourRating' | 'rateThisRecipe' | 'rateThisIngredient' | 'rateThisTool' | 'cookingSearchTitle' | 'cookingSearchDescription' | 'noResultsFound' | 'tryDifferentSearch' | 'searchDescription' | 'searchTip' | 'searchFailed' | 'clear' | 'ingredientsDescription' | 'quickAdd' | 'items' | 'rated' | 'noIngredientsMatchFilters' | 'asc' | 'desc' | 'failedToSaveIngredient' | 'failedToDeleteIngredient' | 'toolsDescription' | 'noToolsMatchFilters' | 'failedToSaveTool' | 'failedToDeleteTool' | 'recipeListDescription' | 'noRecipesFound' | 'adjustSearchOrClearFilters' | 'resetFilters' | 'searchRecipesPlaceholder' | 'reset' | 'readyToExploreRecipes' | 'adminDashboard' | 'quickEdit' | 'searchUsersAdjustRatings' | 'searchUsers' | 'unableToLoadPreferences' | 'failedToLoadAdminPreferences' | 'failedToRefreshAdminPreferences' | 'failedToLoadUserPreferences' | 'editorDescription' | 'metadata' | 'recipeMetadata' | 'recipeMetadataDescription' | 'basics' | 'requiredFields' | 'coverImage' | 'coverImageHint' | 'details' | 'timingServingsScoring' | 'method' | 'methodHint' | 'blockText' | 'blockHeading1' | 'blockHeading2' | 'blockQuote' | 'blockBulletList' | 'blockNumberedList' | 'blockImage' | 'blockPlaceholderHeading' | 'blockPlaceholderSubheading' | 'blockPlaceholderQuote' | 'blockPlaceholderListItem' | 'blockPlaceholderMethod' | 'addBlock' | 'addImageUnderListItem' | 'nestUnderPreviousListItem' | 'detachFromListItem' | 'dragBlock' | 'blockMenu' | 'moveBlockUp' | 'moveBlockDown' | 'deleteBlock' | 'ingredientReference' | 'toolReference' | 'closeReferenceMenu' | 'quantity' | 'qualifier' | 'imagePathPlaceholder' | 'altText' | 'caption' | 'references' | 'referenceNone' | 'completeRecipeMetadataBeforeSaving' | 'shoppingListHint' | 'noIngredientsAddedYet' | 'searchIngredients' | 'trackEquipmentHint' | 'noToolsAddedYet' | 'searchTools' | 'selectIngredientToEdit' | 'selectToolToEdit' | 'noResults' | 'pleaseSelectIngredientForRow' | 'pleaseSelectToolForRow' | 'failedToLoadCuisineTypes' | 'failedToLoadIngredients' | 'failedToLoadTools' | 'failedToLoadRecipes' | 'failedToCreateIngredient' | 'failedToCreateTool' | 'adminTitle' | 'adminDescription' | 'adminRecipesDescription' | 'adminCuisineTypesDescription' | 'adminIngredientsDescription' | 'adminToolsDescription' | 'manageTitle' | 'goToTitle' | 'accessDenied' | 'accessDeniedMessage' | 'adminRoleRequired' | 'cookingAdmin' | 'adminArea' | 'cookingDashboard' | 'dashboard' | 'recipes' | 'cuisineTypes' | 'cuisineTypesTags' | 'cuisineTypesDescription' | 'newType' | 'failedToDeleteCuisineType' | 'failedToSaveCuisineType' | 'deleteCuisineType' | 'editCuisineType' | 'newCuisineType' | 'noCuisineTypesFound' | 'ingredientsAdminDescription' | 'editIngredient' | 'deleteIngredient' | 'sortBy' | 'optionalTips' | 'saving' | 'createIngredient' | 'recipeManagement' | 'recipeManagementDescription' | 'newRecipe' | 'allCuisines' | 'deleteRecipeConfirm' | 'recipeDeletedSuccess' | 'failedToDeleteRecipe' | 'viewRecipeAction' | 'editRecipeAction' | 'deleteRecipeAction' | 'noRecipesFoundAdmin' | 'recipeEditAdminDescription' | 'backToList' | 'viewPublicPage' | 'toolsAdminDescription' | 'editTool' | 'deleteTool' | 'createTool' | 'cookingWidget' | 'noCookingRecords' | 'updatePreference' | 'catalogEditAccess' | 'catalogEditAccessDescription' | 'catalogEditor' | 'catalogEditorRequired';
export type AdminModuleKeys = 'adminArea' | 'userManagement' | 'userManagementDescription' | 'accessDenied' | 'accessDeniedAdmin' | 'accessDeniedSuperAdmin' | 'adminRoleRequired' | 'superAdminRoleRequired' | 'totalUsers' | 'admins' | 'otpEnabled' | 'newUsers7d' | 'failedToLoadUsers' | 'preferencesAdminTitle' | 'preferencesAdminDescription' | 'userPreferences' | 'userPreferencesDescription' | 'userPreferencesHint' | 'itemPreferences' | 'itemPreferencesDescription' | 'itemPreferencesHint' | 'searchUsersAndPreferences' | 'searchUsersAndPreferencesDescription' | 'quickActions' | 'browseRecipes' | 'browseRecipesDescription' | 'browseIngredients' | 'browseIngredientsDescription' | 'browseTools' | 'browseToolsDescription' | 'userRole' | 'user' | 'admin' | 'superAdmin' | 'visitor' | 'preferencesManagement';
export type AppModuleKeys = 'name' | 'description' | 'cancel' | 'confirm' | 'confirmTitle' | 'save' | 'delete' | 'edit' | 'search' | 'submit' | 'close' | 'add' | 'remove' | 'update' | 'select' | 'clear' | 'loading' | 'error' | 'retry' | 'done' | 'back' | 'change' | 'view' | 'pick' | 'operations' | 'refresh' | 'id' | 'tags' | 'unknown' | 'any' | 'optional' | 'color' | 'path' | 'content' | 'appName' | 'copyright' | 'goBack' | 'home' | 'notFound' | 'notFoundWelcome' | 'notFoundDescription' | 'previousPage' | 'nextPage' | 'createdAt' | 'updatedAt' | 'pricing' | 'showingEntries' | 'toEntries' | 'ofTotal' | 'totalEntries' | 'errorOccurred' | 'pinned' | 'previewMode' | 'editMode' | 'folder' | 'document' | 'avatar' | 'coverImage' | 'selectCoverImage' | 'uploadNewImage' | 'noImagesFound' | 'clickToUploadFile' | 'reselectFile' | 'uploadFailed' | 'fileSizeLimit' | 'supportedFormats' | 'fileName' | 'size' | 'fileType' | 'bytes' | 'kb' | 'mb' | 'gb' | 'download' | 'reupload' | 'fileDoesNotExist' | 'public' | 'private' | 'protected' | 'shared' | 'visibility' | 'visibilityPublicDescription' | 'visibilityProtectedDescription' | 'visibilityPrivateDescription' | 'visibilitySharedDescription' | 'preferences' | 'preferencesDescription' | 'rate' | 'rating' | 'pleaseSelectRating' | 'preferenceSaved' | 'preferenceDeleted' | 'errorSavingPreference' | 'errorDeletingPreference' | 'confirmDeletePreference' | 'noPreferenceSet' | 'setYourPreference' | 'addRemarks' | 'remarks' | 'homeWelcome' | 'homeDescription' | 'homeNoteDescription' | 'homeCookingDescription' | 'cooking' | 'contacts' | 'files' | 'credentials' | 'activities' | 'moments' | 'recipeList' | 'createRecipe' | 'ingredients' | 'tools' | 'fileList' | 'fileTag' | 'timeActivity' | 'profileSettings' | 'securitySettings' | 'languageSettings' | 'themeColor' | 'followSystemTheme' | 'settings' | 'open' | 'timeline' | 'actions' | 'favourite' | 'failedToLoadUsers' | 'errorHappened' | 'userRole' | 'admin' | 'contact' | 'note' | 'file' | 'moment' | 'remark' | 'collections' | 'activityBoard' | 'calendar' | 'recipes' | 'exploreNotes' | 'exploreCooking' | 'manageFiles' | 'timeAndActivity' | 'userManagement' | 'livePhotoUpload' | 'selectPlaceholder' | 'noEventsToday' | 'noUpcomingBirthdays' | 'date' | 'birthday' | 'configureShortcut' | 'shortcut' | 'reference' | 'shortcuts' | 'macros' | 'key' | 'action' | 'signature' | 'expansion' | 'args' | 'editorReferenceShortcutsEditing' | 'editorReferenceShortcutsDrafts' | 'editorReferenceMathJaxGeneral' | 'editorReferenceMathJaxConcreteMathematics' | 'editorReferenceMathJaxLinearAlgebra' | 'editorReferenceMathJaxCalculus' | 'editorReferenceMathJaxLogic' | 'editorReferenceMathJaxUnitsAndValues' | 'editorReferenceMathJaxOperators' | 'editorReferenceShortcutInsertTab' | 'editorReferenceShortcutBold' | 'editorReferenceShortcutItalic' | 'editorReferenceShortcutMath' | 'editorReferenceShortcutCode' | 'editorReferenceShortcutSaveDraft' | 'editorReferenceShortcutOpenDrafts' | 'configure' | 'holiday' | 'workday' | 'viewAllResults' | 'jumpTo' | 'pressEnterToSearch' | 'noResults' | 'colorSlate' | 'colorBlue' | 'colorIndigo' | 'colorViolet' | 'colorRose' | 'colorRed' | 'colorOrange' | 'colorAmber' | 'colorLime' | 'colorGreen' | 'colorTeal' | 'colorCyan' | 'colorCustom';
export type AuthModuleKeys = 'signIn' | 'signInSubTitle' | 'signInTitle' | 'signInDescription' | 'signInAgreement' | 'signInSuccessful' | 'signInError' | 'signInWith' | 'signInWithPasskey' | 'signInWithMicrosoft' | 'signOut' | 'signOutConfirmation' | 'register' | 'registerSubTitle' | 'registerTitle' | 'registerDescription' | 'registerSuccessful' | 'registerError' | 'registerAgreement' | 'registerCode' | 'password' | 'email' | 'userName' | 'totpCode' | 'notHavingAccount' | 'alreadyRegistered' | 'invalidSession';
export type SettingsModuleKeys = 'profile' | 'updatePassword' | 'updatePasswordTitle' | 'updatePasswordDescription' | 'oldPassword' | 'newPassword' | 'passwordUpdated' | 'passwordRequired' | 'manageTOTP' | 'mfaTOTPTitle' | 'editOTP' | 'totpDescription' | 'totpSecret' | 'totpSaved' | 'totpQRCodeInstructions' | 'totpVerifyInstructions' | 'totpSaveError' | 'otpEnabled' | 'otpDisabled' | 'disableTotp' | 'hideFooter' | 'hideFooterDescription' | 'backgroundImagePath' | 'backgroundImagePathDescription' | 'locale' | 'localeDescription' | 'location' | 'bio' | 'timeZone' | 'socialAccounts' | 'userNotFound' | 'userInfo' | 'userCenter' | 'invalidSession' | 'username' | 'nothingToUpdate' | 'updateSuccess' | 'updateFailed' | 'comingSoon' | 'passkey' | 'passkeyDevices' | 'noPasskeys' | 'passkeyFallbackName' | 'passkeyItem' | 'passkeyLastUsed' | 'passkeyDeviceName' | 'passkeyDeviceNamePlaceholder' | 'passkeyDeviceNameRequired' | 'renamePasskey' | 'passkeyRenamed' | 'passkeyRenameFailed' | 'removePasskey' | 'passkeyRemoveConfirm' | 'passkeyRemoved' | 'passkeyRemoveFailed' | 'registerNewPasskey' | 'registerPasskey' | 'registeringPasskey' | 'passkeyRegistered' | 'passkeyRegisterFailed' | 'mustSignInForPasskey' | 'passwordUpdateFailed' | 'loadProfileFailed' | 'microsoftIntegration' | 'microsoftIntegrationDescription' | 'microsoftConnectedAccount' | 'linkMicrosoft' | 'disconnectMicrosoft' | 'microsoftDisconnected' | 'microsoftAuthFailed' | 'microsoftDisconnectFailed' | 'themeSettings' | 'followSystemThemeDescription' | 'backgroundImage' | 'backgroundImageDescription' | 'theme' | 'socialAccountPlaceholder' | 'cropAvatar' | 'cropHint' | 'cropConfirm';
export type CredentialModuleKeys = 'credentialNotProvided' | 'editThisCredential' | 'createCredential' | 'deleteThisCredential' | 'deleteCredentialConfirm' | 'encryptionKey' | 'decrypt' | 'credentialDecrypted' | 'nameOfCredential' | 'accountOfCredential' | 'descriptionOfCredential' | 'credentialKey' | 'selectCredentialToPreview' | 'credentialsCount' | 'newCredential' | 'searchCredentialsPlaceholder' | 'clearCredentialSearch' | 'sortBy' | 'groupBy' | 'groupByName' | 'groupByAccount' | 'groupByDescription' | 'noCredentialsFound' | 'failedToLoadCredentials' | 'failedToLoadCredential' | 'failedToSaveCredential' | 'key' | 'encryptKey' | 'account' | 'credentialNotFound' | 'failedToDeleteCredential' | 'failedToDecryptCredential' | 'protectedFields' | 'protectedFieldsHelp' | 'addField' | 'defaultFieldTitle' | 'protectedFieldNumber' | 'fieldTitle' | 'fieldTitlePlaceholder' | 'fieldDescription' | 'fieldDescriptionPlaceholder' | 'fieldValue' | 'fieldValuePlaceholder' | 'atLeastOneFieldRequired' | 'encryptionKeyRequired' | 'unlockExistingFields' | 'unlockExistingFieldsHelp' | 'copyValue' | 'fieldType' | 'fieldTypeSecret' | 'fieldTypeTotp' | 'totpSecretPlaceholder' | 'totpRemaining' | 'untitledField';
export type PostModuleKeys = 'postRecord' | 'postRecords' | 'createPostRecord' | 'editPostRecord' | 'deletePostRecord' | 'postRecordDetail' | 'sender' | 'recipient' | 'sentAt' | 'receivedAt' | 'weight' | 'price' | 'attachments' | 'scope' | 'type' | 'deliverMethod' | 'address' | 'line1' | 'line2' | 'district' | 'city' | 'region' | 'country' | 'postalCode' | 'linkedAttachments' | 'pickFile' | 'noAttachments' | 'clear' | 'pick' | 'saveChanges' | 'createRecord' | 'refresh' | 'newRecord' | 'failedToLoadPostRecords' | 'failedToLoadPostRecord' | 'failedToCreatePostRecord' | 'failedToUpdatePostRecord' | 'failedToDeletePostRecord' | 'postRecordSaved' | 'postRecordDeleted' | 'copyLink' | 'share' | 'senderAddress' | 'recipientAddress' | 'itemDescription' | 'weightGrams' | 'priceCny' | 'selectUser' | 'selectFile' | 'noFilesFound' | 'searchUsers' | 'searchFiles' | 'managePostalEntries' | 'mail' | 'participants' | 'timeline' | 'metrics' | 'actions' | 'sent' | 'received' | 'weightDash' | 'priceDash' | 'view' | 'confirmDeletePostRecord' | 'newPostRecord' | 'senderAndRecipientRequired' | 'completeSenderAddress' | 'completeRecipientAddress' | 'unableToSaveRecord' | 'unableToDeleteRecord' | 'failedToLoadUsers' | 'failedToLoadAttachments' | 'pickSender' | 'pickRecipient' | 'mailScope' | 'mailType' | 'regionProvince' | 'noAttachmentsLinked' | 'loadingRecords' | 'noRecordsCapturedYet' | 'mainland' | 'sar' | 'international' | 'mainlandLetter' | 'mainlandRegisteredLetter' | 'mainlandPostcard' | 'mainlandPrintedMatter' | 'mainlandRegisteredPrintedMatter' | 'mainlandOrdinaryParcel' | 'mainlandExpressParcel' | 'mainlandStandardExpress' | 'mainlandSameDaySpecial' | 'mainlandEms' | 'sarLetter' | 'sarRegisteredLetter' | 'sarPostcard' | 'sarPrintedMatter' | 'sarSmallPacket' | 'sarParcel' | 'sarEms' | 'sarDocumentExpress' | 'internationalLetter' | 'internationalRegisteredLetter' | 'internationalPostcard' | 'internationalPrintedMatter' | 'internationalRegisteredPrintedMatter' | 'internationalSmallPacket' | 'internationalParcel' | 'internationalEms' | 'airMail' | 'surfaceMail';
export type RemarkModuleKeys = 'remarks' | 'remarkTableDescription' | 'remarkReload' | 'remarkFetchSuccess' | 'remarkFetchError' | 'remarkSaveSuccess' | 'remarkSaveError' | 'remarkDeleteSuccess' | 'remarkDeleteError';
export type I18NModuleName = 'note' | 'contact' | 'activity' | 'file' | 'moment' | 'cooking' | 'admin' | 'app' | 'auth' | 'settings' | 'credential' | 'post' | 'remark';
export const I18NModuleDict = {
    note: {
        'en-US': {
            title: 'Note',
            fetchSuccess: 'Note Fetched',
            fetchError: 'Failed to load note',
            failedToFetch: 'Failed to fetch note',
            welcome: 'Welcome to my notes!',
            toc: 'Table of Contents',
            children: 'Note Children',
            failedToFetchChildren: 'Failed to fetch children',
            noChildren: 'No children',
            pathRequired: 'Note Path is required',
            createNew: 'Create a New Note',
            edit: 'Edit Note',
            delete: 'Delete Note',
            create: 'Create Note',
            fetched: 'Note fetched!',
            unsavedChanges: 'You have unsaved changes. Do you really want to leave?',
            saved: 'Note Saved!',
            deleted: 'Note Deleted!',
            name: 'Note Name',
            content: 'Note Content',
            description: 'Note Description',
            tag: 'Note Tag',
            type: 'Note Type',
            path: 'Note Path',
            label: 'Note Label',
            visibility: 'Note Visibility',
            confirmDelete: 'Are you sure you want to delete this note?',
            pagesOf: 'Page {0} of {1}',
            failedToDelete: 'Failed to delete note',
            newCollection: 'New collection',
            createCollection: 'Create collection',
            collectionCreated: 'Collection created',
            failedToCreateCollection: 'Failed to create collection',
            collections: 'Collections',
            noCollections: 'No collections',
            emptyCollection: 'Empty collection',
            manageCollection: 'Manage collection',
            addRootItem: 'Add root item',
            searchNoteByTitleOrPath: 'Search note by title or path',
            searchNotesPlaceholder: 'Search notes...',
            searching: 'Searching…',
            typeToSearchNotes: 'Type to search notes',
            untitled: 'Untitled',
            failedToAddNote: 'Failed to add note',
            confirmRemoveFromCollection: 'Remove this item from the collection?',
            failedToDeleteItem: 'Failed to delete item',
            noItemsYet: 'No items yet',
            selectCollectionToManage: 'Select a collection to manage.',
            failedToReorder: 'Failed to reorder',
            dragCollectionItem: 'Drag to reorder or re-parent',
            failedToLoadCollections: 'Failed to load collections',
            failedToLoadCollection: 'Failed to load collection',
            noTocAvailable: 'No TOC available',
            addTagPlaceholder: 'Add a tag',
            permissionUsers: 'Permission Users',
            addUserPlaceholder: 'Add user',
            disableShare: 'Disable Share',
            enableShare: 'Enable Share',
            noteCollections: 'Note Collections',
            collectionsDescription: 'Create, edit, and control visibility of collections.',
            backToNotes: 'Back to notes',
            collectionUpdated: 'Collection updated',
            failedToSaveCollection: 'Failed to save collection',
            confirmDeleteCollection: 'Delete this collection? This will not delete the notes.',
            collectionDeleted: 'Collection deleted',
            failedToDeleteCollection: 'Failed to delete collection',
            noCollectionsYet: 'No collections yet',
            noCollectionsDescription: 'Create a collection to start grouping related notes.',
            openInNotes: 'Open in notes',
            editCollection: 'Edit collection',
            addCurrentNoteToCollection: 'Add current note to this collection',
            noSavedContentFound: 'No saved content found',
            contentSaved: 'Content saved',
            targetLabel: 'Target:',
            pinnedNotes: 'Pinned Notes',
            unsavedChangesLabel: 'Unsaved Changes',
            showAll: 'Show all',
            showChangedOnly: 'Show changed only',
            noPinnedChangesToSave: 'No pinned changes to save',
            failedToSavePinnedNotes: 'Failed to save pinned notes',
            savedPinned: 'Saved {0} pinned updates',
            savedPinnedPartial: 'Saved {0} notes, but {1} failed. Please retry.',
            saveWithCount: 'Save ({0})',
            failedToSaveContent: 'Failed to save content',
            notesLabel: 'Notes',
            pinnedDescription: 'Batch pin and unpin notes, similar to collection management.',
            refresh: 'Refresh',
            pinFiltered: 'Pin filtered',
            unpinFiltered: 'Unpin filtered',
            reset: 'Reset',
            unsavedBadge: 'Unsaved',
            noNotesMatchedFilter: 'No notes matched your current filter.',
            togglePin: 'Toggle pin for',
            shareLinkLabel: 'Link:',
            editorToolbarMeta: 'Meta',
            editorToolbarAccess: 'Access',
            editorToolbarDrafts: 'Drafts',
            editorToolbarHistory: 'History',
            editorToolbarInsertImage: 'Image',
            editorToolbarSaveDraft: 'Save Draft',
            editorFooterBackToTop: 'Back to top',
            editorFooterWordCount: 'Words',
            editorFooterPreview: 'Preview',
            editorFooterPublish: 'Publish',
            editorMetaDialogTitle: 'Edit metadata',
            editorAccessDialogTitle: 'Edit access',
            editorDraftsDialogTitle: 'Drafts',
            editorHistoryDialogTitle: 'History',
            editorPreviewDialogTitle: 'Preview',
            editorDraftsHelp: 'Saved locally in this browser.',
            editorNoDrafts: 'No local drafts yet',
            editorSaveCurrentDraft: 'Save current draft',
            editorLoadIntoEditor: 'Load into editor',
            editorVersionLabel: 'Version {0}',
            editorSelectVersion: 'Select a version',
            editorNoVersions: 'No versions found',
            editorSaveDraftSuccess: 'Draft saved',
            editorLoadDraftSuccess: 'Draft loaded',
            editorDeleteDraftSuccess: 'Draft deleted',
            editorMetaApply: 'Apply',
            searchTitle: 'Search Notes',
            searchResultsCount: '{0} results',
            searchNoResults: 'No notes found',
            searchTryDifferent: 'Try a different search term',
            searchEmptyHint: 'Type to search your notes'
        },
        'zh-CN': {
            title: '笔记',
            fetchSuccess: '加载笔记成功',
            fetchError: '加载笔记失败',
            failedToFetch: '加载笔记失败',
            welcome: '欢迎来看我的笔记！',
            toc: '目录',
            children: '笔记列表',
            failedToFetchChildren: '加载子笔记失败',
            noChildren: '没有子笔记',
            pathRequired: '笔记路径是必需的',
            createNew: '创建新笔记',
            edit: '编辑笔记',
            delete: '删除笔记',
            create: '创建笔记',
            fetched: '笔记已加载！',
            unsavedChanges: '您有未保存的更改。您确定要离开吗？',
            saved: '笔记已保存！',
            deleted: '笔记已删除！',
            name: '笔记名称',
            content: '笔记内容',
            description: '笔记描述',
            tag: '笔记标签',
            type: '笔记类型',
            path: '笔记路径',
            label: '笔记标签',
            visibility: '笔记可见性',
            confirmDelete: '您确定要删除此笔记吗？',
            pagesOf: '第 {0} 页，共 {1} 页',
            failedToDelete: '删除笔记失败',
            newCollection: '新建合集',
            createCollection: '创建合集',
            collectionCreated: '合集已创建',
            failedToCreateCollection: '创建合集失败',
            collections: '合集',
            noCollections: '没有合集',
            emptyCollection: '空合集',
            manageCollection: '管理合集',
            addRootItem: '添加根项目',
            searchNoteByTitleOrPath: '按标题或路径搜索笔记',
            searchNotesPlaceholder: '搜索笔记...',
            searching: '搜索中…',
            typeToSearchNotes: '输入以搜索笔记',
            untitled: '无标题',
            failedToAddNote: '添加笔记失败',
            confirmRemoveFromCollection: '确定要从合集中移除此项目吗？',
            failedToDeleteItem: '删除项目失败',
            noItemsYet: '暂无项目',
            selectCollectionToManage: '选择一个合集进行管理。',
            failedToReorder: '重新排序失败',
            dragCollectionItem: '拖动以重新排序或调整层级',
            failedToLoadCollections: '加载合集列表失败',
            failedToLoadCollection: '加载合集失败',
            noTocAvailable: '没有可用目录',
            addTagPlaceholder: '添加标签',
            permissionUsers: '授权用户',
            addUserPlaceholder: '添加用户',
            disableShare: '停用分享',
            enableShare: '启用分享',
            noteCollections: '笔记合集',
            collectionsDescription: '创建、编辑和控制合集的可见性。',
            backToNotes: '返回笔记',
            collectionUpdated: '合集已更新',
            failedToSaveCollection: '保存合集失败',
            confirmDeleteCollection: '确定要删除此合集吗？删除合集不会删除关联笔记。',
            collectionDeleted: '合集已删除',
            failedToDeleteCollection: '删除合集失败',
            noCollectionsYet: '暂无合集',
            noCollectionsDescription: '创建一个合集来分组相关笔记。',
            openInNotes: '在笔记中打开',
            editCollection: '编辑合集',
            addCurrentNoteToCollection: '将当前笔记添加到此合集',
            noSavedContentFound: '未找到已保存的内容',
            contentSaved: '内容已保存',
            targetLabel: '目标：',
            pinnedNotes: '置顶笔记',
            unsavedChangesLabel: '未保存的更改',
            showAll: '显示全部',
            showChangedOnly: '仅显示更改项',
            noPinnedChangesToSave: '没有置顶更改需要保存',
            failedToSavePinnedNotes: '保存置顶笔记失败',
            savedPinned: '已保存 {0} 个置顶更新',
            savedPinnedPartial: '已保存 {0} 个笔记，但 {1} 个失败。请重试。',
            saveWithCount: '保存 ({0})',
            failedToSaveContent: '保存内容失败',
            notesLabel: '笔记',
            pinnedDescription: '批量固定/取消固定笔记，类似于集合管理。',
            refresh: '刷新',
            pinFiltered: '固定筛选结果',
            unpinFiltered: '取消固定筛选结果',
            reset: '重置',
            unsavedBadge: '未保存',
            noNotesMatchedFilter: '没有笔记匹配当前筛选条件。',
            togglePin: '切换固定：',
            shareLinkLabel: '链接：',
            editorToolbarMeta: '元数据',
            editorToolbarAccess: '权限',
            editorToolbarDrafts: '草稿',
            editorToolbarHistory: '历史',
            editorToolbarInsertImage: '图片',
            editorToolbarSaveDraft: '保存草稿',
            editorFooterBackToTop: '回到顶部',
            editorFooterWordCount: '字数',
            editorFooterPreview: '预览',
            editorFooterPublish: '发布',
            editorMetaDialogTitle: '编辑元数据',
            editorAccessDialogTitle: '编辑权限',
            editorDraftsDialogTitle: '草稿',
            editorHistoryDialogTitle: '历史',
            editorPreviewDialogTitle: '预览',
            editorDraftsHelp: '保存在本浏览器本地。',
            editorNoDrafts: '暂无本地草稿',
            editorSaveCurrentDraft: '保存当前草稿',
            editorLoadIntoEditor: '载入到编辑器',
            editorVersionLabel: '版本 {0}',
            editorSelectVersion: '请选择一个版本',
            editorNoVersions: '未找到版本',
            editorSaveDraftSuccess: '草稿已保存',
            editorLoadDraftSuccess: '草稿已载入',
            editorDeleteDraftSuccess: '草稿已删除',
            editorMetaApply: '应用',
            searchTitle: '搜索笔记',
            searchResultsCount: '{0} 条结果',
            searchNoResults: '未找到笔记',
            searchTryDifferent: '尝试其他搜索词',
            searchEmptyHint: '输入以搜索笔记'
        },
        'zh-TW': {
            title: '筆記',
            fetchSuccess: '載入筆記成功',
            fetchError: '載入筆記失敗',
            failedToFetch: '載入筆記失敗',
            welcome: '歡迎來看我的筆記！',
            toc: '目錄',
            children: '筆記列表',
            failedToFetchChildren: '載入子筆記失敗',
            noChildren: '沒有子筆記',
            pathRequired: '筆記路徑是必需的',
            createNew: '建立新筆記',
            edit: '編輯筆記',
            delete: '刪除筆記',
            create: '建立筆記',
            fetched: '筆記已載入！',
            unsavedChanges: '您有未儲存的變更。您確定要離開嗎？',
            saved: '筆記已儲存！',
            deleted: '筆記已刪除！',
            name: '筆記名稱',
            content: '筆記內容',
            description: '筆記描述',
            tag: '筆記標籤',
            type: '筆記類型',
            path: '筆記路徑',
            label: '筆記標籤',
            visibility: '筆記可見性',
            confirmDelete: '您確定要刪除此筆記嗎？',
            pagesOf: '第 {0} 頁，共 {1} 頁',
            failedToDelete: '刪除筆記失敗',
            newCollection: '新建合集',
            createCollection: '建立合集',
            collectionCreated: '合集已建立',
            failedToCreateCollection: '建立合集失敗',
            collections: '合集',
            noCollections: '沒有合集',
            emptyCollection: '空合集',
            manageCollection: '管理合集',
            addRootItem: '新增根項目',
            searchNoteByTitleOrPath: '按標題或路徑搜尋筆記',
            searchNotesPlaceholder: '搜尋筆記...',
            searching: '搜尋中…',
            typeToSearchNotes: '輸入以搜尋筆記',
            untitled: '無標題',
            failedToAddNote: '新增筆記失敗',
            confirmRemoveFromCollection: '確定要從合集中移除此項目嗎？',
            failedToDeleteItem: '刪除項目失敗',
            noItemsYet: '暫無項目',
            selectCollectionToManage: '選擇一個合集進行管理。',
            failedToReorder: '重新排序失敗',
            dragCollectionItem: '拖曳以重新排序或調整層級',
            failedToLoadCollections: '載入合集列表失敗',
            failedToLoadCollection: '載入合集失敗',
            noTocAvailable: '沒有可用目錄',
            addTagPlaceholder: '新增標籤',
            permissionUsers: '授權使用者',
            addUserPlaceholder: '新增使用者',
            disableShare: '停用分享',
            enableShare: '啟用分享',
            noteCollections: '筆記合集',
            collectionsDescription: '建立、編輯和控制合集的可見性。',
            backToNotes: '返回筆記',
            collectionUpdated: '合集已更新',
            failedToSaveCollection: '儲存合集失敗',
            confirmDeleteCollection: '確定要刪除此合集嗎？刪除合集不會刪除關聯筆記。',
            collectionDeleted: '合集已刪除',
            failedToDeleteCollection: '刪除合集失敗',
            noCollectionsYet: '暫無合集',
            noCollectionsDescription: '建立一個合集來分組相關筆記。',
            openInNotes: '在筆記中開啟',
            editCollection: '編輯合集',
            addCurrentNoteToCollection: '將當前筆記新增到此合集',
            noSavedContentFound: '未找到已儲存的內容',
            contentSaved: '內容已儲存',
            targetLabel: '目標：',
            pinnedNotes: '置頂筆記',
            unsavedChangesLabel: '未儲存的變更',
            showAll: '顯示全部',
            showChangedOnly: '僅顯示變更項',
            noPinnedChangesToSave: '沒有置頂變更需要儲存',
            failedToSavePinnedNotes: '儲存置頂筆記失敗',
            savedPinned: '已儲存 {0} 個置頂更新',
            savedPinnedPartial: '已儲存 {0} 個筆記，但 {1} 個失敗。請重試。',
            saveWithCount: '儲存 ({0})',
            failedToSaveContent: '儲存內容失敗',
            notesLabel: '筆記',
            pinnedDescription: '批次釘選或取消釘選筆記，類似集合管理。',
            refresh: '重新整理',
            pinFiltered: '釘選篩選項',
            unpinFiltered: '取消釘選篩選項',
            reset: '重設',
            unsavedBadge: '未儲存',
            noNotesMatchedFilter: '沒有筆記符合目前的篩選條件。',
            togglePin: '切換釘選：',
            shareLinkLabel: '連結：',
            editorToolbarMeta: '中繼資料',
            editorToolbarAccess: '權限',
            editorToolbarDrafts: '草稿',
            editorToolbarHistory: '歷史',
            editorToolbarInsertImage: '圖片',
            editorToolbarSaveDraft: '儲存草稿',
            editorFooterBackToTop: '回到頂部',
            editorFooterWordCount: '字數',
            editorFooterPreview: '預覽',
            editorFooterPublish: '發佈',
            editorMetaDialogTitle: '編輯中繼資料',
            editorAccessDialogTitle: '編輯權限',
            editorDraftsDialogTitle: '草稿',
            editorHistoryDialogTitle: '歷史',
            editorPreviewDialogTitle: '預覽',
            editorDraftsHelp: '已儲存在此瀏覽器本機。',
            editorNoDrafts: '尚無本機草稿',
            editorSaveCurrentDraft: '儲存目前草稿',
            editorLoadIntoEditor: '載入到編輯器',
            editorVersionLabel: '版本 {0}',
            editorSelectVersion: '請選擇一個版本',
            editorNoVersions: '找不到版本',
            editorSaveDraftSuccess: '草稿已儲存',
            editorLoadDraftSuccess: '草稿已載入',
            editorDeleteDraftSuccess: '草稿已刪除',
            editorMetaApply: '套用',
            searchTitle: '搜尋筆記',
            searchResultsCount: '{0} 筆結果',
            searchNoResults: '找不到筆記',
            searchTryDifferent: '請嘗試其他搜尋字詞',
            searchEmptyHint: '輸入以搜尋筆記'
        },
        'fr': {
            title: 'Note',
            fetchSuccess: 'Note chargée',
            fetchError: 'Échec du chargement de la note',
            failedToFetch: 'Impossible de récupérer la note',
            welcome: 'Bienvenue dans mes notes !',
            toc: 'Table des matières',
            children: 'Notes enfants',
            failedToFetchChildren: 'Échec du chargement des notes enfants',
            noChildren: 'Aucune note enfant',
            pathRequired: 'Le chemin de la note est requis',
            createNew: 'Créer une nouvelle note',
            edit: 'Modifier la note',
            delete: 'Supprimer la note',
            create: 'Créer une note',
            fetched: 'Note récupérée !',
            unsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
            saved: 'Note enregistrée !',
            deleted: 'Note supprimée !',
            name: 'Nom de la note',
            content: 'Contenu de la note',
            description: 'Description de la note',
            tag: 'Étiquette de la note',
            type: 'Type de note',
            path: 'Chemin de la note',
            label: 'Libellé de la note',
            visibility: 'Visibilité de la note',
            confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette note ?',
            pagesOf: 'Page {0} sur {1}',
            failedToDelete: 'Échec de la suppression de la note',
            newCollection: 'Nouvelle collection',
            createCollection: 'Créer une collection',
            collectionCreated: 'Collection créée',
            failedToCreateCollection: 'Échec de la création de la collection',
            collections: 'Collections',
            noCollections: 'Aucune collection',
            emptyCollection: 'Collection vide',
            manageCollection: 'Gérer la collection',
            addRootItem: 'Ajouter un élément racine',
            searchNoteByTitleOrPath: 'Rechercher une note par titre ou chemin',
            searchNotesPlaceholder: 'Rechercher des notes...',
            searching: 'Recherche en cours…',
            typeToSearchNotes: 'Tapez pour rechercher des notes',
            untitled: 'Sans titre',
            failedToAddNote: 'Échec de l\'ajout de la note',
            confirmRemoveFromCollection: 'Retirer cet élément de la collection ?',
            failedToDeleteItem: 'Échec de la suppression de l\'élément',
            noItemsYet: 'Aucun élément pour le moment',
            selectCollectionToManage: 'Sélectionnez une collection à gérer.',
            failedToReorder: 'Échec de la réorganisation',
            dragCollectionItem: 'Faire glisser pour réorganiser ou changer de parent',
            failedToLoadCollections: 'Échec du chargement des collections',
            failedToLoadCollection: 'Échec du chargement de la collection',
            noTocAvailable: 'Pas de table des matières disponible',
            addTagPlaceholder: 'Ajouter une étiquette',
            permissionUsers: 'Utilisateurs autorisés',
            addUserPlaceholder: 'Ajouter un utilisateur',
            disableShare: 'Désactiver le partage',
            enableShare: 'Activer le partage',
            noteCollections: 'Collections de notes',
            collectionsDescription: 'Créer, modifier et contrôler la visibilité des collections.',
            backToNotes: 'Retour aux notes',
            collectionUpdated: 'Collection mise à jour',
            failedToSaveCollection: 'Échec de l\'enregistrement de la collection',
            confirmDeleteCollection: 'Supprimer cette collection ? Les notes ne seront pas supprimées.',
            collectionDeleted: 'Collection supprimée',
            failedToDeleteCollection: 'Échec de la suppression de la collection',
            noCollectionsYet: 'Aucune collection pour le moment',
            noCollectionsDescription: 'Créez une collection pour commencer à regrouper des notes.',
            openInNotes: 'Ouvrir dans les notes',
            editCollection: 'Modifier la collection',
            addCurrentNoteToCollection: 'Ajouter la note actuelle à cette collection',
            noSavedContentFound: 'Aucun contenu sauvegardé trouvé',
            contentSaved: 'Contenu sauvegardé',
            targetLabel: 'Cible :',
            pinnedNotes: 'Notes épinglées',
            unsavedChangesLabel: 'Modifications non enregistrées',
            showAll: 'Afficher tout',
            showChangedOnly: 'Afficher uniquement les modifications',
            noPinnedChangesToSave: 'Aucune modification épinglée à enregistrer',
            failedToSavePinnedNotes: 'Échec de l\'enregistrement des notes épinglées',
            failedToSaveContent: 'Échec de l\'enregistrement du contenu',
            notesLabel: 'Notes',
            pinnedDescription: 'Épingler et désépingler des notes par lot, similaire à la gestion des collections.',
            refresh: 'Actualiser',
            pinFiltered: 'Épingler le filtré',
            unpinFiltered: 'Désépingler le filtré',
            reset: 'Réinitialiser',
            unsavedBadge: 'Non enregistré',
            noNotesMatchedFilter: 'Aucune note ne correspond à votre filtre.',
            togglePin: 'Basculer l\'épinglage pour',
            savedPinned: 'Enregistré {0} mises à jour d\'épingles',
            savedPinnedPartial: 'Enregistré {0} notes, mais {1} ont échoué. Veuillez réessayer.',
            saveWithCount: 'Enregistrer ({0})',
            shareLinkLabel: 'Lien :',
            editorToolbarMeta: 'Meta',
            editorToolbarAccess: 'Accès',
            editorToolbarDrafts: 'Brouillons',
            editorToolbarHistory: 'Historique',
            editorToolbarInsertImage: 'Image',
            editorToolbarSaveDraft: 'Enregistrer le brouillon',
            editorFooterBackToTop: 'Retour en haut',
            editorFooterWordCount: 'Mots',
            editorFooterPreview: 'Aperçu',
            editorFooterPublish: 'Publier',
            editorMetaDialogTitle: 'Modifier les métadonnées',
            editorAccessDialogTitle: 'Modifier l\'accès',
            editorDraftsDialogTitle: 'Brouillons',
            editorHistoryDialogTitle: 'Historique',
            editorPreviewDialogTitle: 'Aperçu',
            editorDraftsHelp: 'Enregistré localement dans ce navigateur.',
            editorNoDrafts: 'Aucun brouillon local pour le moment',
            editorSaveCurrentDraft: 'Enregistrer le brouillon actuel',
            editorLoadIntoEditor: 'Charger dans l\'éditeur',
            editorVersionLabel: 'Version {0}',
            editorSelectVersion: 'Sélectionnez une version',
            editorNoVersions: 'Aucune version trouvée',
            editorSaveDraftSuccess: 'Brouillon enregistré',
            editorLoadDraftSuccess: 'Brouillon chargé',
            editorDeleteDraftSuccess: 'Brouillon supprimé',
            editorMetaApply: 'Appliquer',
            searchTitle: 'Rechercher des notes',
            searchResultsCount: '{0} résultats',
            searchNoResults: 'Aucune note trouvée',
            searchTryDifferent: 'Essayez un autre terme',
            searchEmptyHint: 'Saisissez pour rechercher vos notes'
        },
        'ja': {
            title: 'ノート',
            fetchSuccess: 'ノートを読み込みました',
            fetchError: 'ノートの読み込みに失敗しました',
            failedToFetch: 'ノートの取得に失敗しました',
            welcome: '私のノートへようこそ！',
            toc: '目次',
            children: '子ノート',
            failedToFetchChildren: '子ノートの読み込みに失敗しました',
            noChildren: '子ノートはありません',
            pathRequired: 'ノートのパスは必須です',
            createNew: '新しいノートを作成',
            edit: 'ノートを編集',
            delete: 'ノートを削除',
            create: 'ノートを作成',
            fetched: 'ノートを取得しました！',
            unsavedChanges: '未保存の変更があります。本当に離れますか？',
            saved: 'ノートを保存しました！',
            deleted: 'ノートを削除しました！',
            name: 'ノート名',
            content: 'ノート内容',
            description: 'ノートの説明',
            tag: 'ノートタグ',
            type: 'ノートタイプ',
            path: 'ノートパス',
            label: 'ノートラベル',
            visibility: 'ノートの公開設定',
            confirmDelete: 'このノートを削除してもよろしいですか？',
            pagesOf: '{1}ページ中{0}ページ',
            failedToDelete: 'ノートの削除に失敗しました',
            newCollection: '新しいコレクション',
            createCollection: 'コレクションを作成',
            collectionCreated: 'コレクションを作成しました',
            failedToCreateCollection: 'コレクションの作成に失敗しました',
            collections: 'コレクション',
            noCollections: 'コレクションがありません',
            emptyCollection: '空のコレクション',
            manageCollection: 'コレクションを管理',
            addRootItem: 'ルート項目を追加',
            searchNoteByTitleOrPath: 'タイトルまたはパスでノートを検索',
            searchNotesPlaceholder: 'ノートを検索...',
            searching: '検索中…',
            typeToSearchNotes: '入力してノートを検索',
            untitled: '無題',
            failedToAddNote: 'ノートの追加に失敗しました',
            confirmRemoveFromCollection: 'このアイテムをコレクションから削除しますか？',
            failedToDeleteItem: 'アイテムの削除に失敗しました',
            noItemsYet: 'まだアイテムがありません',
            selectCollectionToManage: '管理するコレクションを選択してください。',
            failedToReorder: '並べ替えに失敗しました',
            dragCollectionItem: 'ドラッグして並べ替えまたは階層を変更',
            failedToLoadCollections: 'コレクション一覧の読み込みに失敗しました',
            failedToLoadCollection: 'コレクションの読み込みに失敗しました',
            noTocAvailable: '目次がありません',
            addTagPlaceholder: 'タグを追加',
            permissionUsers: '権限ユーザー',
            addUserPlaceholder: 'ユーザーを追加',
            disableShare: '共有を無効化',
            enableShare: '共有を有効化',
            noteCollections: 'ノートコレクション',
            collectionsDescription: 'コレクションの作成、編集、公開設定を管理します。',
            backToNotes: 'ノートに戻る',
            collectionUpdated: 'コレクションを更新しました',
            failedToSaveCollection: 'コレクションの保存に失敗しました',
            confirmDeleteCollection: 'このコレクションを削除しますか？ノートは削除されません。',
            collectionDeleted: 'コレクションを削除しました',
            failedToDeleteCollection: 'コレクションの削除に失敗しました',
            noCollectionsYet: 'まだコレクションがありません',
            noCollectionsDescription: 'コレクションを作成して関連ノートをグループ化しましょう。',
            openInNotes: 'ノートで開く',
            editCollection: 'コレクションを編集',
            addCurrentNoteToCollection: '現在のノートをこのコレクションに追加',
            noSavedContentFound: '保存されたコンテンツが見つかりません',
            contentSaved: 'コンテンツを保存しました',
            targetLabel: 'ターゲット：',
            pinnedNotes: 'ピン留めされたノート',
            unsavedChangesLabel: '未保存の変更',
            showAll: 'すべて表示',
            showChangedOnly: '変更のみ表示',
            noPinnedChangesToSave: '保存するピン留めされた変更はありません',
            failedToSavePinnedNotes: 'ピン留めしたノートの保存に失敗しました',
            failedToSaveContent: 'コンテンツの保存に失敗しました',
            notesLabel: 'ノート',
            pinnedDescription: 'ノートを一括でピン/ピン解除します（コレクション管理に類似）。',
            refresh: '更新',
            pinFiltered: 'フィルタをピン',
            unpinFiltered: 'フィルタのピンを解除',
            reset: 'リセット',
            unsavedBadge: '未保存',
            noNotesMatchedFilter: '現在のフィルタに一致するノートはありません。',
            togglePin: 'ピンの切り替え:',
            savedPinned: '{0} 件のピンの更新を保存しました',
            savedPinnedPartial: '{0} 件を保存しましたが、{1} 件が失敗しました。再試行してください。',
            saveWithCount: '保存 ({0})',
            shareLinkLabel: 'リンク：',
            editorToolbarMeta: 'メタ',
            editorToolbarAccess: 'アクセス',
            editorToolbarDrafts: '下書き',
            editorToolbarHistory: '履歴',
            editorToolbarInsertImage: '画像',
            editorToolbarSaveDraft: '下書きを保存',
            editorFooterBackToTop: '先頭へ戻る',
            editorFooterWordCount: '文字数',
            editorFooterPreview: 'プレビュー',
            editorFooterPublish: '公開',
            editorMetaDialogTitle: 'メタデータを編集',
            editorAccessDialogTitle: 'アクセスを編集',
            editorDraftsDialogTitle: '下書き',
            editorHistoryDialogTitle: '履歴',
            editorPreviewDialogTitle: 'プレビュー',
            editorDraftsHelp: 'このブラウザにローカル保存されています。',
            editorNoDrafts: 'ローカル下書きはまだありません',
            editorSaveCurrentDraft: '現在の下書きを保存',
            editorLoadIntoEditor: 'エディタに読み込む',
            editorVersionLabel: 'バージョン {0}',
            editorSelectVersion: 'バージョンを選択してください',
            editorNoVersions: 'バージョンが見つかりません',
            editorSaveDraftSuccess: '下書きを保存しました',
            editorLoadDraftSuccess: '下書きを読み込みました',
            editorDeleteDraftSuccess: '下書きを削除しました',
            editorMetaApply: '適用',
            searchTitle: 'ノートを検索',
            searchResultsCount: '{0} 件の結果',
            searchNoResults: 'ノートが見つかりません',
            searchTryDifferent: '別のキーワードをお試しください',
            searchEmptyHint: '入力してノートを検索'
        }
    } as Record<string, Record<NoteModuleKeys, string>>,
    contact: {
        'en-US': {
            title: 'Contacts',
            addressBook: 'Address Book',
            subtitleShort: 'Organise important people with clarity.',
            subtitleLong: 'Organise important people with clarity.',
            contact: 'Contact',
            contactSingular: 'contact',
            contactPlural: 'contacts',
            contactProfileHeading: 'Contact Profile',
            contactNamePlaceholder: 'Unnamed Contact',
            contactIDRequired: 'A contact ID is required.',
            contactsLoadFailed: 'Failed to load contacts. Please try again.',
            contactDeleted: 'Contact deleted.',
            contactCreated: 'Contact created.',
            contactUpdated: 'Contact updated.',
            confirmDeleteContact: 'Are you sure you want to delete this contact? This action cannot be undone.',
            loadingContacts: 'Loading contacts…',
            noContactsYet: 'No contacts yet. Create your first one!',
            noContactsMatchFilters: 'No contacts match the current filters.',
            selectContactToPreview: 'Select a contact from the list to preview.',
            welcomeToContactsHome: 'Contacts',
            newContact: 'New',
            createContact: 'Create Contact',
            editContact: 'Edit',
            deleteContact: 'Delete',
            searchPlaceholder: 'Search contacts…',
            clearSearch: 'Clear search',
            expandList: 'Expand list',
            collapseList: 'Collapse list',
            view: 'View',
            listView: 'List',
            cardView: 'Cards',
            filters: 'Filters',
            sort: 'Sort',
            groupBy: 'Group by',
            groupByName: 'Name',
            groupByBirthdayMonth: 'Birthday month',
            noBirthday: 'No birthday',
            sortFieldAria: 'Sort field',
            sortPlaceholder: 'Best match',
            toggleSortOrder: 'Toggle sort order',
            birthday: 'Birthday',
            identityNumber: 'Identity / document number',
            nationality: 'Nationality',
            cityOfResidence: 'City of residence',
            careerField: 'Career field',
            degree: 'Degree',
            personalAndProfessionalInformation: 'Personal and professional information',
            personalAndProfessionalInformationDescription: 'Identity, residence, nationality, and career details exposed by this invitation.',
            educationBackground: 'Education background',
            educationBackgroundDescription: 'Schools, qualifications, fields of study, and attendance dates.',
            noEducationBackground: 'No education background provided.',
            institution: 'Institution',
            fieldOfStudy: 'Field of study',
            educationStartDate: 'Start date',
            educationEndDate: 'End date',
            educationDescriptionPlaceholder: 'Honours, activities, or other context',
            upcomingBirthdaysAria: 'Filter by upcoming birthdays',
            anyTime: 'Any time',
            days: 'days',
            daysAway: 'days away',
            today: 'Today!',
            tomorrow: 'Tomorrow',
            favourite: 'Favourite',
            reset: 'Reset',
            resetFilters: 'Reset Filters',
            clearAll: 'Clear all',
            clear: 'Clear',
            markedFavourite: 'marked as favourite',
            matchingSearch: 'matching "{0}"',
            withUpcomingBirthdays: 'with birthday within {0} days',
            addedToFavourites: 'Added {0} to favourites',
            removedFromFavourites: 'Removed {0} from favourites',
            addToFavourites: 'Add to favourites',
            removeFromFavourites: 'Remove from favourites',
            pinnedFavourite: 'Pinned favourite',
            totalContactsLabel: 'Total',
            favouritesLabel: 'Favourites',
            upcomingBirthdaysLabel: 'Upcoming Birthdays',
            recentlyUpdatedLabel: 'Recently Updated',
            noUpcomingBirthdays: 'No upcoming birthdays in the next 30 days.',
            noFavouritesYet: 'No favourites yet. Star a contact to pin it here.',
            contactsListAria: 'Contacts list',
            favouritesHeader: 'Favourites',
            noContactsTitle: 'No contacts',
            noContactsDescription: 'Create your first contact to get started.',
            noContactsAction: 'Create Contact',
            loadFailed: 'Failed to load contacts.',
            yearsOld: 'years old',
            addressesDescription: 'Postal and physical addresses',
            addressPlaceholder: 'No address specified',
            phonesDescription: 'Phone numbers',
            emailsDescription: 'Email addresses',
            imsDescription: 'Instant messaging accounts',
            urlsDescription: 'Web links and URLs',
            relationshipsDescription: 'Related people',
            noteHint: 'Personal notes and comments',
            call: 'Call',
            compose: 'Compose',
            open: 'Open',
            copy: 'Copy',
            copiedToClipboard: 'Copied to clipboard!',
            copyFailed: 'Failed to copy to clipboard',
            deleteFailed: 'Failed to delete contact.',
            createContactHeading: 'Create contact',
            editContactHeading: 'Edit contact',
            newContactTitle: 'New contact',
            editingContactTitle: 'Update contact',
            contactFormSubtitle: 'Keep the essentials tidy so you can reach out in seconds.',
            statusDraft: 'Draft',
            statusUpdating: 'Updating existing record',
            description: 'Description',
            notes: 'Notes',
            addressLine1Placeholder: 'Street and number',
            addressLine2Placeholder: 'Apartment, building, suite',
            district: 'District',
            city: 'City',
            country: 'Country',
            postalCode: 'Postal code',
            addressNotePlaceholder: 'Notes (e.g. front desk)',
            phonePlaceholder: 'Phone number',
            phoneNotePlaceholder: 'When to call or who answers',
            emailPlaceholder: 'name@example.com',
            emailNotePlaceholder: 'How this email is used',
            imPlaceholder: 'Handle or username',
            imNotePlaceholder: 'Channel context or schedule',
            urlPlaceholder: 'https://example.com',
            urlNotePlaceholder: 'What this link points to',
            relationshipPlaceholder: 'Related contact ID or name',
            relationshipNotePlaceholder: 'How they\'re connected',
            storySectionTitle: 'Notes & highlights',
            storySectionSubtitle: 'Share context, favourite memories, or upcoming plans.',
            userManagement: 'Users',
            commaSeparatedHint: 'One per line or comma-separated.',
            linkedContact: 'Linked Contact',
            noLinkedContact: 'No linked contact',
            linkContact: 'Link Contact',
            searchUsersPlaceholder: 'Search users…',
            selectUserToPreview: 'Select a user to view details.',
            noUsersFound: 'No users found.',
            userProfile: 'Profile',
            userName: 'Username',
            accountSecurity: 'Security',
            totpSecretPlaceholder: 'Enter TOTP secret',
            deleteUser: 'Delete User',
            manageTab: 'Manage',
            createTab: 'Create',
            codes: 'Codes',
            codesDescription: 'Create and manage registration invite codes.',
            inviteCode: 'Invite Code',
            createCode: 'Create Code',
            createBatch: 'Create Batch',
            batchCount: 'Batch Count',
            status: 'Status',
            codeUsed: 'Used',
            codeUnused: 'Unused',
            copyLink: 'Copy Link',
            noCodes: 'No invite codes.',
            codeRequired: 'Enter an invite code.',
            codeCreated: 'Invite code created.',
            codesCreated: '{0} invite codes created.',
            codeDeleted: 'Invite code deleted.',
            failedToLoadCodes: 'Failed to load invite codes.',
            failedToCreateCode: 'Failed to create invite code.',
            failedToDeleteCode: 'Failed to delete invite code.',
            inviteLinkCopied: 'Invite link copied.',
            copyInviteLinkFailed: 'Failed to copy invite link.',
            deleteCodeConfirm: 'Delete invite code "{0}"?',
            createUser: 'Create User',
            createUserHelp: 'Fill in the form to create a new user account.',
            nameEmailPasswordRequired: 'Name, email, and password are required.',
            profileUpdated: 'Profile updated.',
            failedToUpdateProfile: 'Failed to update profile.',
            failedToUpdatePassword: 'Failed to update password.',
            failedToUpdateTotp: 'Failed to update TOTP.',
            failedToCreateUser: 'Failed to create user.',
            failedToDeleteUser: 'Failed to delete user.',
            userCreated: 'User created.',
            userDeleted: 'User deleted.',
            deleteUserConfirm: 'Are you sure you want to delete user "{0}"? This action cannot be undone.',
            refresh: 'Refresh',
            addresses: 'Addresses',
            altName: 'Alt Name',
            contactDescription: 'Here you can manage your contact information!',
            emails: 'Emails',
            familyName: 'Family Name',
            firstName: 'First Name',
            instantMessengers: 'Instant Messengers',
            lastName: 'Last Name',
            nickName: 'Nickname',
            noAddresses: 'No addresses',
            noEmails: 'No emails',
            noInstantMessengers: 'No instant messengers',
            noPhones: 'No phones',
            noRelationships: 'No relationships',
            noUrls: 'No urls',
            phones: 'Phones',
            relationships: 'Relationships',
            urls: 'URLs',
            contactInvitations: 'Contact invitations',
            superAdminTool: 'Super admin tool',
            contactInvitationsDescription: 'Create one-use links that let a recipient update only selected contact channels during a controlled time window, without signing in.',
            createContactInvitation: 'Create contact invitation',
            invitationTokenShownOnce: 'The secure link is returned only when it is created. Copy it before leaving or refreshing this page.',
            invitationStartsAt: 'Available from',
            invitationExpiresAt: 'Expires at',
            createInvitation: 'Create invitation',
            invitationHistory: 'Invitation history',
            invitationHistoryDescription: 'Review use, expiry, and revocation state for every contact invitation.',
            noContactInvitations: 'No contact invitations have been created.',
            invitationWindow: 'Access window',
            actions: 'Actions',
            createdAt: 'Created',
            until: 'until',
            revokeInvitation: 'Revoke',
            invitationActive: 'Active',
            invitationScheduled: 'Scheduled',
            invitationUsed: 'Used',
            invitationRevoked: 'Revoked',
            invitationExpired: 'Expired',
            contactInvitationLinkCopied: 'Contact invitation link copied.',
            contactInvitationCreated: 'Contact invitation created.',
            contactInvitationRevoked: 'Contact invitation revoked.',
            failedToLoadContactInvitations: 'Failed to load contact invitations.',
            failedToCreateContactInvitation: 'Failed to create contact invitation.',
            failedToRevokeContactInvitation: 'Failed to revoke contact invitation.',
            invalidInvitationWindow: 'Select a contact and an expiry time after the start time.',
            secureContactUpdate: 'Secure contact update',
            updateContactInformation: 'Update contact information',
            publicContactInvitationDescription: 'You can view and update only the contact fields shown below. This link accepts one successful submission and does not require an account.',
            contactInvitationUnavailableTitle: 'Invitation unavailable',
            contactInvitationUnavailable: 'This link is invalid, outside its allowed time window, already used, or revoked.',
            failedToSubmitContactInvitation: 'Failed to save contact information.',
            contactInformationSubmitted: 'Contact information submitted',
            contactInvitationConsumed: 'Your changes were saved. This one-use link is now closed.',
            submitContactInformation: 'Submit information',
            noInformationProvided: 'No information provided.',
            add: 'Add',
            remove: 'Remove',
            type: 'Type',
            province: 'Province / region',
            contactLabels: 'Labels',
            contactLabelsDescription: 'Create and maintain reusable labels for organizing contacts.',
            contactLabelsCount: '{0} labels',
            createContactLabel: 'Create label',
            createLabel: 'Create label',
            label: 'Label',
            labelName: 'Name',
            labelColor: 'Color',
            labelCount: 'Label count',
            displayName: 'Display name',
            contactLabelNamePlaceholder: 'Family, university, supplier…',
            contactLabelDescriptionPlaceholder: 'Optional context for this label',
            contactLabelNameRequired: 'Enter a label name.',
            contactLabelCreated: 'Contact label created.',
            contactLabelUpdated: 'Contact label updated.',
            contactLabelDeleted: 'Contact label deleted.',
            failedToLoadContactLabels: 'Failed to load contact labels.',
            failedToCreateContactLabel: 'Failed to create contact label.',
            failedToUpdateContactLabel: 'Failed to update contact label.',
            failedToDeleteContactLabel: 'Failed to delete contact label.',
            deleteContactLabelConfirm: 'Delete label "{0}"? It will be removed from every contact.',
            assignContactLabelsDescription: 'Use labels to organize and filter this contact.',
            noContactLabels: 'No labels',
            allLabels: 'All labels',
            untaggedContacts: 'Without labels',
            withContactLabels: 'with {0} selected labels',
            groupByLabel: 'Label',
            information: 'Information',
            anyInformation: 'Any information',
            informationFilterActive: 'with an information filter',
            hasContactMethod: 'Has a contact method',
            missingContactMethod: 'Missing contact methods',
            hasPhone: 'Has phone',
            hasEmail: 'Has email',
            hasAddress: 'Has address',
            hasInstantMessage: 'Has instant message',
            hasWebsite: 'Has website',
            hasBirthday: 'Has birthday',
            hasIdentityNumber: 'Has identity number',
            hasNationality: 'Has nationality',
            hasCityOfResidence: 'Has city of residence',
            hasCareerField: 'Has career field',
            hasDegree: 'Has degree',
            hasEducationBackground: 'Has education background'
        },
        'zh-CN': {
            title: '联系人',
            addressBook: '通讯录',
            subtitleShort: '清晰地管理重要联系人。',
            subtitleLong: '清晰地管理重要联系人。',
            contact: '联系人',
            contactSingular: '位联系人',
            contactPlural: '位联系人',
            contactProfileHeading: '联系人资料',
            contactNamePlaceholder: '未命名联系人',
            contactIDRequired: '需要联系人 ID。',
            contactsLoadFailed: '加载联系人失败，请重试。',
            contactDeleted: '联系人已删除。',
            contactCreated: '联系人已创建。',
            contactUpdated: '联系人已更新。',
            confirmDeleteContact: '确定要删除此联系人吗？此操作不可撤销。',
            loadingContacts: '正在加载联系人…',
            noContactsYet: '暂无联系人，创建第一个吧！',
            noContactsMatchFilters: '没有联系人匹配当前筛选条件。',
            selectContactToPreview: '从列表中选择一位联系人来预览。',
            welcomeToContactsHome: '联系人',
            newContact: '新建',
            createContact: '创建联系人',
            editContact: '编辑',
            deleteContact: '删除',
            searchPlaceholder: '搜索联系人…',
            clearSearch: '清除搜索',
            expandList: '展开列表',
            collapseList: '收起列表',
            view: '查看',
            listView: '列表',
            cardView: '卡片',
            filters: '筛选',
            sort: '排序',
            groupBy: '分组',
            groupByName: '名称',
            groupByBirthdayMonth: '生日月份',
            noBirthday: '无生日',
            sortFieldAria: '排序字段',
            sortPlaceholder: '最佳匹配',
            toggleSortOrder: '切换排序方向',
            birthday: '生日',
            identityNumber: '身份证件号码',
            nationality: '国籍',
            cityOfResidence: '居住城市',
            careerField: '职业领域',
            degree: '学位',
            personalAndProfessionalInformation: '个人与职业资料',
            personalAndProfessionalInformationDescription: '此邀请公开的身份、居住地、国籍和职业资料。',
            educationBackground: '教育背景',
            educationBackgroundDescription: '学校、学历、专业及就读日期。',
            noEducationBackground: '暂无教育背景。',
            institution: '学校／机构',
            fieldOfStudy: '专业领域',
            educationStartDate: '开始日期',
            educationEndDate: '结束日期',
            educationDescriptionPlaceholder: '荣誉、活动或其他说明',
            upcomingBirthdaysAria: '按即将到来的生日筛选',
            anyTime: '不限',
            days: '天',
            daysAway: '天后',
            today: '今天！',
            tomorrow: '明天',
            favourite: '特别关注',
            reset: '重置',
            resetFilters: '重置筛选',
            clearAll: '清除全部',
            clear: '清除',
            markedFavourite: '已标记为特别关注',
            matchingSearch: '匹配「{0}」',
            withUpcomingBirthdays: '生日在 {0} 天内',
            addedToFavourites: '已将 {0} 添加到特别关注',
            removedFromFavourites: '已将 {0} 移出特别关注',
            addToFavourites: '添加到特别关注',
            removeFromFavourites: '移出特别关注',
            pinnedFavourite: '特别关注',
            totalContactsLabel: '总计',
            favouritesLabel: '特别关注',
            upcomingBirthdaysLabel: '即将过生日',
            recentlyUpdatedLabel: '最近更新',
            noUpcomingBirthdays: '未来 30 天内没有即将到来的生日。',
            noFavouritesYet: '暂无特别关注。给联系人加星标即可在此处显示。',
            contactsListAria: '联系人列表',
            favouritesHeader: '特别关注',
            noContactsTitle: '暂无联系人',
            noContactsDescription: '创建第一个联系人即可开始。',
            noContactsAction: '创建联系人',
            loadFailed: '加载联系人失败。',
            yearsOld: '岁',
            addressesDescription: '邮寄和实际地址',
            addressPlaceholder: '未指定地址',
            phonesDescription: '电话号码',
            emailsDescription: '电子邮件地址',
            imsDescription: '即时通讯帐号',
            urlsDescription: '网页链接和 URL',
            relationshipsDescription: '相关人脉',
            noteHint: '个人备注和评论',
            call: '拨打',
            compose: '写信',
            open: '打开',
            copy: '复制',
            copiedToClipboard: '已复制到剪贴板！',
            copyFailed: '复制到剪贴板失败',
            deleteFailed: '删除联系人失败。',
            createContactHeading: '创建联系人',
            editContactHeading: '编辑联系人',
            newContactTitle: '新联系人',
            editingContactTitle: '更新联系人',
            contactFormSubtitle: '整理好关键信息，方便随时联系。',
            statusDraft: '草稿',
            statusUpdating: '正在更新现有记录',
            description: '描述',
            notes: '备注',
            addressLine1Placeholder: '街道和门牌号',
            addressLine2Placeholder: '公寓、楼栋、单元',
            district: '区县',
            city: '城市',
            country: '国家或地区',
            postalCode: '邮政编码',
            addressNotePlaceholder: '备注（如前台）',
            phonePlaceholder: '电话号码',
            phoneNotePlaceholder: '适合拨打的时间或接听人',
            emailPlaceholder: 'name@example.com',
            emailNotePlaceholder: '此邮箱的用途',
            imPlaceholder: '帐号或用户名',
            imNotePlaceholder: '渠道说明或联系时间',
            urlPlaceholder: 'https://example.com',
            urlNotePlaceholder: '此链接指向的内容',
            relationshipPlaceholder: '相关联系人 ID 或姓名',
            relationshipNotePlaceholder: '他们的关系说明',
            storySectionTitle: '备注与重点',
            storySectionSubtitle: '记录背景、重要回忆或后续计划。',
            userManagement: '用户管理',
            commaSeparatedHint: '每行一个或用逗号分隔。',
            linkedContact: '关联联系人',
            noLinkedContact: '无关联联系人',
            linkContact: '关联联系人',
            searchUsersPlaceholder: '搜索用户…',
            selectUserToPreview: '选择一位用户以查看详情。',
            noUsersFound: '未找到用户。',
            userProfile: '个人资料',
            userName: '用户名',
            accountSecurity: '安全设置',
            totpSecretPlaceholder: '输入 TOTP 密钥',
            deleteUser: '删除用户',
            manageTab: '管理',
            createTab: '创建',
            codes: '邀请码',
            codesDescription: '创建和管理注册邀请码。',
            inviteCode: '邀请码',
            createCode: '创建邀请码',
            createBatch: '批量创建',
            batchCount: '批量数量',
            status: '状态',
            codeUsed: '已使用',
            codeUnused: '未使用',
            copyLink: '复制链接',
            noCodes: '暂无邀请码。',
            codeRequired: '请输入邀请码。',
            codeCreated: '邀请码已创建。',
            codesCreated: '已创建 {0} 个邀请码。',
            codeDeleted: '邀请码已删除。',
            failedToLoadCodes: '加载邀请码失败。',
            failedToCreateCode: '创建邀请码失败。',
            failedToDeleteCode: '删除邀请码失败。',
            inviteLinkCopied: '邀请链接已复制。',
            copyInviteLinkFailed: '复制邀请链接失败。',
            deleteCodeConfirm: '删除邀请码「{0}」？',
            createUser: '创建用户',
            createUserHelp: '填写表单以创建新用户帐号。',
            nameEmailPasswordRequired: '姓名、邮箱和密码为必填项。',
            profileUpdated: '资料已更新。',
            failedToUpdateProfile: '更新资料失败。',
            failedToUpdatePassword: '更新密码失败。',
            failedToUpdateTotp: '更新 TOTP 失败。',
            failedToCreateUser: '创建用户失败。',
            failedToDeleteUser: '删除用户失败。',
            userCreated: '用户已创建。',
            userDeleted: '用户已删除。',
            deleteUserConfirm: '确定要删除用户「{0}」吗？此操作不可撤销。',
            refresh: '刷新',
            addresses: '地址',
            altName: '别名',
            contactDescription: '在这里你可以管理你的联系人信息！',
            emails: '邮箱',
            familyName: '家族姓氏',
            firstName: '名',
            instantMessengers: '即时通讯',
            lastName: '姓',
            nickName: '昵称',
            noAddresses: '没有地址',
            noEmails: '没有邮箱',
            noInstantMessengers: '没有即时通讯',
            noPhones: '没有电话',
            noRelationships: '没有关系',
            noUrls: '没有网址',
            phones: '电话',
            relationships: '关系',
            urls: '网址',
            contactInvitations: '联系人资料邀请',
            superAdminTool: '超级管理员工具',
            contactInvitationsDescription: '创建一次性链接，让收件人在指定时间内无需登录，仅更新获准公开的联系资料。',
            createContactInvitation: '创建联系人资料邀请',
            invitationTokenShownOnce: '安全链接只会在创建时返回。请在离开或刷新此页面前复制。',
            invitationStartsAt: '开放时间',
            invitationExpiresAt: '截止时间',
            createInvitation: '创建邀请',
            invitationHistory: '邀请记录',
            invitationHistoryDescription: '查看每个联系人资料邀请的使用、过期及撤销状态。',
            noContactInvitations: '尚未创建联系人资料邀请。',
            invitationWindow: '开放时段',
            actions: '操作',
            createdAt: '创建时间',
            until: '至',
            revokeInvitation: '撤销',
            invitationActive: '有效',
            invitationScheduled: '未开始',
            invitationUsed: '已使用',
            invitationRevoked: '已撤销',
            invitationExpired: '已过期',
            contactInvitationLinkCopied: '联系人资料邀请链接已复制。',
            contactInvitationCreated: '联系人资料邀请已创建。',
            contactInvitationRevoked: '联系人资料邀请已撤销。',
            failedToLoadContactInvitations: '加载联系人资料邀请失败。',
            failedToCreateContactInvitation: '创建联系人资料邀请失败。',
            failedToRevokeContactInvitation: '撤销联系人资料邀请失败。',
            invalidInvitationWindow: '请选择联系人，并确保截止时间晚于开放时间。',
            secureContactUpdate: '安全更新联系资料',
            updateContactInformation: '更新联系资料',
            publicContactInvitationDescription: '你只能查看和更新下方显示的联系资料。此链接仅接受一次成功提交，且无需帐号。',
            contactInvitationUnavailableTitle: '邀请不可用',
            contactInvitationUnavailable: '此链接无效、尚未开放、已经过期、已使用或已撤销。',
            failedToSubmitContactInvitation: '保存联系资料失败。',
            contactInformationSubmitted: '联系资料已提交',
            contactInvitationConsumed: '更改已保存，此一次性链接现已关闭。',
            submitContactInformation: '提交资料',
            noInformationProvided: '暂无资料。',
            add: '添加',
            remove: '移除',
            type: '类型',
            province: '省／地区',
            contactLabels: '标签',
            contactLabelsDescription: '创建和维护可重复使用的联系人分类标签。',
            contactLabelsCount: '{0} 个标签',
            createContactLabel: '创建标签',
            createLabel: '创建标签',
            label: '标签',
            labelName: '名称',
            labelColor: '颜色',
            labelCount: '标签数量',
            displayName: '显示名称',
            contactLabelNamePlaceholder: '家人、大学、供应商……',
            contactLabelDescriptionPlaceholder: '此标签的可选说明',
            contactLabelNameRequired: '请输入标签名称。',
            contactLabelCreated: '联系人标签已创建。',
            contactLabelUpdated: '联系人标签已更新。',
            contactLabelDeleted: '联系人标签已删除。',
            failedToLoadContactLabels: '加载联系人标签失败。',
            failedToCreateContactLabel: '创建联系人标签失败。',
            failedToUpdateContactLabel: '更新联系人标签失败。',
            failedToDeleteContactLabel: '删除联系人标签失败。',
            deleteContactLabelConfirm: '删除标签「{0}」？该标签会从所有联系人中移除。',
            assignContactLabelsDescription: '使用标签整理和筛选此联系人。',
            noContactLabels: '无标签',
            allLabels: '全部标签',
            untaggedContacts: '无标签联系人',
            withContactLabels: '含 {0} 个所选标签',
            groupByLabel: '标签',
            information: '资料',
            anyInformation: '不限资料',
            informationFilterActive: '已应用资料筛选',
            hasContactMethod: '有联系方式',
            missingContactMethod: '缺少联系方式',
            hasPhone: '有电话',
            hasEmail: '有邮箱',
            hasAddress: '有地址',
            hasInstantMessage: '有即时通讯',
            hasWebsite: '有网站',
            hasBirthday: '有生日',
            hasIdentityNumber: '有身份证件号码',
            hasNationality: '有国籍',
            hasCityOfResidence: '有居住城市',
            hasCareerField: '有职业领域',
            hasDegree: '有学位',
            hasEducationBackground: '有教育背景'
        }
    } as Record<string, Record<ContactModuleKeys, string>>,
    activity: {
        'en-US': {
            clickToAddTitle: 'Add title',
            clickToAddDescription: 'Add description',
            activityTiming: 'Activity timing',
            subtasks: 'Subtasks',
            subtasksProgress: '{0}/{1} done',
            addSubtask: 'Add sub-task',
            subtaskTiming: 'Sub-task timing',
            addSubtaskPlaceholder: 'Add sub-task (press Enter)',
            addTime: 'Add time',
            clearTime: 'Clear',
            openSubtaskMenu: 'Open sub-task menu',
            paste: 'Paste',
            deleteSubtask: 'Delete Sub-task',
            subtaskFilterAll: 'All',
            subtaskFilterOpen: 'Open',
            subtaskFilterCompleted: 'Done',
            subtaskFilterTimed: 'Timed',
            subtaskSortDefault: 'Original',
            subtaskSortName: 'Name',
            subtaskSortTiming: 'Timing',
            subtaskSortStatus: 'Status',
            noSubtasksMatchingFilter: 'No sub-tasks match this filter.',
            noTime: 'No time',
            specificTimingStartRequired: 'Specific timing (start required)',
            startTimeRequired: 'Start time is required.',
            startRequiredBeforeEnd: 'Start time is required before end time.',
            duePrefix: 'Due:',
            scheduledPrefix: 'Scheduled:',
            recurring: 'Recurring',
            everyFrequency: 'Every {0}',
            frequencyDaily: 'daily',
            frequencyWeekly: 'weekly',
            frequencyMonthly: 'monthly',
            frequencyYearly: 'yearly',
            frequencyWeekday: 'weekday',
            frequencyWeekend: 'weekend',
            frequencyCustom: 'custom',
            failedSaveActivityTiming: 'Failed to save activity timing',
            failedSaveSubtaskTiming: 'Failed to save sub-task timing',
            activityPreview: 'Activity Preview',
            activityEdit: 'Activity Edit',
            activityName: 'Activity Name',
            activityDescription: 'Activity Description',
            activityStatus: 'Activity Status',
            noTagsAvailable: 'No Tags Available',
            tagsSummary: '{0} tags',
            activeTagsSummary: '{0} active tags',
            manageActivityTags: 'Manage Activity Tags',
            areYouSureDeleteTag: 'Are you sure you want to delete this tag?',
            allActivities: 'All Activities',
            allActivitiesDescription: 'Here are all activities ever since the website born.',
            todo: 'TODO',
            ready: 'Ready',
            inProgress: 'IN PROGRESS',
            review: 'Review',
            done: 'Done',
            blocked: 'BLOCKED',
            cancelled: 'CANCELLED',
            activityDDL: 'Activity DDL',
            due: 'Due',
            startTypingToCreate: 'Start typing to create a new activity!',
            editThisActivity: 'Edit this activity',
            deleteThisActivity: 'Delete this activity',
            deleteActivityConfirm: 'Are you sure you want to delete this Activity?',
            reporting: 'Reporting',
            refreshReports: 'Refresh reports',
            noReports: 'No activity reports yet.',
            failedLoadReports: 'Failed to load activity reports',
            loadMoreActivities: 'Load more',
            display: 'Display',
            layout: 'Layout',
            sort: 'Sort',
            filter: 'Filter',
            applyFilters: 'Apply',
            startTime: 'Start time',
            endTime: 'End time',
            projects: 'Projects',
            project: 'Project',
            addProject: 'Add project',
            editProject: 'Edit project',
            deleteProject: 'Delete project',
            projectName: 'Project name',
            projectDescription: 'Project description',
            projectColor: 'Project color',
            noProjectsAvailable: 'No projects available',
            confirmDeleteProject: 'Delete this project? Its activities will move to another project.',
            createActivity: 'Add activity',
            inbox: 'Inbox',
            today: 'Today',
            upcoming: 'Upcoming',
            filtersAndLabels: 'Filters & Labels',
            myProjects: 'My Projects',
            taskboard: 'Taskboard',
            defaultProject: 'Default',
            projectUntitled: 'Untitled project',
            openTaskMenu: 'Open task menu',
            selectLabels: 'Select labels',
            date: 'Date',
            tomorrow: 'Tomorrow',
            laterThisWeek: 'Later this week',
            thisWeekend: 'This weekend',
            nextWeek: 'Next week',
            noActivitiesInView: 'No activities in this view',
            overdue: 'Overdue',
            reschedule: 'Reschedule',
            allDay: 'All day',
            specificTiming: 'Specific timing',
            timingNumber: 'Timing {0}',
            addTiming: 'Add timing',
            removeTiming: 'Remove timing',
            every: 'Every',
            until: 'Until',
            manageActivityTagsDescription: 'Create and maintain activity labels used for filtering tasks.',
            addTag: 'Add tag',
            editTag: 'Edit tag',
            view: 'View',
            sortAndFilter: 'Sort and filter',
            sortBy: 'Sort by',
            order: 'Order',
            updated: 'Updated',
            ascending: 'Ascending',
            descending: 'Descending',
            from: 'From',
            clear: 'Clear',
            resetView: 'Reset view',
            counter: 'Counter',
            counterNone: 'None',
            daysUntil: 'Days until',
            daysSince: 'Days since',
            counterAnchorRequired: 'Countdown and count-forward activities require an anchor date.',
            chooseDateBeforeCounter: 'Choose an activity date before enabling a counter.',
            boardSections: 'Board sections',
            boardSectionsMinimum: 'At least two sections are required.',
            boardSection: 'Board section',
            addSection: 'Add section',
            newSection: 'New section',
            defaultSection: 'Default',
            completedSection: 'Done',
            moveSectionLeft: 'Move section left',
            moveSectionRight: 'Move section right',
            deleteSection: 'Delete section',
            deleteSectionConfirm: 'Delete the section "{0}"? Activities in it will move to the default section.',
            deleteSectionConfirmFallback: 'Delete this section? Activities in it will move to the default section.',
            chooseCounterActivity: 'Choose a counter activity',
            counterWidgetDescription: 'Select the milestone and how the 2x2 widget should look.',
            configureCounterWidget: 'Configure activity counter widget',
            counterAppearance: 'Appearance',
            counterPlain: 'Plain',
            counterPlainDescription: 'Neutral surface for quiet dashboards.',
            counterAccent: 'Accent',
            counterAccentDescription: 'Uses the active theme color for emphasis.',
            loadingCounterActivities: 'Loading counter activities...',
            failedLoadCounterActivities: 'Could not load counter activities',
            noCounterActivities: 'No activities have a counter and date yet',
            sectionDescription: 'Section description',
            editSection: 'Edit section',
            sectionName: 'Section name',
            dragSection: 'Drag to reorder section',
            sectionColor: 'Section color',
            subtaskCompletedToggle: 'Completed subtasks ({0})',
            subtaskHideCompleted: 'Hide completed subtasks',
            subtaskBatchToggle: 'Batch',
            subtaskBatchTitle: 'Batch add subtasks',
            subtaskBatchTemplateLabel: 'Template',
            subtaskBatchTemplatePlaceholder: 'e.g. 【考研】$1年',
            subtaskBatchTemplateHint: 'Use $1–$9 as variables. Click "Parse variables" to confirm the template.',
            subtaskBatchParse: 'Parse variables',
            subtaskBatchVariablesLabel: 'Variable data',
            subtaskBatchVariableLabel: 'Variable ${0}',
            subtaskBatchVariableHint: 'One value per line. Multiple variables generate all combinations.',
            subtaskBatchVariableValuesPlaceholder: 'One value per line',
            subtaskBatchPreviewLabel: 'Preview',
            subtaskBatchPreviewCount: 'Will add {0} subtasks',
            subtaskBatchAddCount: 'Add {0} subtasks',
            subtaskBatchConfirmCount: 'Click again to confirm adding {0} subtasks',
            subtaskBatchNoVariables: 'Include at least one variable (e.g. $1) in the template.',
            subtaskBatchMissingValues: 'Enter at least one value for every variable.',
            subtaskBatchTooManyCombinations: 'Too many combinations ({0}). Please reduce the data.',
            subtaskBatchEditTemplate: 'Edit template',
            subtaskBatchAdded: 'Added {0} subtasks',
            createTagNamed: 'Create tag "{0}"',
            tagNameExists: 'A tag with this name already exists',
            markIncomplete: 'Mark as not done',
            sectionActions: 'Section actions',
            projectActions: 'Project actions',
            filtersActive: '{0} filters active',
            newProject: 'New project',
            boardEmpty: 'This board has no sections yet',
            discardChangesConfirm: 'Discard unsaved changes?',
            discard: 'Discard'
        },
        'zh-CN': {
            clickToAddTitle: '添加标题',
            clickToAddDescription: '添加描述',
            activityTiming: '活动时间',
            subtasks: '子任务',
            subtasksProgress: '已完成 {0}/{1}',
            addSubtask: '添加子任务',
            subtaskTiming: '子任务时间',
            addSubtaskPlaceholder: '添加子任务（回车创建）',
            addTime: '添加时间',
            clearTime: '清除',
            openSubtaskMenu: '打开子任务菜单',
            paste: '粘贴',
            deleteSubtask: '删除子任务',
            subtaskFilterAll: '全部',
            subtaskFilterOpen: '未完成',
            subtaskFilterCompleted: '已完成',
            subtaskFilterTimed: '有时间',
            subtaskSortDefault: '原顺序',
            subtaskSortName: '名称',
            subtaskSortTiming: '时间',
            subtaskSortStatus: '状态',
            noSubtasksMatchingFilter: '没有符合筛选条件的子任务。',
            noTime: '无时间',
            specificTimingStartRequired: '具体时间（需要开始时间）',
            startTimeRequired: '需要开始时间。',
            startRequiredBeforeEnd: '结束时间前需要先设置开始时间。',
            duePrefix: '截止：',
            scheduledPrefix: '时间：',
            recurring: '重复',
            everyFrequency: '每 {0}',
            frequencyDaily: '天',
            frequencyWeekly: '周',
            frequencyMonthly: '月',
            frequencyYearly: '年',
            frequencyWeekday: '工作日',
            frequencyWeekend: '周末',
            frequencyCustom: '自定义',
            failedSaveActivityTiming: '保存活动时间失败',
            failedSaveSubtaskTiming: '保存子任务时间失败',
            activityPreview: '活动预览',
            activityEdit: '活动编辑',
            activityName: '活动名称',
            activityDescription: '活动描述',
            activityStatus: '活动状态',
            noTagsAvailable: '无可用标签',
            tagsSummary: '{0} 个标签',
            activeTagsSummary: '已选 {0} 个标签',
            manageActivityTags: '管理活动标签',
            areYouSureDeleteTag: '你确定要删除此标签吗？',
            allActivities: '所有活动',
            allActivitiesDescription: '这里是自网站诞生以来的所有活动。',
            todo: '待办',
            ready: '就绪',
            inProgress: '进行中',
            review: '审核',
            done: '已完成',
            blocked: '阻塞',
            cancelled: '已取消',
            activityDDL: '活动截止时间',
            due: '截止',
            startTypingToCreate: '开始输入以创建新活动！',
            editThisActivity: '编辑此活动',
            deleteThisActivity: '删除此活动',
            deleteActivityConfirm: '你确定要删除此活动吗？',
            reporting: '报告',
            refreshReports: '刷新报告',
            noReports: '暂无活动报告。',
            failedLoadReports: '加载活动报告失败',
            loadMoreActivities: '加载更多',
            display: '显示',
            layout: '布局',
            sort: '排序',
            filter: '筛选',
            applyFilters: '应用',
            startTime: '开始时间',
            endTime: '结束时间',
            projects: '项目',
            project: '项目',
            addProject: '添加项目',
            editProject: '编辑项目',
            deleteProject: '删除项目',
            projectName: '项目名称',
            projectDescription: '项目描述',
            projectColor: '项目颜色',
            noProjectsAvailable: '暂无项目',
            confirmDeleteProject: '删除此项目？其中的活动将移动到另一个项目。',
            createActivity: '添加活动',
            inbox: '收件箱',
            today: '今天',
            upcoming: '即将到来',
            filtersAndLabels: '筛选和标签',
            myProjects: '我的项目',
            taskboard: '任务板',
            defaultProject: '默认',
            projectUntitled: '未命名项目',
            openTaskMenu: '打开任务菜单',
            selectLabels: '选择标签',
            date: '日期',
            tomorrow: '明天',
            laterThisWeek: '本周稍后',
            thisWeekend: '本周末',
            nextWeek: '下周',
            noActivitiesInView: '此视图暂无活动',
            overdue: '已逾期',
            reschedule: '重新安排',
            allDay: '全天',
            specificTiming: '具体时间',
            timingNumber: '时间 {0}',
            addTiming: '添加时间',
            removeTiming: '移除时间',
            every: '每',
            until: '直到',
            manageActivityTagsDescription: '创建和维护用于筛选任务的活动标签。',
            addTag: '添加标签',
            editTag: '编辑标签',
            view: '视图',
            sortAndFilter: '排序和筛选',
            sortBy: '排序方式',
            order: '顺序',
            updated: '更新时间',
            ascending: '升序',
            descending: '降序',
            from: '开始于',
            clear: '清除',
            resetView: '重置视图',
            counter: '计日',
            counterNone: '无',
            daysUntil: '还有几天',
            daysSince: '已经几天',
            counterAnchorRequired: '倒计时和正计时活动需要设置一个日期。',
            chooseDateBeforeCounter: '启用计日前请先选择活动日期。',
            boardSections: '任务板分区',
            boardSectionsMinimum: '至少需要两个分区。',
            boardSection: '任务板分区',
            addSection: '添加分区',
            newSection: '新分区',
            defaultSection: '默认',
            completedSection: '完成',
            moveSectionLeft: '向左移动分区',
            moveSectionRight: '向右移动分区',
            deleteSection: '删除分区',
            deleteSectionConfirm: '确定删除分区「{0}」吗？其中的活动将移动到默认分区。',
            deleteSectionConfirmFallback: '确定删除这个分区吗？其中的活动将移动到默认分区。',
            chooseCounterActivity: '选择一个计日活动',
            counterWidgetDescription: '选择里程碑活动以及 2x2 小组件的外观。',
            configureCounterWidget: '配置计日小组件',
            counterAppearance: '外观',
            counterPlain: '简洁',
            counterPlainDescription: '使用中性色，适合安静的仪表盘。',
            counterAccent: '强调',
            counterAccentDescription: '使用当前主题色突出显示。',
            loadingCounterActivities: '正在加载计日活动...',
            failedLoadCounterActivities: '无法加载计日活动',
            noCounterActivities: '暂无同时设置计日模式和日期的活动',
            sectionDescription: '分区描述',
            editSection: '编辑分区',
            sectionName: '分区名称',
            dragSection: '拖动以调整分区顺序',
            sectionColor: '分区颜色',
            subtaskCompletedToggle: '已完成子任务（{0}）',
            subtaskHideCompleted: '收起已完成的子任务',
            subtaskBatchToggle: '批量',
            subtaskBatchTitle: '批量添加子任务',
            subtaskBatchTemplateLabel: '模板',
            subtaskBatchTemplatePlaceholder: '例如：【考研】$1年',
            subtaskBatchTemplateHint: '使用 $1–$9 作为变量，点击“解析变量”确认模板。',
            subtaskBatchParse: '解析变量',
            subtaskBatchVariablesLabel: '变量数据',
            subtaskBatchVariableLabel: '变量 ${0}',
            subtaskBatchVariableHint: '每行一个值；多个变量会生成所有组合。',
            subtaskBatchVariableValuesPlaceholder: '每行一个值',
            subtaskBatchPreviewLabel: '预览',
            subtaskBatchPreviewCount: '将添加 {0} 个子任务',
            subtaskBatchAddCount: '添加 {0} 个子任务',
            subtaskBatchConfirmCount: '再次点击确认添加 {0} 个子任务',
            subtaskBatchNoVariables: '模板中至少包含一个变量（如 $1）。',
            subtaskBatchMissingValues: '请为每个变量输入至少一个值。',
            subtaskBatchTooManyCombinations: '组合过多（{0}），请减少数据。',
            subtaskBatchEditTemplate: '编辑模板',
            subtaskBatchAdded: '已添加 {0} 个子任务',
            createTagNamed: '创建标签“{0}”',
            tagNameExists: '已存在同名标签',
            markIncomplete: '标记为未完成',
            sectionActions: '分区操作',
            projectActions: '项目操作',
            filtersActive: '{0} 项筛选生效中',
            newProject: '新建项目',
            boardEmpty: '此看板还没有分区',
            discardChangesConfirm: '放弃未保存的修改吗？',
            discard: '放弃'
        }
    } as Record<string, Record<ActivityModuleKeys, string>>,
    file: {
        'en-US': {
            failedToUploadFiles: 'Failed to upload files',
            penguinAlt: 'Penguin',
            untagged: 'Untagged',
            pathRequired: 'Path required',
            uploadedLivePhoto: 'Uploaded {name}.hfap',
            noValidLivePhotoPairs: 'No valid live photo pairs detected',
            livePhotoUpload: 'Live Photo Upload',
            livePhotoDescription: 'Drop image (still) + video (motion) files sharing the same base filename (e.g. IMG_0001.jpg & IMG_0001.mov). We will upload a single .hfap entry.',
            livePhotoPathPlaceholder: 'e.g. photos.2025.08',
            uploadAllCount: 'Upload All ({count})',
            dropOrChooseFiles: 'Drop or choose files…',
            filesSelectedPairs: '{fileCount} files selected. Detected {pairCount} live photo pair(s).',
            stillLabel: 'Still',
            motionLabel: 'Motion',
            done: 'DONE',
            upload: 'Upload',
            fileDragDropTitle: 'Drag and drop files here',
            fileDragDropSubtitle: 'or use the options below to select files',
            chooseFiles: 'Choose Files',
            fileNamePlaceholder: 'Filename',
            descriptionOptional: 'Description (optional)',
            uploadFilesCount: 'Upload {count} Files',
            uploadedFilesCount: 'Uploaded {count} files',
            failedFilesCount: '{count} files could not be uploaded',
            selectedFilesCount: '{count} files selected',
            removeSelectedFile: 'Remove {name}',
            uploadPanelDescription: 'Add files, review their names, and upload them to this folder.',
            deleteTagConfirmWithName: 'Delete tag "{name}"? This cannot be undone.',
            fileLibrary: 'File Library',
            manageTagsDescription: 'Create, update, and organize the tags used to classify your files. Changes apply instantly across the library.',
            manageTagsHelper: 'Manage file tags without clutter. Use the button to add new tags; edit existing ones in a dialog so the layout stays stable.',
            newTag: 'New Tag',
            noTagsYet: 'No tags yet',
            noTagsYetDescription: 'Click “New Tag” to add your first one.',
            noTagDescription: 'No description provided.',
            editTagAria: 'Edit tag',
            deleteTagAria: 'Delete tag',
            createTag: 'Create Tag',
            editTag: 'Edit Tag',
            files: 'Files',
            fileWelcome: 'Welcome to the file section!',
            fileDescription: 'Here you can upload files and manage them!',
            fileList: 'File List',
            fileListDescription: 'Browser and manage your files here',
            fileTag: 'File Tags',
            fileTagDescription: 'Manage your file tags here',
            clipboardReadFilesCount: 'Read {count} files from Clipboard',
            clipboardNoSupportedFiles: 'No supported files found in clipboard',
            readFromPasteboard: 'Read from Pasteboard',
            fileBatchUpload: 'Batch Upload',
            searchFiles: 'Search Files',
            fileTypeUnknown: 'FILE',
            tagNamePlaceholder: 'Tag name',
            clipboardReadFile: 'Read file from clipboard',
            clipboardNoSupportedFile: 'No supported file found in clipboard',
            editFile: 'Edit File',
            pasteFromClipboard: 'Paste from Clipboard',
            newContentSelected: 'New content selected: {name} ({size})',
            deleteFileConfirm: 'Are you sure you want to delete this file?',
            deleteFile: 'Delete File',
            updateFile: 'Update File',
            areYouSureDeleteTag: 'Are you sure you want to delete this tag?',
            fileTagsLoadFailed: 'Failed to load file tags',
            incorrectFormData: 'Incorrect form data',
            reviewAndUpload: 'Review & Upload',
            pathPlaceholder: 'e.g. photos.2025.08',
            globalSettings: 'Global Settings',
            fileUploadFailed: 'File upload failed',
            fileUploadSuccess: 'File uploaded successfully',
            manageTags: 'Manage Tags',
            missingFilePathOrName: 'Missing file path or file name',
            missingUploadInfo: 'Missing upload information',
            pleaseSelectCorrectFileType: 'Please select the correct file type',
            pleaseSelectFileFirst: 'Please select a file first',
            resourceDeletedYouShouldSubmitCurrentChanges: 'Resource may have been deleted, you should submit current changes',
            uploading: 'Uploading'
        },
        'zh-CN': {
            failedToUploadFiles: '上传文件失败',
            penguinAlt: '企鹅',
            untagged: '未标记',
            pathRequired: '需要路径',
            uploadedLivePhoto: '已上传 {name}.hfap',
            noValidLivePhotoPairs: '未检测到有效的实况照片组合',
            livePhotoUpload: '实况照片上传',
            livePhotoDescription: '拖入同名的图片（静态）与视频（动态）文件（例如 IMG_0001.jpg 与 IMG_0001.mov）。我们将上传一个 .hfap 条目。',
            livePhotoPathPlaceholder: '例如：photos.2025.08',
            uploadAllCount: '全部上传（{count}）',
            dropOrChooseFiles: '拖拽或选择文件…',
            filesSelectedPairs: '已选择 {fileCount} 个文件，检测到 {pairCount} 组实况照片。',
            stillLabel: '静态',
            motionLabel: '动态',
            done: '已完成',
            upload: '上传',
            fileDragDropTitle: '拖拽文件到这里',
            fileDragDropSubtitle: '或使用下面的选项选择文件',
            chooseFiles: '选择文件',
            fileNamePlaceholder: '文件名',
            descriptionOptional: '描述（可选）',
            uploadFilesCount: '上传 {count} 个文件',
            uploadedFilesCount: '已上传 {count} 个文件',
            failedFilesCount: '有 {count} 个文件上传失败',
            selectedFilesCount: '已选择 {count} 个文件',
            removeSelectedFile: '移除 {name}',
            uploadPanelDescription: '添加文件、检查文件名，然后上传到当前文件夹。',
            deleteTagConfirmWithName: '确定要删除标签"{name}"吗？此操作无法撤销。',
            fileLibrary: '文件库',
            manageTagsDescription: '创建、更新并整理用于分类文件的标签，改动会立刻生效。',
            manageTagsHelper: '无需打乱布局即可管理标签。使用按钮创建新标签，在对话框中编辑现有标签。',
            newTag: '新建标签',
            noTagsYet: '还没有标签',
            noTagsYetDescription: '点击"新建标签"添加第一个标签。',
            noTagDescription: '暂无描述。',
            editTagAria: '编辑标签',
            deleteTagAria: '删除标签',
            createTag: '创建标签',
            editTag: '编辑标签',
            files: '文件',
            fileWelcome: '欢迎来到文件分区！',
            fileDescription: '在这里你可以上传文件并进行管理！',
            fileList: '文件列表',
            fileListDescription: '在这里浏览和管理你的文件',
            fileTag: '文件标签',
            fileTagDescription: '在这里管理你的文件标签',
            clipboardReadFilesCount: '已从剪贴板读取 {count} 个文件',
            clipboardNoSupportedFiles: '剪贴板中没有支持的文件',
            readFromPasteboard: '从剪贴板读取',
            fileBatchUpload: '批量上传',
            searchFiles: '搜索文件',
            fileTypeUnknown: '文件',
            tagNamePlaceholder: '标签名称',
            clipboardReadFile: '已从剪贴板读取文件',
            clipboardNoSupportedFile: '剪贴板中没有支持的文件',
            editFile: '编辑文件',
            pasteFromClipboard: '从剪贴板粘贴',
            newContentSelected: '已选择新内容：{name}（{size}）',
            deleteFileConfirm: '确定要删除此文件吗？',
            deleteFile: '删除文件',
            updateFile: '更新文件',
            areYouSureDeleteTag: '你确定要删除此标签吗？',
            fileTagsLoadFailed: '加载文件标签失败',
            incorrectFormData: '表单数据不正确',
            reviewAndUpload: '检查并上传',
            pathPlaceholder: '例如：photos.2025.08',
            globalSettings: '全局设置',
            fileUploadFailed: '文件上传失败',
            fileUploadSuccess: '文件上传成功',
            manageTags: '管理标签',
            missingFilePathOrName: '缺少文件路径或文件名',
            missingUploadInfo: '缺少上传信息',
            pleaseSelectCorrectFileType: '请选择正确的文件类型',
            pleaseSelectFileFirst: '请先选择文件',
            resourceDeletedYouShouldSubmitCurrentChanges: '资源可能已被删除，您应该提交当前更改',
            uploading: '上传中'
        },
        'zh-TW': {
            failedToUploadFiles: '上傳檔案失敗',
            penguinAlt: '企鵝',
            untagged: '未標記',
            pathRequired: '需要路徑',
            uploadedLivePhoto: '已上傳 {name}.hfap',
            noValidLivePhotoPairs: '未偵測到有效的實況照片組合',
            livePhotoUpload: '實況照片上傳',
            livePhotoDescription: '拖入同名的圖片（靜態）與影片（動態）檔案（例如 IMG_0001.jpg 與 IMG_0001.mov）。我們將上傳一個 .hfap 項目。',
            livePhotoPathPlaceholder: '例如：photos.2025.08',
            uploadAllCount: '全部上傳（{count}）',
            dropOrChooseFiles: '拖曳或選擇檔案…',
            filesSelectedPairs: '已選擇 {fileCount} 個檔案，偵測到 {pairCount} 組實況照片。',
            stillLabel: '靜態',
            motionLabel: '動態',
            done: '已完成',
            upload: '上傳',
            fileDragDropTitle: '將檔案拖放到這裡',
            fileDragDropSubtitle: '或使用下方選項選擇檔案',
            chooseFiles: '選擇檔案',
            fileNamePlaceholder: '檔案名稱',
            descriptionOptional: '描述（可選）',
            uploadFilesCount: '上傳 {count} 個檔案',
            uploadedFilesCount: '已上傳 {count} 個檔案',
            failedFilesCount: '有 {count} 個檔案上傳失敗',
            selectedFilesCount: '已選擇 {count} 個檔案',
            removeSelectedFile: '移除 {name}',
            uploadPanelDescription: '加入檔案、檢查檔案名稱，然後上傳到目前資料夾。',
            deleteTagConfirmWithName: '確定要刪除標籤「{name}」嗎？此操作無法復原。',
            fileLibrary: '檔案庫',
            manageTagsDescription: '建立、更新並整理用於分類檔案的標籤。變更會立即套用到整個檔案庫。',
            manageTagsHelper: '在不干擾版面的情況下管理檔案標籤。使用按鈕新增標籤，並在對話框中編輯現有標籤，以保持版面穩定。',
            newTag: '新增標籤',
            noTagsYet: '尚無標籤',
            noTagsYetDescription: '點擊「新增標籤」加入第一個標籤。',
            noTagDescription: '未提供描述。',
            editTagAria: '編輯標籤',
            deleteTagAria: '刪除標籤',
            createTag: '建立標籤',
            editTag: '編輯標籤',
            files: '檔案',
            fileWelcome: '歡迎來到檔案區！',
            fileDescription: '你可以在這裡上傳並管理檔案！',
            fileList: '檔案列表',
            fileListDescription: '在這裡瀏覽並管理你的檔案',
            fileTag: '檔案標籤',
            fileTagDescription: '在這裡管理你的檔案標籤',
            clipboardReadFilesCount: '已從剪貼簿讀取 {count} 個檔案',
            clipboardNoSupportedFiles: '剪貼簿中沒有支援的檔案',
            readFromPasteboard: '從剪貼簿讀取',
            fileBatchUpload: '批次上傳',
            searchFiles: '搜尋檔案',
            fileTypeUnknown: '檔案',
            tagNamePlaceholder: '標籤名稱',
            clipboardReadFile: '已從剪貼簿讀取檔案',
            clipboardNoSupportedFile: '剪貼簿中沒有支援的檔案',
            editFile: '編輯檔案',
            pasteFromClipboard: '從剪貼簿貼上',
            newContentSelected: '已選擇新內容：{name}（{size}）',
            deleteFileConfirm: '確定要刪除此檔案嗎？',
            deleteFile: '刪除檔案',
            updateFile: '更新檔案',
            areYouSureDeleteTag: '你確定要刪除此標籤嗎？',
            fileTagsLoadFailed: '載入檔案標籤失敗',
            incorrectFormData: '表單資料不正確',
            reviewAndUpload: '檢查並上傳',
            pathPlaceholder: '例如：photos.2025.08',
            globalSettings: '全域設定',
            fileUploadFailed: '檔案上傳失敗',
            fileUploadSuccess: '檔案上傳成功',
            manageTags: '管理標籤',
            missingFilePathOrName: '缺少檔案路徑或檔案名稱',
            missingUploadInfo: '缺少上傳資訊',
            pleaseSelectCorrectFileType: '請選擇正確的檔案類型',
            pleaseSelectFileFirst: '請先選擇檔案',
            resourceDeletedYouShouldSubmitCurrentChanges: '資源可能已被刪除，請提交目前的變更',
            uploading: '上傳中'
        },
        'fr': {
            failedToUploadFiles: 'Échec du téléchargement des fichiers',
            penguinAlt: 'Pingouin',
            untagged: 'Non étiqueté',
            pathRequired: 'Chemin requis',
            uploadedLivePhoto: '{name}.hfap téléversé',
            noValidLivePhotoPairs: 'Aucune paire de Live Photo valide détectée',
            livePhotoUpload: 'Téléversement de Live Photo',
            livePhotoDescription: 'Déposez des fichiers image (fixe) et vidéo (mouvement) portant le même nom de base (par ex. IMG_0001.jpg et IMG_0001.mov). Nous téléverserons une seule entrée .hfap.',
            livePhotoPathPlaceholder: 'par ex. photos.2025.08',
            uploadAllCount: 'Tout téléverser ({count})',
            dropOrChooseFiles: 'Déposez ou choisissez des fichiers…',
            filesSelectedPairs: '{fileCount} fichiers sélectionnés. {pairCount} paire(s) de Live Photo détectée(s).',
            stillLabel: 'Fixe',
            motionLabel: 'Mouvement',
            done: 'TERMINÉ',
            upload: 'Téléverser',
            fileDragDropTitle: 'Glissez-déposez les fichiers ici',
            fileDragDropSubtitle: 'ou utilisez les options ci-dessous pour sélectionner des fichiers',
            chooseFiles: 'Choisir des fichiers',
            fileNamePlaceholder: 'Nom du fichier',
            descriptionOptional: 'Description (facultative)',
            uploadFilesCount: 'Téléverser {count} fichiers',
            uploadedFilesCount: '{count} fichiers téléversés',
            failedFilesCount: 'Échec du téléversement de {count} fichiers',
            selectedFilesCount: '{count} fichiers sélectionnés',
            removeSelectedFile: 'Retirer {name}',
            uploadPanelDescription: 'Ajoutez des fichiers, vérifiez leurs noms, puis téléversez-les dans ce dossier.',
            deleteTagConfirmWithName: 'Supprimer l\'étiquette "{name}" ? Cette action est irréversible.',
            fileLibrary: 'Bibliothèque de fichiers',
            manageTagsDescription: 'Créez, mettez à jour et organisez les étiquettes utilisées pour classer vos fichiers. Les changements s\'appliquent instantanément à toute la bibliothèque.',
            manageTagsHelper: 'Gérez les étiquettes de fichiers sans encombrer l\'interface. Utilisez le bouton pour ajouter de nouvelles étiquettes ; modifiez les existantes dans une boîte de dialogue afin de garder une mise en page stable.',
            newTag: 'Nouvelle étiquette',
            noTagsYet: 'Aucune étiquette pour le moment',
            noTagsYetDescription: 'Cliquez sur « Nouvelle étiquette » pour ajouter la première.',
            noTagDescription: 'Aucune description fournie.',
            editTagAria: 'Modifier l\'étiquette',
            deleteTagAria: 'Supprimer l\'étiquette',
            createTag: 'Créer l\'étiquette',
            editTag: 'Modifier l\'étiquette',
            files: 'Fichiers',
            fileWelcome: 'Bienvenue dans la section fichiers !',
            fileDescription: 'Vous pouvez téléverser et gérer vos fichiers ici !',
            fileList: 'Liste des fichiers',
            fileListDescription: 'Parcourez et gérez vos fichiers ici',
            fileTag: 'Étiquettes de fichiers',
            fileTagDescription: 'Gérez vos étiquettes de fichiers ici',
            clipboardReadFilesCount: '{count} fichiers lus depuis le presse-papiers',
            clipboardNoSupportedFiles: 'Aucun fichier pris en charge trouvé dans le presse-papiers',
            readFromPasteboard: 'Lire depuis le presse-papiers',
            fileBatchUpload: 'Téléversement par lot',
            searchFiles: 'Rechercher des fichiers',
            fileTypeUnknown: 'FICHIER',
            tagNamePlaceholder: 'Nom de l\'étiquette',
            clipboardReadFile: 'Fichier lu depuis le presse-papiers',
            clipboardNoSupportedFile: 'Aucun fichier pris en charge trouvé dans le presse-papiers',
            editFile: 'Modifier le fichier',
            pasteFromClipboard: 'Coller depuis le presse-papiers',
            newContentSelected: 'Nouveau contenu sélectionné : {name} ({size})',
            deleteFileConfirm: 'Voulez-vous vraiment supprimer ce fichier ?',
            deleteFile: 'Supprimer le fichier',
            updateFile: 'Mettre à jour le fichier',
            areYouSureDeleteTag: 'Voulez-vous vraiment supprimer cette étiquette ?',
            fileTagsLoadFailed: 'Échec du chargement des étiquettes de fichiers',
            incorrectFormData: 'Données du formulaire incorrectes',
            reviewAndUpload: 'Vérifier et téléverser',
            pathPlaceholder: 'par ex. photos.2025.08',
            globalSettings: 'Paramètres globaux',
            fileUploadFailed: 'Échec du téléversement du fichier',
            fileUploadSuccess: 'Fichier téléversé avec succès',
            manageTags: 'Gérer les étiquettes',
            missingFilePathOrName: 'Chemin ou nom de fichier manquant',
            missingUploadInfo: 'Informations de téléversement manquantes',
            pleaseSelectCorrectFileType: 'Veuillez sélectionner le bon type de fichier',
            pleaseSelectFileFirst: 'Veuillez d\'abord sélectionner un fichier',
            resourceDeletedYouShouldSubmitCurrentChanges: 'La ressource a peut-être été supprimée ; vous devriez soumettre les changements actuels',
            uploading: 'Téléversement en cours'
        },
        'ja': {
            failedToUploadFiles: 'ファイルのアップロードに失敗しました',
            penguinAlt: 'ペンギン',
            untagged: '未タグ',
            pathRequired: 'パスが必要です',
            uploadedLivePhoto: '{name}.hfap をアップロードしました',
            noValidLivePhotoPairs: '有効なLive Photoペアが検出されません',
            livePhotoUpload: 'Live Photoアップロード',
            livePhotoDescription: '同じベースファイル名を持つ画像（静止画）と動画（モーション）ファイルをドロップしてください（例: IMG_0001.jpg と IMG_0001.mov）。単一の .hfap エントリとしてアップロードします。',
            livePhotoPathPlaceholder: '例: photos.2025.08',
            uploadAllCount: 'すべてアップロード（{count}）',
            dropOrChooseFiles: 'ファイルをドロップまたは選択…',
            filesSelectedPairs: '{fileCount} 個のファイルが選択されました。{pairCount} 組のLive Photoペアを検出しました。',
            stillLabel: '静止画',
            motionLabel: 'モーション',
            done: '完了',
            upload: 'アップロード',
            fileDragDropTitle: 'ここにファイルをドラッグ＆ドロップ',
            fileDragDropSubtitle: 'または下のオプションでファイルを選択',
            chooseFiles: 'ファイルを選択',
            fileNamePlaceholder: 'ファイル名',
            descriptionOptional: '説明（任意）',
            uploadFilesCount: '{count} 個のファイルをアップロード',
            uploadedFilesCount: '{count} 個のファイルをアップロードしました',
            failedFilesCount: '{count} 個のファイルをアップロードできませんでした',
            selectedFilesCount: '{count} 個のファイルを選択中',
            removeSelectedFile: '{name} を削除',
            uploadPanelDescription: 'ファイルを追加し、名前を確認して、このフォルダにアップロードします。',
            deleteTagConfirmWithName: 'タグ「{name}」を削除しますか？この操作は元に戻せません。',
            fileLibrary: 'ファイルライブラリ',
            manageTagsDescription: 'ファイル分類に使うタグを作成、更新、整理します。変更はライブラリ全体に即時反映されます。',
            manageTagsHelper: '画面を散らかさずにファイルタグを管理します。ボタンで新しいタグを追加し、既存のタグはダイアログで編集してレイアウトを安定させます。',
            newTag: '新しいタグ',
            noTagsYet: 'タグはまだありません',
            noTagsYetDescription: '「新しいタグ」をクリックして最初のタグを追加してください。',
            noTagDescription: '説明はありません。',
            editTagAria: 'タグを編集',
            deleteTagAria: 'タグを削除',
            createTag: 'タグを作成',
            editTag: 'タグを編集',
            files: 'ファイル',
            fileWelcome: 'ファイルセクションへようこそ！',
            fileDescription: 'ここでファイルをアップロードして管理できます！',
            fileList: 'ファイル一覧',
            fileListDescription: 'ここでファイルを閲覧、管理します',
            fileTag: 'ファイルタグ',
            fileTagDescription: 'ここでファイルタグを管理します',
            clipboardReadFilesCount: 'クリップボードから {count} 個のファイルを読み込みました',
            clipboardNoSupportedFiles: 'クリップボードに対応ファイルがありません',
            readFromPasteboard: 'クリップボードから読み込む',
            fileBatchUpload: '一括アップロード',
            searchFiles: 'ファイルを検索',
            fileTypeUnknown: 'ファイル',
            tagNamePlaceholder: 'タグ名',
            clipboardReadFile: 'クリップボードからファイルを読み込みました',
            clipboardNoSupportedFile: 'クリップボードに対応ファイルがありません',
            editFile: 'ファイルを編集',
            pasteFromClipboard: 'クリップボードから貼り付け',
            newContentSelected: '新しい内容を選択しました: {name}（{size}）',
            deleteFileConfirm: 'このファイルを削除してもよろしいですか？',
            deleteFile: 'ファイルを削除',
            updateFile: 'ファイルを更新',
            areYouSureDeleteTag: 'このタグを削除してもよろしいですか？',
            fileTagsLoadFailed: 'ファイルタグの読み込みに失敗しました',
            incorrectFormData: 'フォームデータが正しくありません',
            reviewAndUpload: '確認してアップロード',
            pathPlaceholder: '例: photos.2025.08',
            globalSettings: '全体設定',
            fileUploadFailed: 'ファイルのアップロードに失敗しました',
            fileUploadSuccess: 'ファイルをアップロードしました',
            manageTags: 'タグを管理',
            missingFilePathOrName: 'ファイルパスまたはファイル名が不足しています',
            missingUploadInfo: 'アップロード情報が不足しています',
            pleaseSelectCorrectFileType: '正しいファイル種類を選択してください',
            pleaseSelectFileFirst: '先にファイルを選択してください',
            resourceDeletedYouShouldSubmitCurrentChanges: 'リソースが削除された可能性があります。現在の変更を送信してください',
            uploading: 'アップロード中'
        }
    } as Record<string, Record<FileModuleKeys, string>>,
    moment: {
        'en-US': {
            create: 'Create moment',
            edit: 'Edit moment',
            delete: 'Delete moment',
            detail: 'Moment detail',
            content: 'Moment content',
            saved: 'Moment saved',
            loadFailed: 'Failed to load moment',
            saveFailed: 'Failed to save moment',
            countLoadFailed: 'Failed to load moments count',
            listLoadFailed: 'Failed to load moments',
            usersLoadFailed: 'Failed to load users',
            placeholder: 'What\'s happening right away?',
            idRequired: 'Moment ID is required',
            confirmDelete: 'Are you sure you want to delete this moment?',
            deleted: 'Moment deleted',
            editThis: 'Edit this moment',
            visibility: 'Moment visibility',
            permissionUsers: 'Permission users',
            permissionUsersDescription: 'Select users who can view this moment',
            addUserPlaceholder: 'Add user',
            insertImage: 'Insert image',
            imagePickerTitle: 'Insert image',
            imagePickerDescription: 'Pick an existing image or upload a new one.',
            uploadImage: 'Upload image',
            selectImage: 'Select image',
            noImagesFound: 'No images found',
            createMoment: 'Create Moment',
            momentDetail: 'Moment Detail',
            momentIDRequired: 'Moment ID is required',
            failedToDelete: 'Failed to delete'
        },
        'zh-CN': {
            create: '创建动态',
            edit: '编辑动态',
            delete: '删除动态',
            detail: '动态详情',
            content: '动态内容',
            saved: '动态已保存',
            loadFailed: '加载动态失败',
            saveFailed: '保存动态失败',
            countLoadFailed: '加载动态数量失败',
            listLoadFailed: '加载动态失败',
            usersLoadFailed: '加载用户失败',
            placeholder: '现在发生了什么？',
            idRequired: '需要提供动态 ID',
            confirmDelete: '确定要删除此动态吗？',
            deleted: '动态已删除',
            editThis: '编辑此动态',
            visibility: '动态可见范围',
            permissionUsers: '授权用户',
            permissionUsersDescription: '选择可以查看此动态的用户',
            addUserPlaceholder: '添加用户',
            insertImage: '插入图片',
            imagePickerTitle: '插入图片',
            imagePickerDescription: '选择已有图片或上传一张新图片。',
            uploadImage: '上传图片',
            selectImage: '选择图片',
            noImagesFound: '未找到图片',
            createMoment: '创建动态',
            momentDetail: '动态详情',
            momentIDRequired: '需要提供动态 ID',
            failedToDelete: '删除失败'
        },
        'zh-TW': {
            create: '建立動態',
            edit: '編輯動態',
            delete: '刪除動態',
            detail: '動態詳情',
            content: '動態內容',
            saved: '動態已儲存',
            loadFailed: '載入動態失敗',
            saveFailed: '儲存動態失敗',
            countLoadFailed: '載入動態數量失敗',
            listLoadFailed: '載入動態失敗',
            usersLoadFailed: '載入使用者失敗',
            placeholder: '現在發生了什麼？',
            idRequired: '需要提供動態 ID',
            confirmDelete: '確定要刪除此動態嗎？',
            deleted: '動態已刪除',
            editThis: '編輯此動態',
            visibility: '動態可見範圍',
            permissionUsers: '授權使用者',
            permissionUsersDescription: '選擇可以檢視此動態的使用者',
            addUserPlaceholder: '新增使用者',
            insertImage: '插入圖片',
            imagePickerTitle: '插入圖片',
            imagePickerDescription: '選擇既有圖片或上傳一張新圖片。',
            uploadImage: '上傳圖片',
            selectImage: '選擇圖片',
            noImagesFound: '找不到圖片',
            createMoment: '建立動態',
            momentDetail: '動態詳情',
            momentIDRequired: '需要提供動態 ID',
            failedToDelete: '刪除失敗'
        },
        'fr': {
            create: 'Créer un moment',
            edit: 'Modifier le moment',
            delete: 'Supprimer le moment',
            detail: 'Détail du moment',
            content: 'Contenu du moment',
            saved: 'Moment enregistré',
            loadFailed: 'Échec du chargement du moment',
            saveFailed: 'Échec de l\'enregistrement du moment',
            countLoadFailed: 'Échec du chargement du nombre de moments',
            listLoadFailed: 'Échec du chargement des moments',
            usersLoadFailed: 'Échec du chargement des utilisateurs',
            placeholder: 'Que se passe-t-il maintenant ?',
            idRequired: 'L\'identifiant du moment est requis',
            confirmDelete: 'Voulez-vous vraiment supprimer ce moment ?',
            deleted: 'Moment supprimé',
            editThis: 'Modifier ce moment',
            visibility: 'Visibilité du moment',
            permissionUsers: 'Utilisateurs autorisés',
            permissionUsersDescription: 'Sélectionnez les utilisateurs pouvant voir ce moment',
            addUserPlaceholder: 'Ajouter un utilisateur',
            insertImage: 'Insérer une image',
            imagePickerTitle: 'Insérer une image',
            imagePickerDescription: 'Choisissez une image existante ou téléversez-en une nouvelle.',
            uploadImage: 'Téléverser une image',
            selectImage: 'Sélectionner une image',
            noImagesFound: 'Aucune image trouvée',
            createMoment: 'Créer un moment',
            momentDetail: 'Détail du moment',
            momentIDRequired: 'L\'identifiant du moment est requis',
            failedToDelete: 'Échec de la suppression'
        },
        'ja': {
            create: 'モーメントを作成',
            edit: 'モーメントを編集',
            delete: 'モーメントを削除',
            detail: 'モーメント詳細',
            content: 'モーメント内容',
            saved: 'モーメントを保存しました',
            loadFailed: 'モーメントの読み込みに失敗しました',
            saveFailed: 'モーメントの保存に失敗しました',
            countLoadFailed: 'モーメント数の読み込みに失敗しました',
            listLoadFailed: 'モーメントの読み込みに失敗しました',
            usersLoadFailed: 'ユーザーの読み込みに失敗しました',
            placeholder: '今なにが起きていますか？',
            idRequired: 'モーメントIDが必要です',
            confirmDelete: 'このモーメントを削除してもよろしいですか？',
            deleted: 'モーメントを削除しました',
            editThis: 'このモーメントを編集',
            visibility: 'モーメントの公開範囲',
            permissionUsers: '権限ユーザー',
            permissionUsersDescription: 'このモーメントを表示できるユーザーを選択してください',
            addUserPlaceholder: 'ユーザーを追加',
            insertImage: '画像を挿入',
            imagePickerTitle: '画像を挿入',
            imagePickerDescription: '既存の画像を選ぶか、新しい画像をアップロードしてください。',
            uploadImage: '画像をアップロード',
            selectImage: '画像を選択',
            noImagesFound: '画像が見つかりません',
            createMoment: 'モーメントを作成',
            momentDetail: 'モーメント詳細',
            momentIDRequired: 'モーメントIDが必要です',
            failedToDelete: '削除に失敗しました'
        }
    } as Record<string, Record<MomentModuleKeys, string>>,
    cooking: {
        'en-US': {
            cooking: 'Cooking',
            cuisineType: 'Cuisine Type',
            invalidCuisineType: 'Invalid Cuisine Type',
            recipeList: 'Recipe List',
            all: 'All',
            submit: 'Submit',
            query: 'Query',
            missingRecipeID: 'Missing Recipe ID',
            recipeDifficulty: 'Difficulty',
            recipeTime: 'Time',
            recipeServings: 'Servings',
            recipeDeliciousness: 'Deliciousness',
            recipeRatings: 'Ratings',
            steps: 'Steps',
            tips: 'Tips',
            ingredients: 'Ingredients',
            ingredient: 'Ingredient',
            ingredientName: 'Ingredient Name',
            ingredientDescription: 'Ingredient Description',
            ingredientPricing: 'Ingredient Pricing',
            ingredientTips: 'Ingredient Tips',
            ingredientAmount: 'Ingredient Amount',
            ingredientUnit: 'Ingredient Unit',
            tools: 'Tools',
            tool: 'Tool',
            toolName: 'Tool Name',
            toolDescription: 'Tool Description',
            toolPricing: 'Tool Pricing',
            toolTips: 'Tool Tips',
            toolAmount: 'Tool Amount',
            toolUnit: 'Tool Unit',
            toolQualifierNone: 'No qualifier',
            toolQualifierPreheated: 'Preheated',
            toolQualifierChilled: 'Chilled',
            toolQualifierGreased: 'Greased',
            toolQualifierLined: 'Lined',
            toolQualifierCovered: 'Covered',
            editRecipe: 'Edit Recipe',
            createRecipe: 'Create Recipe',
            deleteRecipe: 'Delete Recipe',
            confirmDeleteRecipe: 'Are you sure you want to delete this recipe?',
            recipeDetail: 'Recipe Detail',
            recipeName: 'Recipe Name',
            recipeDescription: 'Recipe Description',
            recipeSteps: 'Recipe Steps',
            recipeTips: 'Recipe Tips',
            estimatedTime: 'Estimated Time',
            selectRecipeToPreview: 'Select a recipe to preview',
            recipeNotFound: 'Recipe not found',
            recipeSaved: 'Recipe saved',
            recipeDeleted: 'Recipe deleted',
            saveRecipe: 'Save Recipe',
            saveIngredients: 'Save Ingredients',
            saveTools: 'Save Tools',
            editIngredients: 'Edit Ingredients',
            editTools: 'Edit Tools',
            editIngredientsAssociated: 'Edit ingredients associated',
            editToolsAssociated: 'Edit tools associated',
            deleteThisRecipe: 'Delete this recipe',
            editThisRecipe: 'Edit this recipe',
            ingredientsManagement: 'Ingredients Management',
            toolsManagement: 'Tools Management',
            addIngredient: 'Add Ingredient',
            addTool: 'Add Tool',
            deleteThisIngredient: 'Delete this ingredient',
            deleteThisTool: 'Delete this tool',
            confirmDeleteIngredient: 'Are you sure you want to delete this ingredient?',
            confirmDeleteTool: 'Are you sure you want to delete this tool?',
            ingredientSaved: 'Ingredient saved',
            toolSaved: 'Tool saved',
            ingredientDeleted: 'Ingredient deleted',
            toolDeleted: 'Tool deleted',
            amount: 'Amount',
            unit: 'Unit',
            action: 'Action',
            minutes: 'minutes',
            noRecipeIDProvided: 'No recipe ID provided',
            manageIngredients: 'Manage Ingredients',
            manageTools: 'Manage Tools',
            manageCuisineTypes: 'Manage Cuisine Types',
            cookingWelcome: 'Welcome to the Cooking page!',
            cookingDescription: 'Here you can browse and manage your recipes!',
            rateRecipe: 'Rate Recipe',
            rateIngredient: 'Rate Ingredient',
            rateTool: 'Rate Tool',
            yourRating: 'Your Rating',
            rateThisRecipe: 'Rate This Recipe',
            rateThisIngredient: 'Rate This Ingredient',
            rateThisTool: 'Rate This Tool',
            cookingSearchTitle: 'Search cooking items',
            cookingSearchDescription: 'Search for recipes, ingredients, tools, and cuisine types here',
            noResultsFound: 'No results found',
            tryDifferentSearch: 'Try a different search term',
            searchDescription: 'Find recipes, ingredients, tools, and cuisine types from one place.',
            searchTip: 'Tip: search by keyword, email, or ID',
            searchFailed: 'Search failed',
            clear: 'Clear',
            ingredientsDescription: 'Search, rate, and manage ingredients with quick add and inline edits.',
            quickAdd: 'Quick add',
            items: 'items',
            rated: 'rated',
            noIngredientsMatchFilters: 'No ingredients match your filters.',
            asc: 'Asc',
            desc: 'Desc',
            failedToSaveIngredient: 'Failed to save ingredient',
            failedToDeleteIngredient: 'Failed to delete ingredient',
            toolsDescription: 'Keep your equipment catalog searchable, rateable, and easy to edit.',
            noToolsMatchFilters: 'No tools match your filters.',
            failedToSaveTool: 'Failed to save tool',
            failedToDeleteTool: 'Failed to delete tool',
            recipeListDescription: 'Browse, search, and filter recipes with quick access to cuisine tags.',
            noRecipesFound: 'No recipes found',
            adjustSearchOrClearFilters: 'Try adjusting your search or clearing filters.',
            resetFilters: 'Reset filters',
            searchRecipesPlaceholder: 'Search recipes, ingredients, or notes',
            reset: 'Reset',
            readyToExploreRecipes: 'Ready to explore new recipes',
            adminDashboard: 'Admin dashboard',
            quickEdit: 'Quick edit',
            searchUsersAdjustRatings: 'Search users, adjust their ratings, and review recent feedback without leaving this page.',
            searchUsers: 'Search users',
            unableToLoadPreferences: 'Unable to load preferences',
            failedToLoadAdminPreferences: 'Failed to load admin preferences',
            failedToRefreshAdminPreferences: 'Failed to refresh admin preferences',
            failedToLoadUserPreferences: 'Failed to load user preferences',
            editorDescription: 'Keep recipes organized with consistent metadata, rich steps, and reusable ingredients/tools.',
            metadata: 'Metadata',
            recipeMetadata: 'Recipe metadata',
            recipeMetadataDescription: 'Recipe details, cover, timing, and scoring.',
            basics: 'Basics',
            requiredFields: 'Required fields',
            coverImage: 'Cover Image',
            coverImageHint: 'Use a 3:2 photo for best presentation.',
            details: 'Details',
            timingServingsScoring: 'Timing, servings, and scoring',
            method: 'Method',
            methodHint: 'Use Markdown for steps and tips',
            blockText: 'Text',
            blockHeading1: 'Heading 1',
            blockHeading2: 'Heading 2',
            blockQuote: 'Quote',
            blockBulletList: 'Bullet list',
            blockNumberedList: 'Numbered list',
            blockImage: 'Image',
            blockPlaceholderHeading: 'Heading',
            blockPlaceholderSubheading: 'Subheading',
            blockPlaceholderQuote: 'Quote',
            blockPlaceholderListItem: 'List item',
            blockPlaceholderMethod: 'Write method',
            addBlock: 'Add block',
            addImageUnderListItem: 'Add image under item',
            nestUnderPreviousListItem: 'Nest under previous item',
            detachFromListItem: 'Detach from list item',
            dragBlock: 'Drag block',
            blockMenu: 'Block menu',
            moveBlockUp: 'Move up',
            moveBlockDown: 'Move down',
            deleteBlock: 'Delete block',
            ingredientReference: 'Ingredient reference',
            toolReference: 'Tool reference',
            closeReferenceMenu: 'Close reference menu',
            quantity: 'Qty',
            qualifier: 'Qualifier',
            imagePathPlaceholder: 'Image path, e.g. cooking/example.webp',
            altText: 'Alt text',
            caption: 'Caption',
            references: 'References',
            referenceNone: 'None',
            completeRecipeMetadataBeforeSaving: 'Please complete recipe metadata before saving.',
            shoppingListHint: 'Build the shopping list with quick search.',
            noIngredientsAddedYet: 'No ingredients added yet.',
            searchIngredients: 'Search ingredients',
            trackEquipmentHint: 'Track required equipment for the recipe.',
            noToolsAddedYet: 'No tools added yet.',
            searchTools: 'Search tools',
            selectIngredientToEdit: 'Select an ingredient from the catalog to edit it.',
            selectToolToEdit: 'Select a tool from the catalog to edit it.',
            noResults: 'No results',
            pleaseSelectIngredientForRow: 'Please select an ingredient for each row.',
            pleaseSelectToolForRow: 'Please select a tool for each row.',
            failedToLoadCuisineTypes: 'Failed to load cuisine types',
            failedToLoadIngredients: 'Failed to load ingredients',
            failedToLoadTools: 'Failed to load tools',
            failedToLoadRecipes: 'Failed to load recipes',
            failedToCreateIngredient: 'Failed to create ingredient',
            failedToCreateTool: 'Failed to create tool',
            adminTitle: 'Cooking Administration',
            adminDescription: 'Dedicated workspace for admins to curate recipes, tags, ingredients, and tools without affecting the guest-facing browsing experience.',
            adminRecipesDescription: 'Create, edit, and delete recipes including ingredients and tools.',
            adminCuisineTypesDescription: 'Manage tags / cuisine categories used for grouping recipes.',
            adminIngredientsDescription: 'Keep ingredient catalog clean with pricing and tips.',
            adminToolsDescription: 'Maintain tools library and their notes.',
            manageTitle: 'Manage {0}',
            goToTitle: 'Go to {0}',
            accessDenied: 'Access denied',
            accessDeniedMessage: 'Access denied. Cooking editor permission required.',
            adminRoleRequired: 'Cooking editor permission or Super Admin role is required.',
            cookingAdmin: 'Cooking Admin',
            adminArea: 'Admin Area',
            cookingDashboard: 'Cooking Dashboard',
            dashboard: 'Dashboard',
            recipes: 'Recipes',
            cuisineTypes: 'Cuisine Types',
            cuisineTypesTags: 'Cuisine Types / Tags',
            cuisineTypesDescription: 'Maintain the taxonomy used by recipes for filtering and discovery.',
            newType: 'New type',
            failedToDeleteCuisineType: 'Failed to delete cuisine type',
            failedToSaveCuisineType: 'Failed to save cuisine type',
            deleteCuisineType: 'Delete this cuisine type?',
            editCuisineType: 'Edit cuisine type',
            newCuisineType: 'New cuisine type',
            noCuisineTypesFound: 'No cuisine types found.',
            ingredientsAdminDescription: 'Central place to add, edit, or delete ingredients used by recipes.',
            editIngredient: 'Edit ingredient',
            deleteIngredient: 'Delete this ingredient?',
            sortBy: 'Sort by',
            optionalTips: 'Optional tips',
            saving: 'Saving…',
            createIngredient: 'Create ingredient',
            recipeManagement: 'Recipe Management',
            recipeManagementDescription: 'Keep the recipe catalog tidy; edits here will not impact the guest-facing browsing flow.',
            newRecipe: 'New Recipe',
            allCuisines: 'All cuisines',
            deleteRecipeConfirm: 'Delete this recipe?',
            recipeDeletedSuccess: 'Recipe deleted',
            failedToDeleteRecipe: 'Failed to delete recipe',
            viewRecipeAction: 'View',
            editRecipeAction: 'Edit',
            deleteRecipeAction: 'Delete',
            noRecipesFoundAdmin: 'No recipes found.',
            recipeEditAdminDescription: 'Changes save directly to the catalog; use cautiously.',
            backToList: 'Back to list',
            viewPublicPage: 'View public page',
            toolsAdminDescription: 'Manage tools library used across recipes.',
            editTool: 'Edit tool',
            deleteTool: 'Delete this tool?',
            createTool: 'Create tool',
            cookingWidget: 'Cooking',
            noCookingRecords: 'No cooking records yet.',
            updatePreference: 'Update Preference',
            catalogEditAccess: 'Cooking catalog editor',
            catalogEditAccessDescription: 'Can create, edit, and delete cooking catalog entries. This does not allow viewing or changing other users\' preferences.',
            catalogEditor: 'Cooking editor',
            catalogEditorRequired: 'Cooking editor permission or Super Admin role is required.'
        },
        'zh-CN': {
            cooking: '烹饪',
            cuisineType: '菜系',
            invalidCuisineType: '非法菜系',
            recipeList: '食谱列表',
            all: '全部',
            submit: '提交',
            query: '查询',
            missingRecipeID: '缺少食谱 ID',
            recipeDifficulty: '困难程度',
            recipeTime: '烹饪时间',
            recipeServings: '份量',
            recipeDeliciousness: '美味程度',
            recipeRatings: '评分',
            steps: '步骤',
            tips: '提示',
            ingredients: '配料',
            ingredient: '配料',
            ingredientName: '配料名称',
            ingredientDescription: '配料描述',
            ingredientPricing: '配料价格',
            ingredientTips: '配料提示',
            ingredientAmount: '配料数量',
            ingredientUnit: '配料单位',
            tools: '工具',
            tool: '工具',
            toolName: '工具名称',
            toolDescription: '工具描述',
            toolPricing: '工具价格',
            toolTips: '工具提示',
            toolAmount: '工具数量',
            toolUnit: '工具单位',
            toolQualifierNone: '无状态',
            toolQualifierPreheated: '已预热',
            toolQualifierChilled: '已冷藏',
            toolQualifierGreased: '已抹油',
            toolQualifierLined: '已垫纸',
            toolQualifierCovered: '已加盖',
            editRecipe: '编辑食谱',
            createRecipe: '创建食谱',
            deleteRecipe: '删除食谱',
            confirmDeleteRecipe: '你确定要删除此食谱吗？',
            recipeDetail: '食谱详情',
            recipeName: '食谱名称',
            recipeDescription: '食谱描述',
            recipeSteps: '制作步骤',
            recipeTips: '小贴士',
            estimatedTime: '预计时间',
            selectRecipeToPreview: '选择一个食谱进行预览',
            recipeNotFound: '食谱未找到',
            recipeSaved: '食谱已保存',
            recipeDeleted: '食谱已删除',
            saveRecipe: '保存食谱',
            saveIngredients: '保存配料',
            saveTools: '保存工具',
            editIngredients: '编辑配料',
            editTools: '编辑工具',
            editIngredientsAssociated: '编辑关联配料',
            editToolsAssociated: '编辑关联工具',
            deleteThisRecipe: '删除此食谱',
            editThisRecipe: '编辑此食谱',
            ingredientsManagement: '配料管理',
            toolsManagement: '工具管理',
            addIngredient: '添加配料',
            addTool: '添加工具',
            deleteThisIngredient: '删除此配料',
            deleteThisTool: '删除此工具',
            confirmDeleteIngredient: '你确定要删除此配料吗？',
            confirmDeleteTool: '你确定要删除此工具吗？',
            ingredientSaved: '配料已保存',
            toolSaved: '工具已保存',
            ingredientDeleted: '配料已删除',
            toolDeleted: '工具已删除',
            amount: '数量',
            unit: '单位',
            action: '操作',
            minutes: '分钟',
            noRecipeIDProvided: '未提供食谱 ID',
            manageIngredients: '管理配料',
            manageTools: '管理工具',
            manageCuisineTypes: '管理菜系',
            cookingWelcome: '欢迎来到烹饪页面！',
            cookingDescription: '在这里你可以浏览和管理食谱！',
            rateRecipe: '评价食谱',
            rateIngredient: '评价配料',
            rateTool: '评价工具',
            yourRating: '您的评分',
            rateThisRecipe: '评价此食谱',
            rateThisIngredient: '评价此配料',
            rateThisTool: '评价此工具',
            cookingSearchTitle: '搜索烹饪项目',
            cookingSearchDescription: '在这里搜索食谱、配料、工具和菜系',
            noResultsFound: '未找到结果',
            tryDifferentSearch: '尝试不同的搜索词',
            searchDescription: '在这里搜索食谱、配料、工具和菜系',
            searchTip: '提示：按关键词、邮箱或 ID 搜索',
            searchFailed: '搜索失败',
            clear: '清除',
            ingredientsDescription: '搜索、评分和管理配料，支持快速添加和行内编辑。',
            quickAdd: '快速添加',
            items: '项',
            rated: '已评分',
            noIngredientsMatchFilters: '没有符合筛选条件的配料。',
            asc: '升序',
            desc: '降序',
            failedToSaveIngredient: '保存配料失败',
            failedToDeleteIngredient: '删除配料失败',
            toolsDescription: '管理你的设备目录，支持搜索、评分和编辑。',
            noToolsMatchFilters: '没有符合筛选条件的工具。',
            failedToSaveTool: '保存工具失败',
            failedToDeleteTool: '删除工具失败',
            recipeListDescription: '浏览、搜索和筛选食谱，快速访问菜系标签。',
            noRecipesFound: '未找到食谱',
            adjustSearchOrClearFilters: '请尝试调整搜索条件或清除筛选器。',
            resetFilters: '重置筛选',
            searchRecipesPlaceholder: '搜索食谱、配料或笔记',
            reset: '重置',
            readyToExploreRecipes: '准备好探索新食谱了',
            adminDashboard: '管理面板',
            quickEdit: '快速编辑',
            searchUsersAdjustRatings: '搜索用户、调整评分并查看最近的反馈，无需离开此页面。',
            searchUsers: '搜索用户',
            unableToLoadPreferences: '无法加载偏好设置',
            failedToLoadAdminPreferences: '加载管理员偏好失败',
            failedToRefreshAdminPreferences: '刷新管理员偏好失败',
            failedToLoadUserPreferences: '加载用户偏好失败',
            editorDescription: '保持食谱的元数据一致、步骤丰富、配料和工具可复用。',
            metadata: '元数据',
            recipeMetadata: '食谱元数据',
            recipeMetadataDescription: '食谱详情、封面、时间和评分。',
            basics: '基础信息',
            requiredFields: '必填字段',
            coverImage: '封面图片',
            coverImageHint: '使用 3:2 比例的照片效果最佳。',
            details: '详细信息',
            timingServingsScoring: '时间、份量和评分',
            method: '制作方法',
            methodHint: '使用 Markdown 编写步骤和提示',
            blockText: '正文',
            blockHeading1: '一级标题',
            blockHeading2: '二级标题',
            blockQuote: '引用',
            blockBulletList: '无序列表',
            blockNumberedList: '有序列表',
            blockImage: '图片',
            blockPlaceholderHeading: '标题',
            blockPlaceholderSubheading: '副标题',
            blockPlaceholderQuote: '引用',
            blockPlaceholderListItem: '列表项',
            blockPlaceholderMethod: '写下制作方法',
            addBlock: '添加块',
            addImageUnderListItem: '在列表项下添加图片',
            nestUnderPreviousListItem: '嵌入上一列表项',
            detachFromListItem: '从列表项分离',
            dragBlock: '拖动块',
            blockMenu: '块菜单',
            moveBlockUp: '上移',
            moveBlockDown: '下移',
            deleteBlock: '删除块',
            ingredientReference: '配料引用',
            toolReference: '工具引用',
            closeReferenceMenu: '关闭引用菜单',
            quantity: '数量',
            qualifier: '限定',
            imagePathPlaceholder: '图片路径，例如 cooking/example.webp',
            altText: '替代文本',
            caption: '说明',
            references: '引用预览',
            referenceNone: '无',
            completeRecipeMetadataBeforeSaving: '保存前请先补全食谱元数据。',
            shoppingListHint: '通过快速搜索构建购物清单。',
            noIngredientsAddedYet: '尚未添加配料。',
            searchIngredients: '搜索配料',
            trackEquipmentHint: '跟踪食谱所需的设备。',
            noToolsAddedYet: '尚未添加工具。',
            searchTools: '搜索工具',
            selectIngredientToEdit: '从目录中选择一个配料进行编辑。',
            selectToolToEdit: '从目录中选择一个工具进行编辑。',
            noResults: '无结果',
            pleaseSelectIngredientForRow: '请为每一行选择一个配料。',
            pleaseSelectToolForRow: '请为每一行选择一个工具。',
            failedToLoadCuisineTypes: '加载菜系失败',
            failedToLoadIngredients: '加载配料失败',
            failedToLoadTools: '加载工具失败',
            failedToLoadRecipes: '加载食谱失败',
            failedToCreateIngredient: '创建配料失败',
            failedToCreateTool: '创建工具失败',
            adminTitle: '烹饪管理',
            adminDescription: '管理员专用工作区，用于管理食谱、标签、配料和工具，不影响访客浏览体验。',
            adminRecipesDescription: '创建、编辑和删除食谱，包括配料和工具。',
            adminCuisineTypesDescription: '管理用于食谱分组的标签和菜系分类。',
            adminIngredientsDescription: '维护配料目录，包括价格和提示。',
            adminToolsDescription: '维护工具库及其备注。',
            manageTitle: '管理{0}',
            goToTitle: '前往{0}',
            accessDenied: '访问被拒绝',
            accessDeniedMessage: '访问被拒绝。需要烹饪目录编辑权限。',
            adminRoleRequired: '需要烹饪目录编辑权限或超级管理员角色。',
            cookingAdmin: '烹饪管理',
            adminArea: '管理区域',
            cookingDashboard: '烹饪仪表板',
            dashboard: '仪表板',
            recipes: '食谱',
            cuisineTypes: '菜系',
            cuisineTypesTags: '菜系 / 标签',
            cuisineTypesDescription: '维护食谱用于筛选和发现的分类体系。',
            newType: '新建类型',
            failedToDeleteCuisineType: '删除菜系失败',
            failedToSaveCuisineType: '保存菜系失败',
            deleteCuisineType: '确定要删除此菜系吗？',
            editCuisineType: '编辑菜系',
            newCuisineType: '新建菜系',
            noCuisineTypesFound: '未找到菜系。',
            ingredientsAdminDescription: '添加、编辑或删除食谱使用的配料的中心位置。',
            editIngredient: '编辑配料',
            deleteIngredient: '确定要删除此配料吗？',
            sortBy: '排序方式',
            optionalTips: '可选提示',
            saving: '保存中…',
            createIngredient: '创建配料',
            recipeManagement: '食谱管理',
            recipeManagementDescription: '保持食谱目录整洁；此处的编辑不会影响访客浏览流程。',
            newRecipe: '新建食谱',
            allCuisines: '所有菜系',
            deleteRecipeConfirm: '确定要删除此食谱吗？',
            recipeDeletedSuccess: '食谱已删除',
            failedToDeleteRecipe: '删除食谱失败',
            viewRecipeAction: '查看',
            editRecipeAction: '编辑',
            deleteRecipeAction: '删除',
            noRecipesFoundAdmin: '未找到食谱。',
            recipeEditAdminDescription: '更改直接保存到目录；请谨慎操作。',
            backToList: '返回列表',
            viewPublicPage: '查看公开页面',
            toolsAdminDescription: '管理食谱中使用的工具库。',
            editTool: '编辑工具',
            deleteTool: '确定要删除此工具吗？',
            createTool: '创建工具',
            cookingWidget: '烹饪',
            noCookingRecords: '暂无烹饪记录。',
            updatePreference: '更新偏好',
            catalogEditAccess: '烹饪目录编辑权限',
            catalogEditAccessDescription: '可创建、编辑和删除烹饪目录内容，但不能查看或修改其他用户的偏好。',
            catalogEditor: '烹饪编辑者',
            catalogEditorRequired: '需要烹饪目录编辑权限或超级管理员角色。'
        }
    } as Record<string, Record<CookingModuleKeys, string>>,
    admin: {
        'en-US': {
            adminArea: 'Admin Area',
            userManagement: 'User Management',
            userManagementDescription: 'View and manage all user accounts, roles, security settings, and linked contacts.',
            accessDenied: 'Access denied',
            accessDeniedAdmin: 'Access denied. Admin permission required.',
            accessDeniedSuperAdmin: 'Access denied. Super admin privileges required.',
            adminRoleRequired: 'Admin or Super Admin role is required.',
            superAdminRoleRequired: 'Super Admin role is required.',
            totalUsers: 'Total Users',
            admins: 'Admins',
            otpEnabled: 'OTP Enabled',
            newUsers7d: 'New (7d)',
            failedToLoadUsers: 'Failed to load users',
            preferencesAdminTitle: 'Preferences Administration',
            preferencesAdminDescription: 'Super admin tools for managing user preferences across recipes, ingredients, and tools.',
            userPreferences: 'User Preferences',
            userPreferencesDescription: 'View and manage user preferences across recipes, ingredients, and tools.',
            userPreferencesHint: 'Use the search functionality below to find users and manage their preferences.',
            itemPreferences: 'Item Preferences',
            itemPreferencesDescription: 'View preferences for specific recipes, ingredients, or tools by browsing the respective sections.',
            itemPreferencesHint: 'Navigate to Recipes, Ingredients, or Tools sections to view and manage preferences.',
            searchUsersAndPreferences: 'Search Users & Add Preferences',
            searchUsersAndPreferencesDescription: 'Search for users by name, email, or ID, then view and manage their preferences inline.',
            quickActions: 'Quick Actions',
            browseRecipes: 'Browse Recipes',
            browseRecipesDescription: 'View all recipes',
            browseIngredients: 'Browse Ingredients',
            browseIngredientsDescription: 'View all ingredients',
            browseTools: 'Browse Tools',
            browseToolsDescription: 'View all tools',
            userRole: 'User Role',
            user: 'User',
            admin: 'Admin',
            superAdmin: 'Super Admin',
            visitor: 'Visitor',
            preferencesManagement: 'Preferences Management'
        },
        'zh-CN': {
            adminArea: '管理区域',
            userManagement: '用户管理',
            userManagementDescription: '查看和管理所有用户账户、角色、安全设置和关联联系人。',
            accessDenied: '访问被拒绝',
            accessDeniedAdmin: '访问被拒绝。需要管理员权限。',
            accessDeniedSuperAdmin: '访问被拒绝。需要超级管理员权限。',
            adminRoleRequired: '需要管理员或超级管理员角色。',
            superAdminRoleRequired: '需要超级管理员角色。',
            totalUsers: '总用户数',
            admins: '管理员',
            otpEnabled: '已启用 OTP',
            newUsers7d: '近 7 天新增',
            failedToLoadUsers: '加载用户失败',
            preferencesAdminTitle: '偏好管理',
            preferencesAdminDescription: '超级管理员工具，用于管理用户在食谱、配料和工具方面的偏好。',
            userPreferences: '用户偏好',
            userPreferencesDescription: '查看和管理用户在食谱、配料和工具方面的偏好。',
            userPreferencesHint: '使用下方搜索功能查找用户并管理其偏好。',
            itemPreferences: '项目偏好',
            itemPreferencesDescription: '通过浏览相应部分查看特定食谱、配料或工具的偏好。',
            itemPreferencesHint: '前往食谱、配料或工具部分查看和管理偏好。',
            searchUsersAndPreferences: '搜索用户并添加偏好',
            searchUsersAndPreferencesDescription: '按姓名、邮箱或 ID 搜索用户，然后在页面内查看和管理其偏好。',
            quickActions: '快捷操作',
            browseRecipes: '浏览食谱',
            browseRecipesDescription: '查看所有食谱',
            browseIngredients: '浏览配料',
            browseIngredientsDescription: '查看所有配料',
            browseTools: '浏览工具',
            browseToolsDescription: '查看所有工具',
            userRole: '用户角色',
            user: '用户',
            admin: '管理员',
            superAdmin: '超级管理员',
            visitor: '访客',
            preferencesManagement: '偏好管理'
        }
    } as Record<string, Record<AdminModuleKeys, string>>,
    app: {
        'en-US': {
            name: 'Name',
            description: 'Description',
            cancel: 'Cancel',
            confirm: 'Confirm',
            confirmTitle: 'Please confirm',
            save: 'Save',
            delete: 'Delete',
            edit: 'Edit',
            search: 'Search',
            submit: 'Submit',
            close: 'Close',
            add: 'Add',
            remove: 'Remove',
            update: 'Update',
            select: 'Select',
            clear: 'Clear',
            loading: 'Loading',
            error: 'Error',
            retry: 'Retry',
            done: 'DONE',
            back: 'Back',
            change: 'Change',
            view: 'View',
            pick: 'Pick',
            operations: 'Actions',
            refresh: 'Refresh',
            id: 'ID',
            tags: 'Tags',
            unknown: 'Unknown',
            any: 'Any',
            optional: 'Optional',
            color: 'Color',
            path: 'Path',
            content: 'Content',
            appName: 'Hoarfroster',
            copyright: '© 2025 Hoarfroster, All Rights Reserved',
            goBack: 'Go Back',
            home: 'Home',
            notFound: 'Page Not Found',
            notFoundWelcome: 'Sorry, we couldn\'t find that page...',
            notFoundDescription: 'Here are some helpful links instead:',
            previousPage: 'Previous Page',
            nextPage: 'Next Page',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            pricing: 'Pricing',
            showingEntries: 'Showing',
            toEntries: 'to',
            ofTotal: 'of',
            totalEntries: 'entries',
            errorOccurred: 'An error occurred',
            pinned: 'Pinned',
            previewMode: 'Preview Mode',
            editMode: 'Edit Mode',
            folder: 'Folder',
            document: 'Document',
            avatar: 'Profile Avatar',
            coverImage: 'Cover Image',
            selectCoverImage: 'Select Cover Image',
            uploadNewImage: 'Upload New Image',
            noImagesFound: 'No images found',
            clickToUploadFile: 'Click to upload file',
            reselectFile: 'Reselect file',
            uploadFailed: 'Upload failed',
            fileSizeLimit: 'File size limit exceeded',
            supportedFormats: 'Supported Formats',
            fileName: 'File Name',
            size: 'Size',
            fileType: 'File Type',
            bytes: 'bytes',
            kb: 'KB',
            mb: 'MB',
            gb: 'GB',
            download: 'Download',
            reupload: 'Re-upload',
            fileDoesNotExist: 'File does not exist',
            public: 'Public',
            private: 'Private',
            protected: 'Protected',
            shared: 'Shared',
            visibility: 'Visibility',
            visibilityPublicDescription: 'Visible to everyone.',
            visibilityProtectedDescription: 'Visible to signed-in users.',
            visibilityPrivateDescription: 'Visible only to you.',
            visibilitySharedDescription: 'Visible only to selected users.',
            preferences: 'Preferences',
            preferencesDescription: 'The application\'s preferences and session information will be stored in the browser\'s localStorage without encryption. Please use this application only on trusted devices.',
            rate: 'Rate',
            rating: 'Rating',
            pleaseSelectRating: 'Please select a rating',
            preferenceSaved: 'Preference Saved',
            preferenceDeleted: 'Preference Deleted',
            errorSavingPreference: 'Error saving preference',
            errorDeletingPreference: 'Error deleting preference',
            confirmDeletePreference: 'Are you sure you want to delete this preference?',
            noPreferenceSet: 'No preference set',
            setYourPreference: 'Set Your Preference',
            addRemarks: 'Add Remarks',
            remarks: 'Remarks',
            homeWelcome: 'Welcome Home!',
            homeDescription: 'Welcome to Hoarfroster\'s Space! You may read various learning notes and recipes here!',
            homeNoteDescription: 'Fastest links to notes!',
            homeCookingDescription: 'Eating, especially eating delicious food made by yourself, is really intoxicating! Why not go and see if there are any interesting recipes!',
            cooking: 'Cooking',
            contacts: 'Contacts',
            files: 'Files',
            credentials: 'Credentials',
            activities: 'Activities',
            moments: 'Moments',
            recipeList: 'Recipe List',
            createRecipe: 'Create Recipe',
            ingredients: 'Ingredients',
            tools: 'Tools',
            fileList: 'File List',
            fileTag: 'File Tags',
            timeActivity: 'Activity',
            profileSettings: 'Profile Settings',
            securitySettings: 'Security Settings',
            languageSettings: 'Language Settings',
            themeColor: 'Theme Color',
            followSystemTheme: 'Follow System Theme',
            settings: 'Settings',
            open: 'Open',
            timeline: 'Timeline',
            actions: 'Actions',
            favourite: 'Favourite',
            failedToLoadUsers: 'Failed to load users',
            errorHappened: 'An error occurred!',
            userRole: 'User Role',
            admin: 'Admin',
            contact: 'Contact',
            note: 'Note',
            file: 'File',
            moment: 'Moment',
            remark: 'Remark',
            collections: 'Collections',
            activityBoard: 'Activity Board',
            calendar: 'Calendar',
            recipes: 'Recipes',
            exploreNotes: 'Explore Notes',
            exploreCooking: 'Explore Cooking',
            manageFiles: 'Manage Files',
            timeAndActivity: 'Time & Activity',
            userManagement: 'User Management',
            livePhotoUpload: 'Live Photo Upload',
            selectPlaceholder: 'Please select...',
            noEventsToday: 'No events today',
            noUpcomingBirthdays: 'No upcoming birthdays',
            date: 'Date',
            birthday: 'Birthday',
            configureShortcut: 'Configure shortcut',
            shortcut: 'Shortcut',
            reference: 'Reference',
            shortcuts: 'Shortcuts',
            macros: 'Macros',
            key: 'Key',
            action: 'Action',
            signature: 'Signature',
            expansion: 'Expansion',
            args: 'Args',
            editorReferenceShortcutsEditing: 'Editing',
            editorReferenceShortcutsDrafts: 'Drafts',
            editorReferenceMathJaxGeneral: 'General',
            editorReferenceMathJaxConcreteMathematics: 'Concrete Mathematics',
            editorReferenceMathJaxLinearAlgebra: 'Linear Algebra',
            editorReferenceMathJaxCalculus: 'Calculus',
            editorReferenceMathJaxLogic: 'Logic',
            editorReferenceMathJaxUnitsAndValues: 'Units and Values',
            editorReferenceMathJaxOperators: 'Operators',
            editorReferenceShortcutInsertTab: 'Insert tab',
            editorReferenceShortcutBold: 'Bold',
            editorReferenceShortcutItalic: 'Italic',
            editorReferenceShortcutMath: 'Math',
            editorReferenceShortcutCode: 'Code',
            editorReferenceShortcutSaveDraft: 'Save draft',
            editorReferenceShortcutOpenDrafts: 'Open drafts',
            configure: 'Configure',
            holiday: 'Holiday',
            workday: 'Workday',
            viewAllResults: 'View all results',
            jumpTo: 'Jump to',
            pressEnterToSearch: 'Press Enter to search',
            noResults: 'No results',
            colorSlate: 'Slate',
            colorBlue: 'Blue',
            colorIndigo: 'Indigo',
            colorViolet: 'Violet',
            colorRose: 'Rose',
            colorRed: 'Red',
            colorOrange: 'Orange',
            colorAmber: 'Amber',
            colorLime: 'Lime',
            colorGreen: 'Green',
            colorTeal: 'Teal',
            colorCyan: 'Cyan',
            colorCustom: 'Current color'
        },
        'zh-CN': {
            name: '名称',
            description: '描述',
            cancel: '取消',
            confirm: '确认',
            confirmTitle: '请确认',
            save: '保存',
            delete: '删除',
            edit: '编辑',
            search: '搜索',
            submit: '提交',
            close: '关闭',
            add: '添加',
            remove: '移除',
            update: '更新',
            select: '选择',
            clear: '清除',
            loading: '加载中',
            error: '错误',
            retry: '重试',
            done: '已完成',
            back: '返回',
            change: '更改',
            view: '查看',
            pick: '选择',
            operations: '操作',
            refresh: '刷新',
            id: 'ID',
            tags: '标签',
            unknown: '未知',
            any: '任意',
            optional: '可选',
            color: '颜色',
            path: '路径',
            content: '内容',
            appName: '烤鹅普拉斯',
            copyright: '© 2025 Hoarfroster，版权所有',
            goBack: '返回',
            home: '首页',
            notFound: '页面不存在',
            notFoundWelcome: '太难过了，这个页面不见了啊！！！',
            notFoundDescription: '下面是一些可能有些用的链接？',
            previousPage: '前一页',
            nextPage: '后一页',
            createdAt: '创建时间',
            updatedAt: '更新时间',
            pricing: '价格',
            showingEntries: '显示第',
            toEntries: '到',
            ofTotal: '条，共',
            totalEntries: '条记录',
            errorOccurred: '发生错误',
            pinned: '置顶',
            previewMode: '预览模式',
            editMode: '编辑模式',
            folder: '文件夹',
            document: '文档',
            avatar: '个人头像',
            coverImage: '封面图片',
            selectCoverImage: '选择封面图片',
            uploadNewImage: '上传新图片',
            noImagesFound: '未找到图片',
            clickToUploadFile: '点击上传文件',
            reselectFile: '重新选择文件',
            uploadFailed: '上传失败',
            fileSizeLimit: '文件大小超限',
            supportedFormats: '支持的格式',
            fileName: '文件名',
            size: '大小',
            fileType: '文件类型',
            bytes: '字节',
            kb: 'KB',
            mb: 'MB',
            gb: 'GB',
            download: '下载',
            reupload: '重新上传',
            fileDoesNotExist: '文件不存在',
            public: '公开',
            private: '私有',
            protected: '受保护',
            shared: '共享',
            visibility: '可见性',
            visibilityPublicDescription: '所有人可见',
            visibilityProtectedDescription: '登录用户可见',
            visibilityPrivateDescription: '仅自己可见',
            visibilitySharedDescription: '仅指定用户可见',
            preferences: '偏好设置',
            preferencesDescription: '应用程序的偏好设置与会话信息将不经加密地存储于浏览器的 localStorage 中，请仅在你信任的设备上使用本应用程序',
            rate: '评分',
            rating: '评分',
            pleaseSelectRating: '请选择评分',
            preferenceSaved: '偏好已保存',
            preferenceDeleted: '偏好已删除',
            errorSavingPreference: '保存偏好失败',
            errorDeletingPreference: '删除偏好失败',
            confirmDeletePreference: '您确定要删除此偏好吗？',
            noPreferenceSet: '尚未设置偏好',
            setYourPreference: '设置您的偏好',
            addRemarks: '添加备注',
            remarks: '名句名言',
            homeWelcome: '欢迎大家来玩！',
            homeDescription: '欢迎来访烤鹅的小站，你可以在这里阅读各种 ta 的学习笔记和菜谱记录！',
            homeNoteDescription: '快速前往阅读笔记！',
            homeCookingDescription: '吃饭，尤其是吃自己做的好吃的美食，真的是一件很让人陶醉的事儿呢！不如前往看看有什么有意思的食谱叭！',
            cooking: '烹饪',
            contacts: '联系人',
            files: '文件',
            credentials: '凭据',
            activities: '活动',
            moments: '日志',
            recipeList: '食谱列表',
            createRecipe: '创建食谱',
            ingredients: '配料',
            tools: '工具',
            fileList: '文件列表',
            fileTag: '文件标签',
            timeActivity: '计划',
            profileSettings: '个人信息设置',
            securitySettings: '安全设置',
            languageSettings: '语言设置',
            themeColor: '主题颜色',
            followSystemTheme: '跟随系统主题',
            settings: '设置',
            open: '打开',
            timeline: '时间线',
            actions: '操作',
            favourite: '特别关注',
            failedToLoadUsers: '加载用户失败',
            errorHappened: '出错啦！',
            userRole: '用户角色',
            admin: '管理',
            contact: '联系人',
            note: '笔记',
            file: '文件',
            moment: '动态',
            remark: '名句名言',
            collections: '合集',
            activityBoard: '活动看板',
            calendar: '日历',
            recipes: '食谱',
            exploreNotes: '探索笔记',
            exploreCooking: '探索烹饪',
            manageFiles: '管理文件',
            timeAndActivity: '计划与活动',
            userManagement: '用户管理',
            livePhotoUpload: '实况照片上传',
            selectPlaceholder: '请选择...',
            noEventsToday: '今天没有活动',
            noUpcomingBirthdays: '没有即将到来的生日',
            date: '日期',
            birthday: '生日',
            configureShortcut: '配置快捷方式',
            shortcut: '快捷方式',
            reference: '参考',
            shortcuts: '快捷键',
            macros: '宏',
            key: '按键',
            action: '操作',
            signature: '签名',
            expansion: '展开',
            args: '参数',
            editorReferenceShortcutsEditing: '编辑',
            editorReferenceShortcutsDrafts: '草稿',
            editorReferenceMathJaxGeneral: '通用',
            editorReferenceMathJaxConcreteMathematics: '具体数学',
            editorReferenceMathJaxLinearAlgebra: '线性代数',
            editorReferenceMathJaxCalculus: '微积分',
            editorReferenceMathJaxLogic: '逻辑',
            editorReferenceMathJaxUnitsAndValues: '单位与数值',
            editorReferenceMathJaxOperators: '运算符',
            editorReferenceShortcutInsertTab: '插入制表符',
            editorReferenceShortcutBold: '加粗',
            editorReferenceShortcutItalic: '斜体',
            editorReferenceShortcutMath: '数学公式',
            editorReferenceShortcutCode: '代码',
            editorReferenceShortcutSaveDraft: '保存草稿',
            editorReferenceShortcutOpenDrafts: '打开草稿',
            configure: '配置',
            holiday: '休',
            workday: '班',
            viewAllResults: '查看全部结果',
            jumpTo: '前往',
            pressEnterToSearch: '按回车搜索',
            noResults: '无结果',
            colorSlate: '石板灰',
            colorBlue: '蓝色',
            colorIndigo: '靛蓝色',
            colorViolet: '紫罗兰色',
            colorRose: '玫红色',
            colorRed: '红色',
            colorOrange: '橙色',
            colorAmber: '琥珀色',
            colorLime: '青柠色',
            colorGreen: '绿色',
            colorTeal: '蓝绿色',
            colorCyan: '青色',
            colorCustom: '当前颜色'
        }
    } as Record<string, Record<AppModuleKeys, string>>,
    auth: {
        'en-US': {
            signIn: 'Sign In',
            signInSubTitle: 'My Friends',
            signInTitle: 'Sign In',
            signInDescription: 'Sign in to your account with your username and password!',
            signInAgreement: 'By clicking \'Sign In\', you agree to provide your account information for verification',
            signInSuccessful: 'Welcome back!',
            signInError: 'Sign In failed.',
            signInWith: 'Sign in with...',
            signInWithPasskey: 'Sign in with Passkey',
            signInWithMicrosoft: 'Sign in with Microsoft',
            signOut: 'Sign Out',
            signOutConfirmation: 'Are you sure you want to sign out?',
            register: 'Register',
            registerSubTitle: 'My Friends',
            registerTitle: 'Register',
            registerDescription: 'Create a new account with your email and register code!',
            registerSuccessful: 'You\'re in!',
            registerError: 'Registration failed.',
            registerAgreement: 'By clicking \'Register\', you agree to provide your input information for verification and registration',
            registerCode: 'Register Code',
            password: 'Password',
            email: 'Email',
            userName: 'Username',
            totpCode: 'TOTP Code',
            notHavingAccount: 'Don\'t have an account?',
            alreadyRegistered: 'Already Registered?',
            invalidSession: 'Invalid sign in session. A re-sign in is required.'
        },
        'zh-CN': {
            signIn: '登录',
            signInSubTitle: '我的朋友',
            signInTitle: '用户登录',
            signInDescription: '使用用户名和密码登录到你的帐户！',
            signInAgreement: '当点击"登录"时，表示你同意将你的账号信息提供给我们进行校验',
            signInSuccessful: '欢迎回来！',
            signInError: '登录失败',
            signInWith: '第三方快捷登录',
            signInWithPasskey: '使用 Passkey 登录',
            signInWithMicrosoft: '使用微软登录',
            signOut: '登出',
            signOutConfirmation: '你确定要登出吗？',
            register: '注册',
            registerSubTitle: '我的朋友',
            registerTitle: '用户注册',
            registerDescription: '使用电子邮箱和注册码创建一个新帐户！',
            registerSuccessful: '注册成功！',
            registerError: '注册失败',
            registerAgreement: '当点击"注册"时，表示你同意提供你的输入信息给我们进行校验与注册',
            registerCode: '注册码',
            password: '密码',
            email: '电子邮箱',
            userName: '用户名',
            totpCode: '动态口令',
            notHavingAccount: '还没有账号？',
            alreadyRegistered: '已经有了账号？',
            invalidSession: '登录会话无效，需要重新登录'
        }
    } as Record<string, Record<AuthModuleKeys, string>>,
    settings: {
        'en-US': {
            profile: 'Profile',
            updatePassword: 'Update Password',
            updatePasswordTitle: 'Update User Password',
            updatePasswordDescription: 'You should disable OTP verification before updating your password.',
            oldPassword: 'Old Password',
            newPassword: 'New Password',
            passwordUpdated: 'Password updated!',
            passwordRequired: 'Password is required.',
            manageTOTP: 'Manage TOTP',
            mfaTOTPTitle: 'MFA: Time-based One Time Password',
            editOTP: 'Edit OTP',
            totpDescription: 'TOTP (Time-based One Time Password) is a two-factor authentication method that generates a one-time password based on the current time and a shared secret key.',
            totpSecret: 'TOTP secret',
            totpSaved: 'TOTP has been updated.',
            totpQRCodeInstructions: 'Scan the QRCode below with your authenticator application to save the OTP secret.',
            totpVerifyInstructions: 'And verify if the code on your authenticator application matches the code below.',
            totpSaveError: 'Failed to save TOTP secret.',
            otpEnabled: 'TOTP enabled',
            otpDisabled: 'TOTP disabled',
            disableTotp: 'Disable TOTP',
            hideFooter: 'Hide Footer',
            hideFooterDescription: 'Hide the footer of the page',
            backgroundImagePath: 'Background Image Path',
            backgroundImagePathDescription: 'The path of background image for the application',
            locale: 'Locale',
            localeDescription: 'Select the display locale for the application',
            location: 'Location',
            bio: 'Bio',
            timeZone: 'Time Zone',
            socialAccounts: 'Social Accounts',
            userNotFound: 'User not found.',
            userInfo: 'User Information',
            userCenter: 'User Center',
            invalidSession: 'Invalid sign in session. A re-sign in is required.',
            username: 'Username',
            nothingToUpdate: 'Nothing to update.',
            updateSuccess: 'Profile updated successfully!',
            updateFailed: 'Failed to update profile.',
            comingSoon: 'Coming soon...',
            passkey: 'Passkey',
            passkeyDevices: 'Passkey Devices',
            noPasskeys: 'No passkey devices registered.',
            passkeyFallbackName: 'Passkey #{0}',
            passkeyItem: '{0} · Registered {1}',
            passkeyLastUsed: 'Last used {0}',
            passkeyDeviceName: 'Device name',
            passkeyDeviceNamePlaceholder: 'MacBook Touch ID',
            passkeyDeviceNameRequired: 'Enter a device name for this passkey.',
            renamePasskey: 'Rename passkey',
            passkeyRenamed: 'Passkey renamed.',
            passkeyRenameFailed: 'Failed to rename passkey.',
            removePasskey: 'Remove passkey',
            passkeyRemoveConfirm: 'Remove this passkey device?',
            passkeyRemoved: 'Passkey removed.',
            passkeyRemoveFailed: 'Failed to remove passkey.',
            registerNewPasskey: 'Register a New Passkey',
            registerPasskey: 'Register Passkey',
            registeringPasskey: 'Registering passkey…',
            passkeyRegistered: 'Passkey registered successfully!',
            passkeyRegisterFailed: 'Failed to register passkey.',
            mustSignInForPasskey: 'You must be signed in to register a passkey.',
            passwordUpdateFailed: 'Failed to update password.',
            loadProfileFailed: 'Unable to load user profile.',
            microsoftIntegration: 'Microsoft 365 Integration',
            microsoftIntegrationDescription: 'Link your Microsoft account to access email functionality.',
            microsoftConnectedAccount: 'Connected account: {0}',
            linkMicrosoft: 'Link Microsoft Account',
            disconnectMicrosoft: 'Disconnect Microsoft',
            microsoftDisconnected: 'Microsoft account disconnected.',
            microsoftAuthFailed: 'Failed to start Microsoft authorization.',
            microsoftDisconnectFailed: 'Failed to disconnect Microsoft account.',
            themeSettings: 'Theme Settings',
            followSystemThemeDescription: 'Automatically switch between light and dark themes based on your system preference.',
            backgroundImage: 'Background Image',
            backgroundImageDescription: 'Show decorative background image.',
            theme: 'Theme',
            socialAccountPlaceholder: 'Social account URL',
            cropAvatar: 'Crop Avatar',
            cropHint: 'Drag to move, use corner points to resize',
            cropConfirm: 'Confirm'
        },
        'zh-CN': {
            profile: '个人资料',
            updatePassword: '更新密码',
            updatePasswordTitle: '更新用户密码',
            updatePasswordDescription: '在更新密码之前，你应该先禁用 OTP 验证',
            oldPassword: '旧密码',
            newPassword: '新密码',
            passwordUpdated: '密码更新成功！',
            passwordRequired: '需要密码。',
            manageTOTP: '管理 TOTP',
            mfaTOTPTitle: '多因素认证：基于时间的一次性密码',
            editOTP: '编辑 OTP',
            totpDescription: 'TOTP（基于时间的一次性密码）是一种双因素认证方法，它基于当前时间和共享密钥生成一次性密码。',
            totpSecret: 'TOTP 密钥',
            totpSaved: 'TOTP 已经更改成功。',
            totpQRCodeInstructions: '使用你的身份验证应用扫描下方二维码以保存 OTP 密钥',
            totpVerifyInstructions: '并验证你的身份验证应用上的代码是否与下方代码匹配',
            totpSaveError: '保存 TOTP 密钥失败',
            otpEnabled: '已启用 TOTP',
            otpDisabled: '未启用 TOTP',
            disableTotp: '禁用 TOTP',
            hideFooter: '隐藏页脚',
            hideFooterDescription: '隐藏页面的页脚',
            backgroundImagePath: '背景图片路径',
            backgroundImagePathDescription: '应用程序的背景图片路径',
            locale: '语言',
            localeDescription: '选择应用程序的显示语言',
            location: '位置',
            bio: '个性签名',
            timeZone: '时区',
            socialAccounts: '社交账号',
            userNotFound: '用户未找到',
            userInfo: '用户信息',
            userCenter: '用户中心',
            invalidSession: '登录会话无效，需要重新登录',
            username: '用户名',
            nothingToUpdate: '没有需要更新的内容。',
            updateSuccess: '个人信息更新成功！',
            updateFailed: '个人信息更新失败。',
            comingSoon: '敬请期待...',
            passkey: '通行密钥',
            passkeyDevices: '通行密钥设备',
            noPasskeys: '尚未注册任何通行密钥设备。',
            passkeyFallbackName: '通行密钥 #{0}',
            passkeyItem: '{0} · 注册于 {1}',
            passkeyLastUsed: '上次使用于 {0}',
            passkeyDeviceName: '设备名称',
            passkeyDeviceNamePlaceholder: 'MacBook Touch ID',
            passkeyDeviceNameRequired: '请输入这个通行密钥的设备名称。',
            renamePasskey: '重命名通行密钥',
            passkeyRenamed: '通行密钥已重命名。',
            passkeyRenameFailed: '重命名通行密钥失败。',
            removePasskey: '移除通行密钥',
            passkeyRemoveConfirm: '要移除此通行密钥设备吗？',
            passkeyRemoved: '通行密钥已移除。',
            passkeyRemoveFailed: '移除通行密钥失败。',
            registerNewPasskey: '注册新的通行密钥',
            registerPasskey: '注册通行密钥',
            registeringPasskey: '正在注册通行密钥……',
            passkeyRegistered: '通行密钥注册成功！',
            passkeyRegisterFailed: '通行密钥注册失败。',
            mustSignInForPasskey: '你需要登录后才能注册通行密钥。',
            passwordUpdateFailed: '密码更新失败。',
            loadProfileFailed: '无法加载用户资料。',
            microsoftIntegration: 'Microsoft 365 集成',
            microsoftIntegrationDescription: '关联你的 Microsoft 账户以使用邮件功能。',
            microsoftConnectedAccount: '已关联账户：{0}',
            linkMicrosoft: '关联 Microsoft 账户',
            disconnectMicrosoft: '解除 Microsoft 关联',
            microsoftDisconnected: '已解除 Microsoft 账户关联。',
            microsoftAuthFailed: '无法启动 Microsoft 授权。',
            microsoftDisconnectFailed: '解除 Microsoft 账户关联失败。',
            themeSettings: '主题设置',
            followSystemThemeDescription: '根据系统偏好自动在浅色与深色主题之间切换。',
            backgroundImage: '背景图片',
            backgroundImageDescription: '显示装饰性背景图片。',
            theme: '主题',
            socialAccountPlaceholder: '社交账号链接',
            cropAvatar: '裁剪头像',
            cropHint: '拖动以移动，使用角点调整大小',
            cropConfirm: '确认'
        }
    } as Record<string, Record<SettingsModuleKeys, string>>,
    credential: {
        'en-US': {
            credentialNotProvided: 'No credential ID provided.',
            editThisCredential: 'Edit this credential',
            createCredential: 'Create credential',
            deleteThisCredential: 'Delete this credential',
            deleteCredentialConfirm: 'Are you sure you want to delete this credential?',
            encryptionKey: 'Encryption key',
            decrypt: 'Decrypt',
            credentialDecrypted: 'Credential',
            nameOfCredential: 'Name of the credential',
            accountOfCredential: 'Account of the credential',
            descriptionOfCredential: 'Description of the credential',
            credentialKey: 'Credential Key',
            selectCredentialToPreview: 'Select a credential to preview',
            credentialsCount: 'credentials',
            newCredential: 'New',
            searchCredentialsPlaceholder: 'Search credentials…',
            clearCredentialSearch: 'Clear credential search',
            sortBy: 'Sort',
            groupBy: 'Group by',
            groupByName: 'Name',
            groupByAccount: 'Account',
            groupByDescription: 'Description',
            noCredentialsFound: 'No credentials found',
            failedToLoadCredentials: 'Failed to load credentials',
            failedToLoadCredential: 'Failed to load credential',
            failedToSaveCredential: 'Failed to save credential',
            key: 'Key',
            encryptKey: 'Encrypt Key',
            account: 'Account',
            credentialNotFound: 'This credential no longer exists.',
            failedToDeleteCredential: 'Failed to delete credential',
            failedToDecryptCredential: 'Failed to decrypt credential',
            protectedFields: 'Protected items',
            protectedFieldsHelp: 'Each item pairs one protected value or TOTP with a title and optional description.',
            addField: 'Add item',
            defaultFieldTitle: 'Password',
            protectedFieldNumber: 'Protected item {0}',
            fieldTitle: 'Title',
            fieldTitlePlaceholder: 'Password, recovery key…',
            fieldDescription: 'Description (optional)',
            fieldDescriptionPlaceholder: 'Account, environment, or usage notes',
            fieldValue: 'Protected value',
            fieldValuePlaceholder: 'Enter the protected value',
            atLeastOneFieldRequired: 'Add at least one protected item, and give every item a title and value.',
            encryptionKeyRequired: 'An encryption key is required to protect credential fields.',
            unlockExistingFields: 'Unlock fields',
            unlockExistingFieldsHelp: 'Enter the original encryption key to view or change the existing protected fields.',
            copyValue: 'Copy',
            fieldType: 'Field type',
            fieldTypeSecret: 'Protected information',
            fieldTypeTotp: 'Time-based one-time password',
            totpSecretPlaceholder: 'Base32 secret or otpauth:// URI',
            totpRemaining: '{0}s remaining',
            untitledField: 'Untitled protected item'
        },
        'zh-CN': {
            credentialNotProvided: '未提供凭据 ID',
            editThisCredential: '编辑此凭据',
            createCredential: '创建凭据',
            deleteThisCredential: '删除此凭据',
            deleteCredentialConfirm: '你确定要删除此凭据吗？',
            encryptionKey: '加密密钥',
            decrypt: '解密',
            credentialDecrypted: '凭据',
            nameOfCredential: '凭据名称',
            accountOfCredential: '凭据账户',
            descriptionOfCredential: '凭据描述',
            credentialKey: '凭据密钥',
            selectCredentialToPreview: '选择一个凭据进行预览',
            credentialsCount: '个凭据',
            newCredential: '新建',
            searchCredentialsPlaceholder: '搜索凭据…',
            clearCredentialSearch: '清除凭据搜索',
            sortBy: '排序',
            groupBy: '分组',
            groupByName: '名称',
            groupByAccount: '账户',
            groupByDescription: '描述',
            noCredentialsFound: '未找到凭据',
            failedToLoadCredentials: '加载凭据列表失败',
            failedToLoadCredential: '加载凭据失败',
            failedToSaveCredential: '保存凭据失败',
            key: '密钥',
            encryptKey: '加密密钥',
            account: '账户',
            credentialNotFound: '此凭据已不存在。',
            failedToDeleteCredential: '删除凭据失败',
            failedToDecryptCredential: '解密凭据失败',
            protectedFields: '受保护项目',
            protectedFieldsHelp: '每个项目将一个受保护值或 TOTP 与标题及可选描述配对。',
            addField: '添加项目',
            defaultFieldTitle: '密码',
            protectedFieldNumber: '受保护项目 {0}',
            fieldTitle: '标题',
            fieldTitlePlaceholder: '密码、恢复密钥…',
            fieldDescription: '描述（可选）',
            fieldDescriptionPlaceholder: '账户、环境或用途说明',
            fieldValue: '受保护值',
            fieldValuePlaceholder: '输入受保护的值',
            atLeastOneFieldRequired: '请至少添加一个受保护项目，并为每个项目填写标题和受保护值。',
            encryptionKeyRequired: '必须提供加密密钥以保护凭据字段。',
            unlockExistingFields: '解锁字段',
            unlockExistingFieldsHelp: '输入原加密密钥以查看或修改现有受保护字段。',
            copyValue: '复制',
            fieldType: '字段类型',
            fieldTypeSecret: '受保护信息',
            fieldTypeTotp: '基于时间的一次性密码',
            totpSecretPlaceholder: 'Base32 密钥或 otpauth:// URI',
            totpRemaining: '剩余 {0} 秒',
            untitledField: '未命名受保护项目'
        }
    } as Record<string, Record<CredentialModuleKeys, string>>,
    post: {
        'en-US': {
            postRecord: 'Post Record',
            postRecords: 'Post Records',
            createPostRecord: 'Create Post Record',
            editPostRecord: 'Edit postal record',
            deletePostRecord: 'Delete Post Record',
            postRecordDetail: 'Post Record Detail',
            sender: 'Sender',
            recipient: 'Recipient',
            sentAt: 'Sent at',
            receivedAt: 'Received at',
            weight: 'Weight',
            price: 'Price',
            attachments: 'Attachments',
            scope: 'Scope',
            type: 'Type',
            deliverMethod: 'Deliver method',
            address: 'Address',
            line1: 'Line 1',
            line2: 'Line 2',
            district: 'District',
            city: 'City',
            region: 'Region',
            country: 'Country',
            postalCode: 'Postal code',
            linkedAttachments: 'Linked attachments',
            pickFile: 'Pick file',
            noAttachments: 'No attachments',
            clear: 'Clear',
            pick: 'Pick',
            saveChanges: 'Save changes',
            createRecord: 'Create record',
            refresh: 'Refresh',
            newRecord: 'New Record',
            failedToLoadPostRecords: 'Failed to load post records',
            failedToLoadPostRecord: 'Failed to load post record',
            failedToCreatePostRecord: 'Failed to create post record',
            failedToUpdatePostRecord: 'Failed to update post record',
            failedToDeletePostRecord: 'Failed to delete post record',
            postRecordSaved: 'Post record saved',
            postRecordDeleted: 'Post record deleted',
            copyLink: 'Copy Link',
            share: 'Share',
            senderAddress: 'Sender Address',
            recipientAddress: 'Recipient Address',
            itemDescription: 'Item description',
            weightGrams: 'Weight (g)',
            priceCny: 'Price (CNY)',
            selectUser: 'Select User',
            selectFile: 'Select File',
            noFilesFound: 'No files found',
            searchUsers: 'Search Users',
            searchFiles: 'Search Files',
            managePostalEntries: 'Manage postal entries, link files, and share read-only details with participants.',
            mail: 'Mail',
            participants: 'Participants',
            timeline: 'Timeline',
            metrics: 'Metrics',
            actions: 'Actions',
            sent: 'Sent',
            received: 'Received',
            weightDash: 'Weight —',
            priceDash: 'Price —',
            view: 'View',
            confirmDeletePostRecord: 'Delete this record?',
            newPostRecord: 'New postal record',
            senderAndRecipientRequired: 'Sender and recipient are required.',
            completeSenderAddress: 'Complete the sender address before saving.',
            completeRecipientAddress: 'Complete the recipient address before saving.',
            unableToSaveRecord: 'Unable to save record',
            unableToDeleteRecord: 'Unable to delete record',
            failedToLoadUsers: 'Failed to load users',
            failedToLoadAttachments: 'Failed to load attachments',
            pickSender: 'Pick a sender',
            pickRecipient: 'Pick a recipient',
            mailScope: 'Mail scope',
            mailType: 'Mail type',
            regionProvince: 'Region / Province',
            noAttachmentsLinked: 'No attachments linked.',
            loadingRecords: 'Loading records…',
            noRecordsCapturedYet: 'No records captured yet.',
            mainland: 'Mainland China',
            sar: 'Hong Kong, Macau, Taiwan',
            international: 'International',
            mainlandLetter: 'Mainland Letter',
            mainlandRegisteredLetter: 'Mainland Registered Letter',
            mainlandPostcard: 'Mainland Postcard',
            mainlandPrintedMatter: 'Mainland Printed Matter',
            mainlandRegisteredPrintedMatter: 'Mainland Registered Printed Matter',
            mainlandOrdinaryParcel: 'Mainland Ordinary Parcel',
            mainlandExpressParcel: 'Mainland Express Parcel',
            mainlandStandardExpress: 'Mainland Standard Express',
            mainlandSameDaySpecial: 'Mainland Same Day Special',
            mainlandEms: 'Mainland EMS',
            sarLetter: 'SAR Letter',
            sarRegisteredLetter: 'SAR Registered Letter',
            sarPostcard: 'SAR Postcard',
            sarPrintedMatter: 'SAR Printed Matter',
            sarSmallPacket: 'SAR Small Packet',
            sarParcel: 'SAR Parcel',
            sarEms: 'SAR EMS',
            sarDocumentExpress: 'SAR Document Express',
            internationalLetter: 'International Letter',
            internationalRegisteredLetter: 'International Registered Letter',
            internationalPostcard: 'International Postcard',
            internationalPrintedMatter: 'International Printed Matter',
            internationalRegisteredPrintedMatter: 'International Registered Printed Matter',
            internationalSmallPacket: 'International Small Packet',
            internationalParcel: 'International Parcel',
            internationalEms: 'International EMS',
            airMail: 'Air Mail',
            surfaceMail: 'Surface Mail'
        },
        'zh-CN': {
            postRecord: '邮政记录',
            postRecords: '邮政记录',
            createPostRecord: '创建邮政记录',
            editPostRecord: '编辑邮政记录',
            deletePostRecord: '删除邮政记录',
            postRecordDetail: '邮政记录详情',
            sender: '发件人',
            recipient: '收件人',
            sentAt: '发送时间',
            receivedAt: '接收时间',
            weight: '重量',
            price: '价格',
            attachments: '附件',
            scope: '范围',
            type: '类型',
            deliverMethod: '递送方式',
            address: '地址',
            line1: '第1行',
            line2: '第2行',
            district: '区',
            city: '市',
            region: '地区',
            country: '国家',
            postalCode: '邮政编码',
            linkedAttachments: '链接的附件',
            pickFile: '选择文件',
            noAttachments: '无附件',
            clear: '清除',
            pick: '选择',
            saveChanges: '保存更改',
            createRecord: '创建记录',
            refresh: '刷新',
            newRecord: '新记录',
            failedToLoadPostRecords: '加载邮政记录失败',
            failedToLoadPostRecord: '加载邮政记录失败',
            failedToCreatePostRecord: '创建邮政记录失败',
            failedToUpdatePostRecord: '更新邮政记录失败',
            failedToDeletePostRecord: '删除邮政记录失败',
            postRecordSaved: '邮政记录已保存',
            postRecordDeleted: '邮政记录已删除',
            copyLink: '复制链接',
            share: '分享',
            senderAddress: '发件人地址',
            recipientAddress: '收件人地址',
            itemDescription: '物品描述',
            weightGrams: '重量 (克)',
            priceCny: '价格 (CNY)',
            selectUser: '选择用户',
            selectFile: '选择文件',
            noFilesFound: '未找到文件',
            searchUsers: '搜索用户',
            searchFiles: '搜索文件',
            managePostalEntries: '管理邮政条目，链接文件，并与参与者分享只读详情。',
            mail: '邮件',
            participants: '参与者',
            timeline: '时间线',
            metrics: '指标',
            actions: '操作',
            sent: '发送',
            received: '接收',
            weightDash: '重量 —',
            priceDash: '价格 —',
            view: '查看',
            confirmDeletePostRecord: '确定要删除此记录吗？',
            newPostRecord: '新建邮政记录',
            senderAndRecipientRequired: '发件人和收件人是必需的',
            completeSenderAddress: '请先完成发件人地址',
            completeRecipientAddress: '请先完成收件人地址',
            unableToSaveRecord: '无法保存记录',
            unableToDeleteRecord: '无法删除记录',
            failedToLoadUsers: '加载用户失败',
            failedToLoadAttachments: '加载附件失败',
            pickSender: '选择发件人',
            pickRecipient: '选择收件人',
            mailScope: '邮件范围',
            mailType: '邮件类型',
            regionProvince: '地区/省',
            noAttachmentsLinked: '未链接附件',
            loadingRecords: '加载记录中…',
            noRecordsCapturedYet: '尚未捕获任何记录。',
            mainland: '中国大陆',
            sar: '港澳台地区',
            international: '国际',
            mainlandLetter: '平信',
            mainlandRegisteredLetter: '挂号信',
            mainlandPostcard: '明信片',
            mainlandPrintedMatter: '印刷品',
            mainlandRegisteredPrintedMatter: '挂号印刷品',
            mainlandOrdinaryParcel: '普通包裹',
            mainlandExpressParcel: '快递包裹',
            mainlandStandardExpress: '标准快递',
            mainlandSameDaySpecial: '即日专递',
            mainlandEms: '国内特快专递 (EMS)',
            sarLetter: '港澳台平信',
            sarRegisteredLetter: '港澳台挂号信',
            sarPostcard: '港澳台明信片',
            sarPrintedMatter: '港澳台印刷品',
            sarSmallPacket: '港澳台小包',
            sarParcel: '港澳台包裹',
            sarEms: '港澳台特快专递 (EMS)',
            sarDocumentExpress: '港澳台文件专递',
            internationalLetter: '国际平信',
            internationalRegisteredLetter: '国际挂号信',
            internationalPostcard: '国际明信片',
            internationalPrintedMatter: '国际印刷品',
            internationalRegisteredPrintedMatter: '国际挂号印刷品',
            internationalSmallPacket: '国际小包',
            internationalParcel: '国际包裹',
            internationalEms: '国际标准快递 (EMS)',
            airMail: '航空',
            surfaceMail: '水陆路'
        }
    } as Record<string, Record<PostModuleKeys, string>>,
    remark: {
        'en-US': {
            remarks: 'Remarks',
            remarkTableDescription: 'Manage quick remarks used across the app.',
            remarkReload: 'Reload',
            remarkFetchSuccess: 'Remarks loaded',
            remarkFetchError: 'Failed to load remarks',
            remarkSaveSuccess: 'Remark saved',
            remarkSaveError: 'Failed to save remark',
            remarkDeleteSuccess: 'Remark deleted',
            remarkDeleteError: 'Failed to delete remark'
        },
        'zh-CN': {
            remarks: '备注',
            remarkTableDescription: '管理应用中使用的快速备注。',
            remarkReload: '重新加载',
            remarkFetchSuccess: '备注已加载',
            remarkFetchError: '加载备注失败',
            remarkSaveSuccess: '备注已保存',
            remarkSaveError: '保存备注失败',
            remarkDeleteSuccess: '备注已删除',
            remarkDeleteError: '删除备注失败'
        },
        'zh-TW': {
            remarks: '備註',
            remarkTableDescription: '管理應用中使用的快速備註。',
            remarkReload: '重新整理',
            remarkFetchSuccess: '備註已載入',
            remarkFetchError: '載入備註失敗',
            remarkSaveSuccess: '備註已儲存',
            remarkSaveError: '儲存備註失敗',
            remarkDeleteSuccess: '備註已刪除',
            remarkDeleteError: '刪除備註失敗'
        },
        'fr': {
            remarks: 'Remarques',
            remarkTableDescription: 'Gérer les remarques rapides utilisées dans l\'application.',
            remarkReload: 'Recharger',
            remarkFetchSuccess: 'Remarques chargées',
            remarkFetchError: 'Échec du chargement des remarques',
            remarkSaveSuccess: 'Remarque enregistrée',
            remarkSaveError: 'Échec de l\'enregistrement de la remarque',
            remarkDeleteSuccess: 'Remarque supprimée',
            remarkDeleteError: 'Échec de la suppression de la remarque'
        },
        'ja': {
            remarks: '備考',
            remarkTableDescription: 'アプリで使用されるクイック備考を管理します。',
            remarkReload: '再読み込み',
            remarkFetchSuccess: '備考を読み込みました',
            remarkFetchError: '備考の読み込みに失敗しました',
            remarkSaveSuccess: '備考を保存しました',
            remarkSaveError: '備考の保存に失敗しました',
            remarkDeleteSuccess: '備考を削除しました',
            remarkDeleteError: '備考の削除に失敗しました'
        }
    } as Record<string, Record<RemarkModuleKeys, string>>
};

